var Alerts = (function (my) {
    return my;
}(Alerts || {}));

(function ($) {
    var prevAlertCount = null;
    var customRedirectionHandler = null;

    Alerts.init = function (config) {
        Alerts.config = config;

        $(function () {
            requestAlerts();
            if (WritableBridges.enabled) {
                WritableBridges.setOnAlertClickedHandler(onBridgesAlertClicked);
                WritableBridges.setOnAlertsReadHandler(onAlertsRead);
            } else {
                $(document.body).on('click', '.writable-alert[data-alert-id]', onWritableAlertClicked);
                if (Writable && Writable.settings && !!Writable.settings.alertRefreshIntervalMs) {
                    setInterval(requestAlerts, Writable.settings.alertRefreshIntervalMs);
                }
            }
        });

        var saved = getSessionString('alertContent');
        if (saved) {
            updateAlerts(saved);
        }
    };

    Alerts.setCustomRedirectionHandler = function (handler) {
        customRedirectionHandler = handler;
    };

    function onBridgesAlertClicked(alertEvent) {
        if (Writable.currentUserType === 'Teacher') {
            Writable.openBridgesDashboard(alertEvent.path);
        } else {
            var chatContextParameters = {
                chatId: alertEvent.chatId,
                contextId: alertEvent.contextId,
                userId: alertEvent.userId,
                originUserId: alertEvent.originUserId,
                customThreadId: alertEvent.customThreadId || undefined,
            };
            if (customRedirectionHandler) {
                var url = setUrlParameters(Alerts.config.landingGetChatContextDestinationUrl, chatContextParameters);
                var jqXHR = $.get(url)
                    .then(function (destination) {
                        try {
                            var destinationUrl = new URL(destination, location);
                            if (destinationUrl.hostname !== window.location.hostname || destinationUrl.pathname !== window.location.pathname || !customRedirectionHandler(destinationUrl)) {
                                window.location.href = destinationUrl;
                            }
                        } catch (err) {
                            console.log('Error in custom redirection handler:', err);
                            window.location.href = destinationUrl;
                        }
                    });
                return Promise.resolve(jqXHR);
            } else {
                window.location.href = setUrlParameters(Alerts.config.landingChatContextUrl, chatContextParameters);
            }
        }
        return Promise.resolve();
    };

    function onAlertsRead(alertEvents) {
        alertEvents.forEach(function (alertEvent) {
            $(alertEvent.element).find('.writable-alert-time').timeago();
        });
    };

    function onWritableAlertClicked(e) {
        var $alert = $(e.target).closest('.writable-alert[data-alert-id]');
        launchWritableAlert($alert);
    };

    function requestAlerts() {
        $.get(Alerts.config.alertMenuUrl)
            .done(function (content) {
                updateAlerts(content);
                setSessionString('alertContent', content);
            });
    }

    function updateAlerts(content) {
        if (WritableBridges.enabled) {
            var $menu = $(content);
            var $menuItems = $menu.find('> li');
            var alerts = $menuItems.get().map(function (item) {
                var $alert = $(item).find('.writable-alert');
                return {
                    id: $alert.attr('data-alert-id'),
                    time: $alert.attr('data-alert-time'),
                    element: $alert.get(0),
                    onClick: function (alertEvent) {
                        return Promise.resolve(launchWritableAlert($alert));
                    },
                    onDismiss: function (alertEvent) {
                        return Promise.resolve($.post(setUrlParameter(Alerts.config.alertMarkAsReadUrl, 'alertId', $alert.attr('data-alert-id'))));
                    }
                };
            });
            WritableBridges.setAlerts(alerts);
        } else {
            var element = $("#alerts");
            var menu = element.find('.dropdown-menu');
            menu.html(content);
            var count = menu.find('ul').children().length;
            element.toggleClass('active', count > 0);
            element.find('.badge').text(count);

            if (prevAlertCount !== null && count > prevAlertCount && typeof (Audio) !== 'undefined') {
                new Audio(Alerts.config.alertReceivedAudioUrl).play();
            }

            prevAlertCount = count;
        }
    };

    function launchWritableAlert($alert) {
        var deferred = $.Deferred();
        var launchUrl = setUrlParameter(Alerts.config.alertLaunchUrl, 'alertId', $alert.attr('data-alert-id'));

        if (!WritableBridges.enabled) {
            var $badge = $('#alerts > a.dropdown-toggle > .badge');
            var count = +($badge.text());
            if (count <= 1) {
                $badge.remove();
            } else {
                $badge.text((--count).toString());
            }
            $alert.closest('li').remove();
        }

        if ($alert.attr('data-alert-type') === 'DraftFeedback') {
            $.get(launchUrl)
                .then(function (data) {
                    if (typeof WritingIndex !== 'undefined') {
                        WritingIndex.onLaunchedDraftFeedbackAlert(data);
                    }
                    else {
                        window.location.href = data.url;
                    }
                })
                .always(function () {
                    deferred.resolve();
                });
        }
        else if ($alert.attr('data-no-redirect') === 'true') {
            $.post(setUrlParameter(Alerts.config.alertMarkAsReadUrl, 'alertId', $alert.attr('data-alert-id')))
                .always(function () {
                    deferred.resolve();
                });
        }
        else {
            deferred.resolve();
            window.location.href = launchUrl;
        }

        return deferred.promise();
    };
})(jQuery);

var BreadCrumbHelper = (function (my) {
    return my;
}(BreadCrumbHelper || window.BreadCrumbHelper || {}));

(function ($) {
    BreadCrumbHelper.isInitialized = false;
    BreadCrumbHelper.init = function () {
        var $bar = $('#breadcrumb-bar');
        BreadCrumbHelper.isInitialized = true;
        if (!$bar.length) {
            return;
        }

        BreadCrumbHelper.$bar = $bar;

    };

    BreadCrumbHelper.addCrumb = function (crumbValue, originalText) {
        if (!BreadCrumbHelper.isInitialized) {
            return;
        }
        if (!BreadCrumbHelper.$bar) {
            var subhead = $('.subhead');
            if (!subhead.length) {
                console.log('Could not locate subhead to add crumb');
                return;
            }
            var firstEntry = '';
            if (originalText) {
                firstEntry = '<li class="breadcrumb-item active">' + originalText + '</li>\n';
            }
            subhead.append('<div id="breadcrumb-bar" role="navigation" aria-label="Breadcrumbs">\n' +
                '<ol class="breadcrumb">\n' + firstEntry +
                '</ol>\n' +
                '</div>\n' +
                '<div class="breadcrumb-bar-separator"></div>');
            var $bar = subhead.find('#breadcrumb-bar');
            if ($bar.length) {
                BreadCrumbHelper.$bar = $bar;
            }
        }

        var $bar = BreadCrumbHelper.$bar;
        var activeItem = $bar.find('.breadcrumb-item.active');
        if (activeItem.text() === crumbValue.newText) {
            // Don't duplicate
            return;
        }
        activeItem.removeClass('active');
        activeItem.html('<a class="confirm-navigate" href="' + crumbValue.oldUri + '">' + activeItem.text() + '</a>');

        $bar.find('.breadcrumb').append('<li class="breadcrumb-item active">' + crumbValue.newText + '</li>');
    };

    BreadCrumbHelper.removeCrumb = function () {
        if (!BreadCrumbHelper.isInitialized) {
            return;
        }
        if (!BreadCrumbHelper.$bar) {
            return;
        }

        BreadCrumbHelper.$bar.find('li.active').remove();
        var items = BreadCrumbHelper.$bar.find('.breadcrumb-item');

        if (items.length <= 1) {
            var $subhead = $('.subhead');
            $subhead.find('#breadcrumb-bar').remove();
            $subhead.find('.breadcrumb-bar-separator').remove();
            BreadCrumbHelper.$bar = null;
        } else {
            var last = items.last();
            var link = last.find('a');
            last.html(link.text());
            last.addClass('active');
        }
    }
})(jQuery);
var WritableBridges = (function (my) {
    return my;
}(WritableBridges || window.WritableBridges || {}));

(function ($) {
    var bridges = null;
    WritableBridges.enabled = false;
    WritableBridges.rosterResynced = false;

    WritableBridges.prefix = {
        EX: 'EX-',
        TY: 'TY-',
        BR: 'BR-'
    }

    WritableBridges.chatType = {
        Public: `${WritableBridges.prefix.TY}public`,
        Private: `${WritableBridges.prefix.TY}private`,
    }

    WritableBridges.threadType = {
        General: `${WritableBridges.prefix.TY}general`,
    }

    /*
     * init
     *
     * Initialize the WritableBridges library.
     */
    WritableBridges.init = function (config) {
        WritableBridges.config = config;
        var user = Writable.currentUser;
        if (user) {
            bridges = new Bridges({
                appId: config.appId,
                issuer: config.issuer,
                clientId: config.clientId,
                deploymentId: config.deploymentId,
                includeThreadWidget: true,
                onResyncRoster: WritableBridges.onResyncRoster
            }, {
                id: user.id,
                type: user.type === 'Teacher' ? 'T' : 'S',
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email
            }, {
                jwtUrl: Writable.generateBridgesJWTUrl
            });
            bridges.onLoad(function (event) {
                console.log(event);
            });
            WritableBridges.enabled = true;
        }
    };

    /*
     * logout
     *
     * Log out of Bridges.
     * Returns: JQuery promise.
     */
    WritableBridges.logout = function () {
        var deferred = $.Deferred();
        var timeoutId = setTimeout(function () {
            bridges = null;
            WritableBridges.enabled = false;
            deferred.reject();
        }, 500);
        bridges.logout()
            .finally(function () {
                clearTimeout(timeoutId);
                bridges = null;
                WritableBridges.enabled = false;
                deferred.resolve();
            });
        return deferred.promise();
    };

    /*
     * getContext
     *
     * Get the context for the given context id.
     * Returns: JQuery promise.
     */
    WritableBridges.getContext = function (contextId) {
        var deferred = $.Deferred();
        bridges.v1.contexts(contextId).get()
            .then(function (context) {
                deferred.resolve(context);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * updateContext
     *
     * Update the context for the given context id.
     * Returns: JQuery promise.
     */
    WritableBridges.updateContext = function (prefixedContextId, updates) {
        var deferred = $.Deferred();
        bridges.v1.contexts(prefixedContextId).update(updates)
            .then(function (context) {
                deferred.resolve(context);
            })
            .catch(function (error) {
                if (error.code === "group_not_found") {
                    WritableBridges.forceBridgesGroupSync(prefixedContextId.slice(3))
                        .then(function () {
                            return bridges.v1.contexts(prefixedContextId).update(updates);
                        })
                        .then(function (context) {
                            deferred.resolve(context);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                }
                else {
                    deferred.reject(error);
                }
            });
        return deferred.promise();
    };

    /*
     * createContext
     *
     * This will attempt to get the context, and if it doesn't exist, it will create it.
     * If the group doesn't exist, it will try to create it and then retry this whole function.
     * If forceBridgesGroupSync is called and it still fails due to no group found, it will reject.
     * If the isRetry is not properly filled out in the then block of forceBridgesGroupSync,
     * it will cause an infinite loop.
     *
     * I don't love how this function looks.
     *
     * Create a new context.
     * Returns: JQuery promise.
     */
    WritableBridges.getOrCreateContext = function (context, isRetry = false) {
        var deferred = $.Deferred();
        WritableBridges.getAndUpdateContext(context.id, context.groupId)
            .then(function (existingContext) {
                deferred.resolve(existingContext);
            })
            .catch(function (error) {
                if (error.code === "context_not_found") {
                    bridges.v1.contexts.create(context)
                        .then(function (newContext) {
                            //If we just created the context and it doesn't have a groupId, then it's a dynamic group and we should perform the sync here. If the context already exists, it means the scheduler picked up a dynamic group sync and we don't need to do anything.
                            if (!newContext.groupId) {
                                WritableBridges.forceBridgesGroupSync(context.id.slice(3))
                                    .then(function () {
                                        deferred.resolve(newContext);
                                    })
                                    .catch(function (error) {
                                        deferred.reject(error);
                                    });
                            }
                            else
                                deferred.resolve(newContext);
                        })
                        .catch(function (error) {
                            if (!isRetry && error.code === "group_not_found") {
                                WritableBridges.forceBridgesGroupSync(context.id.slice(3))
                                    .then(function () {
                                        return WritableBridges.getOrCreateContext(context, true);
                                    })
                                    .then(function (newContext) {
                                        deferred.resolve(newContext);
                                    })
                                    .catch(function (error) {
                                        deferred.reject(error);
                                    });
                            }
                            else { // isRetry || error.code !== "group_not_found"
                                deferred.reject(error);
                            }
                        });
                }
                else { // error.code !== "context_not_found"
                    deferred.reject(error);
                }
            });
        return deferred.promise();
    };

    WritableBridges.getAndUpdateContext = function (prefixedContextId, prefixedGroupId) {
        var deferred = $.Deferred();
        WritableBridges.getContext(prefixedContextId)
            .then(function (existingContext) {
                // currently this only sets the groupId, in the future this can be removed
                // since all contexts will be created with a groupId, this is only here
                // until old contexts get caught up, same with deleteContextUsers
                // If the context param has no groupId, then the
                // context is a dynamic group and will use context users.
                if (!existingContext.groupId && prefixedGroupId) {
                    WritableBridges.updateContext(prefixedContextId, { groupId: prefixedGroupId })
                        .then(function (updatedContext) {
                            deferred.resolve(updatedContext);

                            // We need to delete the context users since we are now using a group for rostering.
                            WritableBridges.deleteContextUsers(prefixedContextId);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                }
                else { // existingContext.groupId
                    deferred.resolve(existingContext);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * getChat
     *
     * Get the chat for the given context id.
     * Returns: JQuery promise.
     */
    WritableBridges.getChat = function (prefixedContextId) {
        return bridges.v1.contexts(prefixedContextId).chats('TY-private').get();
    };

    /*
     * hasChat
     * 
     * Does a chat with the given context id exist.
     * Returns: JQuery promise.
     */
    WritableBridges.hasChat = function (contextId) {
        var deferred = $.Deferred();
        WritableBridges.getChat(`${WritableBridges.prefix.EX}${contextId}`)
            .then(function (response) {
                deferred.resolve(!!response);
            })
            .catch(function (error) {
                if (error.code === "chat_not_found") {
                    deferred.resolve(false);
                }
                else {
                    deferred.reject(error);
                }
            });
        return deferred.promise();
    };

    /*
     * startChat
     *
     * Start a chat using the context and chat configs
     * Returns: JQuery promise.
     */
    WritableBridges.startChat = function (context, chat) {
        var deferred = $.Deferred();
        WritableBridges.getOrCreateContext(context)
            .then(function (bridgesContext) {
                return WritableBridges.createChat(`${WritableBridges.prefix.EX}${bridgesContext.id.ex}`, chat);
            })
            .then(function (chat) {
                deferred.resolve(chat);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    }

    /*
     * createChat
     * 
     * If a chat doesn't exist, this will create a new chat.
     * Returns: JQuery promise.
     */
    WritableBridges.createChat = function (prefixedContextId, chat) {
        return bridges.v1.contexts(prefixedContextId).chats.create(chat);
    };

    /*
     * updateChat
     *
     * Update the chat for the given context id.
     * Returns: JQuery promise.
     */
    WritableBridges.updateChat = function (prefixedContextId, chat) {
        return bridges.v1.contexts(prefixedContextId).chats('TY-private').update(chat);
    };

    /*
     * sendMessage
     * 
     * Send a message.
     * Returns: JQuery promise.
     */
    WritableBridges.sendMessage = function (prefixedContextId, prefixedChatId, prefixedThreadId, message) {
        var deferred = $.Deferred();
        bridges.v1.contexts(prefixedContextId).chats(prefixedChatId).threads(prefixedThreadId).messages.send(message)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * setAlerts
     * 
     * Set the current writable alerts.
     * Returns: JQuery promise.
     */
    WritableBridges.setAlerts = function (alerts) {
        var deferred = $.Deferred();
        var isBridgesAlerts = false;
        var nonAlert = false;
        bridges.v1.widgets.alertCenter.setAlerts(alerts, isBridgesAlerts, nonAlert)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * setNotificationCenterElements
     * 
     * Set the fixed notification center elements.
     * Returns: JQuery promise.
     */
    WritableBridges.setNotificationCenterElements = function (elements) {
        var deferred = $.Deferred();
        var isBridgesAlerts = false;
        var nonAlert = true;
        bridges.v1.widgets.alertCenter.setAlerts(elements, isBridgesAlerts, nonAlert)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };
    
    /*
     * createThread
     * 
     * Create a new bridges thread.
     * Returns: JQuery promise.
     */
    WritableBridges.createThread = function (prefixedContextId, prefixedChatId, thread) {
        var deferred = $.Deferred();
        bridges.v1.contexts(prefixedContextId).chats(prefixedChatId).threads.create(thread)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * createOrUpdateSubGroups
     *
     * Creates or updates the subgroups attached to a given context.
     * Returns: JQuery promise.
     */
    WritableBridges.createOrUpdateSubGroups = function (context) {
        var deferred = $.Deferred();
        bridges.v1.contexts(context.id).chats('TY-private').subgroups.sync(context.subgroups)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * buildChatContextForAssignment
     * 
     * Builds a chat context for an assignment after retrieving goal details and full class roster.
     * Returns: JQuery promise.
     */
    WritableBridges.buildChatContextForAssignment = function (assignmentId, context) {
        let prefix = assignmentId.substring(0, assignmentId.indexOf('-'));
        let finalAssignmentId = assignmentId;
        if(prefix == 'EX') finalAssignmentId = assignmentId.substring(assignmentId.indexOf('-') + 1);
        return $.post(setUrlParameter(WritableBridges.config.assignmentCreateBridgesDataUrl, 'assignmentId', finalAssignmentId))
            .then(function (data) {
                var outContext = $.extend({
                    id: `${WritableBridges.prefix.EX}${finalAssignmentId}`,
                    title: data.goalTitle,
                    label: data.groupTitle,
                    parent: {
                        id: `${WritableBridges.prefix.EX}${data.goalId}`,
                        title: data.goalTitle
                    },
                    links: [
                        {
                            resourceLinkId: data.resourceLinkId,
                            title: data.goalTitle,
                            url: WritableBridges.config.assignmentDeepLinkUrl,
                            custom: JSON.stringify({ goalId: data.goalId }),
                            type: 'ltiResourceLink',
                        },
                    ],
                }, context);

                if (!data.isDynamicGroup)
                    outContext.groupId = `${WritableBridges.prefix.EX}${data.groupId}`;

                return outContext;
            });
    };

    WritableBridges.forceBridgesGroupSync = function (assignmentId) {
        return $.post(setUrlParameter(WritableBridges.config.forceBridgesGroupSyncUrl, 'assignmentId', assignmentId));
    };


    /*
     * startAssignmentChat
     *
     * Builds an assignment chat context and starts the chat.
     * assignmentId - May be prefixed with EX- or not.
     * Returns: JQuery promise.
     */
    WritableBridges.startAssignmentChat = function (assignmentId, context, chat) {
        return WritableBridges.buildChatContextForAssignment(assignmentId, context)
            .then(function (context) {
                chat = $.extend({
                    title: context.title,
                    subtitle: context.label,
                    type: 'Private',
                    hideGeneralThread: true,
                }, chat);
                return WritableBridges.startChat(context, chat);
            });
    };

    /*
     * setOnChatWidgetAddedHandler
     *
     * Set the handler to be called when a chat widget is added to the dom
     */
    WritableBridges.setOnChatWidgetAddedHandler = function (handler) {
        bridges.onChatWidgetAdded = handler;
    };

    /*
     * setOnCreateChatHandler
     *
     * Set the handler to be called when a chat needs to be created for a widget
     */
    WritableBridges.setOnCreateChatHandler = function (handler) {
        bridges.onCreateChat = handler;
    };

    /*
     * setOnBroadcastsWidgetAddedHandler
     *
     * Set the handler to be called when a broadcast widget is added to the dom
     */
    WritableBridges.setOnBroadcastsWidgetAddedHandler = function (handler) {
        bridges.onBroadcastsWidgetAdded = handler;
    };

    /*
     * setOnAlertClickedHandler
     *
     * Set the handler to be called when an alert is clicked
     */
    WritableBridges.setOnAlertClickedHandler = function (handler) {
        bridges.onAlertClicked = handler;
    };

    /*
     * setOnAlertDismissedHandler
     *
     * Set the handler to be called when an alert is dismissed
     */
    WritableBridges.setOnAlertDismissedHandler = function (handler) {
        bridges.onAlertDismissed = handler;
    };

    /*
     * setOnAlertsReadHandler
     *
     * Set the handler to be called when alerts have been read
     */
    WritableBridges.setOnAlertsReadHandler = function (handler) {
        bridges.onAlertsRead = handler;
    };

    /*
     * setOnTipsOpenHandler
     *
     * Set the handler to be called when the user opens the tips menu
     */
    WritableBridges.setOnTipsOpenHandler = function (handler) {
        bridges.onTipsOpen = handler;
    };

    WritableBridges.onResyncRoster = function ({ prefixedContextId }) {
        if (WritableBridges.rosterResynced) return Promise.resolve();

        var deferred = $.Deferred();

        WritableBridges.forceBridgesGroupSync(prefixedContextId.slice(3))
            .always(function () {
                WritableBridges.rosterResynced = true;
                deferred.resolve();
            });

        return deferred.promise();
    };

    /*
     * updateContextInfo
     *
     * Update the context info for the given context.
     * Returns: JQuery promise.
     */
    WritableBridges.updateContextInfo = function (context, isDynamicGroup) {
        var deferred = $.Deferred();

        // currently this only sets the groupId, in the future this can be removed
        // since all contexts will be created with a groupId, this is only here
        // until old contexts get caught up, same with deleteContextUsers
        if (!isDynamicGroup && context.groupId) {
            // we do not send groupId for dynamic groups
            WritableBridges.getContext(context.id)
                .then(function (existingContext) {
                    // We need to update the context with the group ID, since we weren't passing this for a long time.
                    if (!existingContext.groupId) {
                        WritableBridges.updateContext(context.id, { groupId: context.groupId })
                            .then(function () {
                                // We need to delete the context users since we are now using a group for rostering.
                                return WritableBridges.deleteContextUsers(context.id);
                            });
                    } else {
                        deferred.resolve();
                    }
                });
        } else {
            deferred.resolve();
        }

        return deferred.promise();
    };

    /*
     * updateContextAndChatInfo
     *
     * Update the context and chat info for the given context and chat.
     * Returns: JQuery promise.
     */
    WritableBridges.updateContextAndChatInfo = function (context, chat, isDynamicGroup) {
        return WritableBridges.updateContextInfo(context, isDynamicGroup)
            .then(function () {
                return WritableBridges.updateChat(context.id, chat);
            });
    };

    /*
     * deleteContextUsers
     *
     * Delete context-specific users from a context
     * Bridges will assume that the context is using a group for rostering
     * Returns: JQuery promise.
     */
    WritableBridges.deleteContextUsers = function (prefixedContextId) {
        bridges.v1.contexts(prefixedContextId).deleteUsers();
    };

    /*
     * addAssignmentUnreadCountEventListener
     *
     * Get notified when the unread count for an assignment inbox changes
     */
    WritableBridges.addAssignmentUnreadCountEventListener = function (assignmentId, callback) {
        bridges.v1.contexts(`${WritableBridges.prefix.EX}${assignmentId}`, false).addEventListener('UnreadCount', callback);
    };

    /**
     * addGoalUnreadCountEventListener
     * 
     * Get notified when the unread message count for a goal changes
     * @param {*} goalId 
     * @param {*} callback
     */
    WritableBridges.addGoalUnreadCountEventListener = function (goalId, callback) {
        bridges.v1.contexts(`${WritableBridges.prefix.EX}${goalId}`, true).addEventListener('UnreadCount', callback);
    }

    /**
     * addGoalAlertsEventListener
     * 
     * Get notified when the alerts for a goal changes
     * @param {*} goalId
     * @param {*} alertType
     * @param {*} callback
     */
    WritableBridges.addGoalAlertsEventListener = function (goalId, alertType, callback) {
        bridges.v1.user.addEventListener('Alerts', callback, {}, { parentContextId: `${WritableBridges.prefix.EX}${goalId}`, type: alertType });
    }

    /**
     * 
     * @param {*} assignmentId 
     * @param {*} alertType 
     * @param {*} callback 
     */
    WritableBridges.addAssignmentAlertsEventListener = function (assignmentId, alertType, callback) {
        bridges.v1.user.addEventListener('Alerts', callback, {}, { contextId: `${WritableBridges.prefix.EX}${assignmentId}`, type: alertType });
    }

    WritableBridges.markAlertsAsDismissed = function (alertIds) {
        return bridges.v1.user.alerts.dismiss(alertIds.map(alertId => `${WritableBridges.prefix.BR}${alertId}`));
    }
         

    /*
     * getInboxMessagesForAssignment
     *
     * Get the InboxMessages for a given assignment
     * Returns: JQuery promise, that will return an array of Bridges InboxMessages
     */
    WritableBridges.getInboxMessagesForAssignment = function (assignmentId) {
        var deferred = $.Deferred();
        bridges.v1.inbox.messages({
            filters: [{
                type: 'ContextId', value: `${WritableBridges.prefix.EX}${assignmentId}` }] })
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };

    /*
     * getInboxMessagesForGoal
     *
     * Get the InboxMessages for a given goal
     * Returns: JQuery promise, that will return an array of Bridges InboxMessages
     */
    WritableBridges.getInboxMessagesForGoal = function (goalId) {
        var deferred = $.Deferred();
        bridges.v1.inbox.messages({
            filters: [{
                type: 'ParentContextId', value: `${WritableBridges.prefix.EX}${goalId}` }] })
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
        return deferred.promise();
    };
})(jQuery);

var Carousel = (function (my) {
    return my;
}(Carousel || window.Carousel || {}));

// jQuery Carousel
////////////////////
(function ($) {
    Carousel.carousels = [];

    Carousel.attach = function (jQueryCollection, onSlideHandler) {
        onSlideHandler = onSlideHandler || function () { };

        jQueryCollection.each(function (index, element) {
            Carousel.carousels.push({ domElement: element, slideEnabled: true, onSlideHandler: onSlideHandler });

            $('.carousel-control .glyphicon', element).on('click', element, onSlide);

            sliderInit(element);
        });
    };

    Carousel.reattach = function (jQueryCollection, onSlideHandler) {
        if (0 === Carousel.carousels.length) {
            return;
        }
        onSlideHandler = onSlideHandler || function () { };

        jQueryCollection.each(function (index, element) {
            if (Carousel.carousels[index].domElement === element) {
                return;
            }

            Carousel.carousels.splice(index, 0, { domElement: element, slideEnabled: true, onSlideHandler: onSlideHandler });

            $('.carousel-control .glyphicon', element).on('click', element, onSlide);

            sliderInit(element);
        });
    };

    function carouselFromElement(domElement) {
        var result = Carousel.carousels.find(function (e) { return e.domElement === domElement; });
        return result;
    }

    Carousel.clearCarousels = function () {
        Carousel.carousels = [];
    }

    Carousel.getScrollOffset = function (goalSliderElement) {
        var result = $(goalSliderElement).attr('data-shift');
        return result;
    }

    Carousel.setShowItems = function (showItems) {
        for (var i = 0; i < Carousel.carousels.length; i++) {
            var carousel = Carousel.carousels[i];
            var $carousel = $(carousel.domElement);
            $carousel
                .attr('data-shift', 0)
                .attr('data-show-items', showItems)
                .find('.carousel-control.left,.carousel-control.right').addClass('disabled')
                .end()
                .find('> .items').css('left', 0);

            var $allItems = $carousel.find('> .items > .item');
            if ($allItems.length > showItems) {
                $carousel.find('.carousel-control.right').removeClass('disabled');
            }

            carousel.slideEnabled = ($allItems.length > showItems);
        }
    };

    function sliderInit(domElement) {
        var $control = $(domElement);

        var showItems = $control.attr('data-show-items');
        var $allItems = $control.find('> .items > .item');

        if ($allItems.length <= showItems) {
            $control.find('.carousel-control').addClass('disabled');
            var carousel = carouselFromElement(domElement);
            carousel.slideEnabled = false;
        }
        else {
            $control.find('.carousel-control.right').removeClass('disabled');
        }
    };

    function onSlide(event) {
        var carousel = carouselFromElement(event.data);

        if (!carousel.slideEnabled)
            return;

        var $control = $(this).closest('.carousel-control');
        if ($control.hasClass('disabled'))
            return;

        var direction = $control.hasClass('left') ? 'left' : 'right';
        var showItems = $control.parents('[data-show-items]').attr('data-show-items');
        var $slider = $control.parents('[data-shift]').find('> .items');
        var $allItems = $control.parents('[data-shift]').find('> .items > .item');
        var oldShift = Number($control.parents('[data-shift]').attr('data-shift'));
        var dataShiftBy = $control.parents('[data-shift]').attr('data-shift-by');
        dataShiftBy = dataShiftBy ? Number(dataShiftBy) : 1;
        var newShift;

        var goalpanelmeta = new function () {
            var width = null;
            this.getWidth = function () {
                if (null === width) {
                    // measure 2nd panel, not 1st one (different margins)
                    var $measureTile = $slider.find('> .item').eq(1);
                    width = (1 === $measureTile.length) ? $measureTile.outerWidth(true) : 0;
                }
                return width;
            }
        };

        if (direction === 'left') {
            if (oldShift === 0) {
                return;
            }

            newShift = (oldShift - dataShiftBy) < 0 ? 0 : oldShift - dataShiftBy;
        }
        else if (direction === 'right') {
            var maxValue = $allItems.length - showItems;
            if (oldShift === maxValue) {
                return;
            }

            newShift = (oldShift + dataShiftBy) > maxValue ? maxValue : oldShift + dataShiftBy;
        }

        if (newShift === 0) {
            $control.parent().find('.carousel-control.left').addClass('disabled');
        }
        else {
            $control.parent().find('.carousel-control.left').removeClass('disabled');
        }
        if (newShift === ($allItems.length - showItems)) {
            $control.parent().find('.carousel-control.right').addClass('disabled');
        }
        else {
            $control.parent().find('.carousel-control.right').removeClass('disabled');
        }

        slideEnabled = false;
        $control.parents('[data-shift]').attr('data-shift', newShift);
        $slider.css('left', Number(goalpanelmeta.getWidth() * newShift * -1) + 'px');
        window.setTimeout(function () {
            slideEnabled = true;
        }, 750);

        // Fire callback
        carousel.onSlideHandler(carousel.domElement, newShift);
    };

    Carousel.onResize = function () {
        for (var i = 0; i < Carousel.carousels.length; i++) {
            var carousel = Carousel.carousels[i];
            if (!carousel.slideEnabled) {
                continue;
            }
            var $carousel = $(carousel.domElement);

            var $slider = $carousel.find('> .items');
            var oldShift = Number($carousel.attr('data-shift'));

            var goalpanelmeta = new function () {
                var width = null;
                this.getWidth = function () {
                    if (null === width) {
                        // measure 2nd panel, not 1st one (different margins)
                        var $measureTile = $slider.find('> .item').eq(1);
                        width = (1 === $measureTile.length) ? $measureTile.outerWidth(true) : 0;
                    }
                    return width;
                }
            };

            slideEnabled = false;
            $slider.css('left', Number(goalpanelmeta.getWidth() * oldShift * -1) + 'px');
            window.setTimeout(function () {
                slideEnabled = true;
            }, 750);

            // Fire callback
            carousel.onSlideHandler(carousel.domElement, oldShift);
        }
    };
}(jQuery));
/*
    USAGE NOTES
    =====
    class="no-autoload": optionally, prevents the graph from auto-loading.

    data-donut-diameter: (in pixels) NOTE: This doesn't set the
        pixel width of the whole SVG, only the donut itself;
        default is: 70

    data-full-color: the original colors were: "#3aa845", "#267e9c",
        "#fbba00", "#da4120"

    data-empty-color: default is: "#aaaaaa"
*/
(window.donut = function ($) {
    "use strict";

    // Constants
    var TextDonutPadding        = 3;    // Pixels between the header/footer text and the donut graph.
    var PercentFontSizeScalar   = 0.22; // Scales the size of the percent font.
    var InnerRadiusSizeScalar   = 2.0 / 2.8; // Scales the size of the inside of the donut.
    var AnimationDuration       = 3000; // Duration of the progress fill animation (in milliseconds).
    var ArrowBaseWidth          = 20 * (Math.PI / 180); // Width of the base of the arrow (in radians).
    var ArrowHeightScalar       = 0.75; // Height of the arrow, relative to the thickness of the donut.
    var ArrowColorTresholdPercent =     // The progress percentage the arrow should be colored at.
        (Math.PI + ArrowBaseWidth / 2) / (Math.PI / 50);
    var DefaultDonutWidth       = 70;
    var DefaultFillColor        = "#267e9c";
    var DefaultEmptyColor       = "#DEE0E2";

    var donutConfigs = {}; // associative array of maping: donutElement -> donut configuration data

    // Pie generator.
    var pie = d3.pie()
        .sort(null) // Don't sort the pie slices.
        .value(function (d) { return d.p; });

    function getPercentageFormatter() {
        var decimalFormatter = d3.format("d");
        return function (d) {
            return decimalFormatter(d) + "%";
        }
    }

    function update(donutElement) {
        var jqDonut = $(donutElement);
        var d3Donut = d3.select(donutElement);

        var self = donutConfigs[jqDonut.attr('id')];
        if (null == self) {
            return;
        }

        // Re-read the fill percentage.
        {
            var fillPercent = jqDonut.attr("data-fill-percent");

            if (null == fillPercent) {
                fillPercent = 0;
            }

            fillPercent = parseInt(fillPercent, 10);

            if (isNaN(fillPercent) || fillPercent < 0) {
                fillPercent = 0;
            }

            var textPercent = fillPercent;

            if (fillPercent > 100) {
                fillPercent = 100;
            }
        }

        // Arg generator.
        var arc = d3.arc()
            .outerRadius(self.radius)
            .innerRadius(self.radius * InnerRadiusSizeScalar);

        // Create pie slices using the pie chart generator.
        var data = pie([{ p: fillPercent, c: self.fillColor }, { p: 100.0 - fillPercent, c: self.emptyColor }]);

        if (null == self.lastFill) {
            self.lastFill = 0;
            self.lastEndAngle = 0;
        }

        var lastFill = self.lastFill;
        var startAngle = self.lastEndAngle;

        function tween(d, i) {
            if (0 === i) { // donut progress arc
                var i1 = d3.interpolate(startAngle, d.endAngle);
                return function (t) {
                    d.endAngle = i1(t);
                    if (d.endAngle / (Math.PI / 50) >= ArrowColorTresholdPercent) {
                        self.arrow
                            .style("stroke", self.fillColor || '')
                            .style("fill", self.fillColor || '');
                    } else {
                        self.arrow
                            .style("stroke", self.emptyColor)
                            .style("fill", self.emptyColor);
                    }
                    return arc(d);
                };
            } else { // donut empty arc
                var i2 = d3.interpolate(startAngle, d.startAngle);
                return function (t) {
                    d.startAngle = i2(t);
                    return arc(d);
                };
            }
        }

        self.lastFill = fillPercent;
        self.lastEndAngle = data[0].endAngle;

        var donutGroup = d3Donut.select("svg").select("g");

        // JOIN
        var arcs = donutGroup.selectAll(".arc")
            .data(data);

        // EXIT
        arcs.exit().remove();

        // UPDATE
        arcs.transition()
            .duration(AnimationDuration)
            .attrTween("d", tween);

        donutGroup.select(".percent")
            .text(getPercentageFormatter()(textPercent));

        // ENTER
        arcs.enter()         // For each slice create a new SVG group of class "arc".
            .append("path")
                .attr("class", "arc")
                .style("fill", function (d) { return d.data.c; })
                .transition()
                    .duration(AnimationDuration)
                    .attrTween("d", tween);
    } // update()

    function draw(donutElement) {

        var jqDonut = $(donutElement);
        var d3Donut = d3.select(donutElement);

        // Read script inputs:
        var headerText  = jqDonut.attr("data-header-text");     // Header text of the graph.
        var footerText  = jqDonut.attr("data-footer-text");     // Footer text.
        var fillPercent = jqDonut.attr("data-fill-percent");    // [0.0 - 100.0]
        var donutWidth  = jqDonut.attr("data-donut-diameter");  // in pixels (default: 70)
        var fillColor   = jqDonut.attr("data-full-color");      // valid CSS color
        var emptyColor  = jqDonut.attr("data-empty-color");     // valid CSS color
        var arrowHeight = jqDonut.attr("data-donut-arrow-height");  // in pixels (default is relative to donut)
        var hasHeader   = false;
        var hasFooter   = false;

        // Parameter checking:
        {
            if (null != headerText) {
                hasHeader = true;
            }

            if (null != footerText) {
                hasFooter = true;
            }

            if (null == fillPercent) {
                fillPercent = 0;
            }

            fillPercent = parseInt(fillPercent, 10);

            if (isNaN(fillPercent) || fillPercent < 0) {
                fillPercent = 0;
            } else if (fillPercent > 100) {
                fillPercent = 100;
            }

            donutWidth = parseFloat(donutWidth);

            if (isNaN(donutWidth) || donutWidth < 0) {
                donutWidth = DefaultDonutWidth;
            }

            if (null == emptyColor) {
                emptyColor = DefaultEmptyColor;
            }
        }

        var width = donutWidth,
            height = donutWidth,
            radius = width / 2;

        var donutConfig = {
            fillColor: fillColor ? d3.color(fillColor) : null,
            emptyColor: d3.color(emptyColor),
            fillPercent: fillPercent,
            radius: radius
        };

        donutConfigs[jqDonut.attr('id')] = donutConfig;

        if (arrowHeight == null) {
            arrowHeight = (radius - radius * InnerRadiusSizeScalar) * ArrowHeightScalar;
        }

        // Add the SVG image to the html page below the element of class donut.
        var svg = d3Donut.append("svg")
            .attr("class", "donut-graph");

        // Create a group for the donut graph's arcs.
        var donutGroup = svg.append("g");

        // Create the chart header text.
        if (hasHeader) {
            var headerGroup = donutGroup.append("g"); // NOTE: The transform attribute must be applied to a 'g' element for IE.
            var header = headerGroup.append("text")
                .attr("class", "header")
                .text(headerText);
        }

        if (hasFooter) {
            var footerGroup = donutGroup.append("g"); // NOTE: The transform attribute must be applied to a 'g' element for IE.
            var footer = footerGroup.append("text")
                .attr("class", "footer")
                .text(footerText);
        }

        // Get dimensions of the header and footer text, then calculate some positioning and padding.
        {
            var headerBounds = (hasHeader) ?
                $(".header", jqDonut).get(0).getBBox() : { width: 0, height: 0 };
            var footerBounds = (hasFooter) ?
                $(".footer", jqDonut).get(0).getBBox() : { width: 0, height: 0 };

            // Compute the widest component of the complete SVG.
            var adjustedWidth = Math.max(width + (arrowHeight * 2.25),
                Math.max(headerBounds.width, footerBounds.width)
                );

            var headerSpace = (hasHeader) ? headerBounds.height + (headerBounds.height / 2) + TextDonutPadding : 0;
            var footerSpace = (hasFooter) ? footerBounds.height + (footerBounds.height / 2) + TextDonutPadding : 0;

            var adjustedHeight = height + headerSpace + footerSpace + arrowHeight * 1.25;
        }

        if (hasHeader) {
            // Move the header above the donut adding a scaling factor (1.3) for padding.
            headerGroup.attr("transform", "translate(0," + ((height + headerBounds.height) / -2 - TextDonutPadding) + ")");
        }

        if (hasFooter) {
            // Move the footer below the donut adding a scaling factor (1.3) for padding.
            footerGroup.attr("transform", "translate(0," + ((height + footerBounds.height) / 2 + footerBounds.height + TextDonutPadding) + ")");
        }

        // Size the SVG image width to whatever is wider, the donut or the chart header.
        //  Make the height: the donut height, plus the header space.
        svg.attr("width", adjustedWidth)
            .attr("height", adjustedHeight);

        // Position the donut group based on the calculated image sizes.
        donutGroup.attr("transform", "translate(" + (adjustedWidth / 2) + "," + (height / 2 + headerSpace) + ")");

        // Percent label in the middle of the donut.
        donutGroup.append("text")
            .attr("class", "percent")
            .style("font-size", (width * PercentFontSizeScalar) + "px")
            .text(getPercentageFormatter()(fillPercent));

        // Draw the nubby arrow on the outside of the donut.
        // angle: position of the arrow in radians (starts at 12 o'clock, travels clockwise).
        function arrowPath(angle) {
            var a = angle - Math.PI / 2;

            var e = a - (ArrowBaseWidth / 2),
                s = e + ArrowBaseWidth;

            var m = radius + arrowHeight;

            // NOTE: These path functions all flip the y-axis.
            var pf = d3.path();
            pf.arc(0, 0, radius, s, e, true);
            pf.lineTo(m * Math.cos(a), m * Math.sin(a));
            pf.closePath();

            return pf.toString();
        }

        // Draw the arrow on the outside of the donut.
        var arrow = donutGroup.append("g")
            .attr("class", "arrow")
            .append("path")
                .style("stroke", emptyColor)
                .style("fill", emptyColor)
                .attr("d", arrowPath(Math.PI));

        donutConfig.arrow = arrow;

        update(donutElement); // Initial update.
    } // draw()

    function drawAllDonuts() {
        // Find every element of class donut.
        $(".donut").each(function(i, e) {
            if ($(e).hasClass("no-autoload"))// if (null != $(e).attr("no-autoload"))
            {
                return;
            }

            draw(e);
        });
    }

    return {
        update: update,
        draw: draw,
        drawAllDonuts: drawAllDonuts
    };

}(jQuery));
var WritableImages = (function (my) {
    return my;
}(WritableImages || window.WritableImages || {}));

(function ($) {

    WritableImages.createImageFromFile = function (file, settings) {
        settings = settings || {};

        setStatus(settings, 'Processing');
        return getImage(file, settings)
            .then(function (file) {

                setStatus(settings, 'Uploading');
                return $.when(submitImageForScanning(file), addImageAndUploadToS3(file, settings))
                    .then(function (scanResult, addImageResult) {

                        setStatus(settings, 'Verifying');
                        return $.post(Writable.imageVerifyImageUrl, JSON.stringify({
                            length: file.size,
                            contentType: file.type,
                            imageId: addImageResult.id,
                            verificationId: scanResult.id,
                        }));
                    });
            })
            .then(function (result) {
                if (settings.bindImageUrl) {
                    setStatus(settings, 'Finishing');
                    return $.post(settings.bindImageUrl, JSON.stringify([result.imageId]))
                        .then(function () {
                            return result;
                        });
                }
                return result;
            })
            .fail(function (error) {
                if (error instanceof Error) {
                    console.error(error);
                    error = {};
                }
                bootbox.alert({
                    title: error.title || Writable.text.shared_error_image_general_failure_title,
                    message: error.message || Writable.text.shared_error_image_general_failure,
                    closeButton: false,
                });
            });
    };

    WritableImages.initializeFroalaPlugin = function () {
        if (window.FroalaEditor) {
            createFroalaPlugin(window.FroalaEditor);
        } else {
            console.error('FroalaEditor is not loaded');
        }
    };

    function setStatus(settings, status) {
        if (settings.onStatusChanged) {
            settings.onStatusChanged(status);
        }
    }

    function getImage(file, settings) {
        if (Writable.settings.useImageCompression && settings.useImageCompression !== false && typeof imageCompression !== undefined) {
            return getImageWithCompression(file, settings);
        } else {
            return getImageWithoutCompression(file, settings);
        }
    }

    function getImageWithCompression(file, settings) {
        var deferred = $.Deferred();
        var options = {
            exifOrientation: 1,
            maxSizeMB: settings.maxSizeMB || 0.5,
            maxIteration: settings.maxIteration || 10,
        }
        if (settings.maxWidthOrHeight) {
            if (settings.maxWidthOrHeight !== -1) {
                options.maxWidthOrHeight = settings.maxWidthOrHeight;
            }
        } else {
            options.maxWidthOrHeight = 400;
        }

        var maxCompressedSize = options.maxSizeMB * 1024 * 1024;

        imageCompression(file, options)
            .then(function (compressed) {
                if (compressed.type !== 'image/jpeg' &&
                    compressed.type !== 'image/png' &&
                    compressed.type !== 'image/gif') {
                    deferred.reject({
                        title: Writable.text.shared_error_image_type_title,
                        message: Writable.text.shared_error_image_type
                    });
                    return;
                }

                if (compressed.size > maxCompressedSize) {
                    deferred.reject({
                        title: Writable.text.shared_error_image_size_title,
                        message: Writable.text.shared_error_image_compressed_size
                    });
                    return;
                }

                deferred.resolve(compressed);
            })
            .catch(function (error) {
                if (error instanceof Event && error.target && error.target.src && error.target.src.startsWith("data:image/heic;")) {
                    deferred.reject({
                        title: Writable.text.shared_error_image_type_title,
                        message: Writable.text.shared_error_image_heic_unsupported
                    });
                } else if (error.message == "The file given is not an image") {
                    deferred.reject({
                        title: Writable.text.shared_error_image_type_title,
                        message: Writable.text.shared_error_image_invalid
                    });
                } else {
                    getImageWithoutCompression(file, settings)
                        .then(function (data) {
                            deferred.resolve(data);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                }
            });

        return deferred.promise();
    }

    function getImageWithoutCompression(file, settings) {
        var deferred = $.Deferred();
        var maxSize = settings.maxSizeMB || 0.5;
        var maxFileSize = maxSize * 1024 * 1024;

        if (file.size > maxFileSize) {
            deferred.reject({
                title: Writable.text.shared_error_image_size_title,
                message: Writable.text.shared_error_image_compressed_size
            });
        } else {
            var fileReader = new FileReader();
            fileReader.onloadend = function (e) {
                var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
                var header = '';
                for (var i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
                }
                switch (header) {
                    case "89504e47": // image/png
                    case "47494638": // image/gif
                    case "ffd8ffe0": // image/jpeg
                    case "ffd8ffe1":
                    case "ffd8ffe2":
                        deferred.resolve(file);
                        break;
                    default:
                        deferred.reject({
                            title: Writable.text.shared_error_image_type_title,
                            message: Writable.text.shared_error_image_type
                        });
                        break;
                }
            };
            fileReader.readAsArrayBuffer(file);
        }

        return deferred.promise();
    }

    function submitImageForScanning(file) {
        var deferred = $.Deferred();
        ScanFile.runCheck(file)
            .then(function (scanData) {
                deferred.resolve(scanData);
            })
            .catch(function (error) {
                if (error.statusCode === 413) {
                    deferred.reject({
                        title: Writable.text.shared_error_image_size_title,
                        message: Writable.text.shared_error_image_compressed_size
                    });
                } else if (error.statusCode === 415) {
                    deferred.reject({
                        title: Writable.text.shared_error_image_type_title,
                        message: Writable.text.shared_error_image_invalid
                    });
                } else if (error.findings !== undefined) {
                    deferred.reject({
                        message: Writable.text.shared_error_image_scan_failure
                    });
                } else {
                    deferred.reject({
                        message: Writable.text.shared_error_image_general_failure
                    });
                }
            });

        return deferred.promise();
    }

    function addImageAndUploadToS3(file, settings) {
        return $.post(Writable.imageAddImageUrl)
            .then(function (addImageResult) {
                return uploadToS3(file, settings, addImageResult)
                    .then(function () {
                        return addImageResult;
                    });
            });
    }

    function uploadToS3(file, settings, addImageResult) {
        var deferred = $.Deferred();
        var taggingXml = '<Tagging><TagSet>';
        taggingXml += '<Tag><Key>User-Id</Key><Value>' + Writable.currentUserId + '</Value></Tag>';
        if (settings.refId) {
            taggingXml += '<Tag><Key>Ref-Id</Key><Value>' + settings.refId + '</Value></Tag>';
        }
        if (settings.refType) {
            taggingXml += '<Tag><Key>Ref-Type</Key><Value>' + settings.refType + '</Value></Tag>';
        }
        taggingXml += '</TagSet></Tagging>';

        var formData = new FormData();
        var fields = addImageResult.fields;
        Object.keys(fields).forEach(function (value) {
            formData.append(value, fields[value]);
        });
        formData.append('Content-Type', file.type);
        formData.append('tagging', taggingXml);
        formData.append('file', file);
        $.ajax({
            url: addImageResult.url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function () {
                deferred.resolve();
            },
            error: function (jqXHR) {
                deferred.reject({
                    message: Writable.text.shared_error_image_general_failure
                });
            }
        });

        return deferred.promise();
    }

    function createFroalaPlugin(FroalaEditor) {
        FroalaEditor.DEFAULTS = Object.assign(FroalaEditor.DEFAULTS, {
            writableImageUploadEnabled: false,
            writableImageUploadSettings: null,
        });

        FroalaEditor.PLUGINS.writableImageUploader = function (editor) {

            const defaultSettings = {
                maxSizeMB: 2,
                maxWidthOrHeight: -1,
            };

            function initializeImageUpload($element) {

                // Remove any image placeholders from the user's html
                editor.events.on('html.get', function (html) {
                    var $html = $('<div>').html(html);
                    $html.find('.writable-image-uploader-placeholder').remove();
                    return $html.html();
                });

                // Intercept image upload
                editor.events.on('image.beforeUpload', function (images) {
                    if (images && images.length === 1) {
                        var $placeholder = $('<div class="writable-image-uploader-placeholder" contenteditable="false"><div class="fad fa-spinner fa-spin"></div><div class="status"></div></div>');
                        var $existingImage = $(editor.image.get());
                        var $endElement = $(editor.selection.endElement());
                        var $after = $existingImage.length > 0 ? $existingImage : $endElement;
                        if ($element.has($after).length > 0) {
                            while (!$after.parent().is($element)) {
                                $after = $after.parent();
                            }
                            $placeholder.insertAfter($after);
                        } else {
                            $element.append($placeholder);
                        }
                        editor.popups.hideAll();
                        editor.edit.off();
                        var settings = $.extend(defaultSettings, editor.opts.writableImageUploadSettings, {
                            onStatusChanged: function (status) {
                                $placeholder.find('.status').text(status);
                            }
                        });
                        WritableImages.createImageFromFile(images[0], settings)
                            .then(function (result) {
                                if ($placeholder.parent().length > 0) {
                                    editor.selection.setAtEnd($placeholder.get(0));
                                    editor.selection.restore();
                                }
                                editor.image.insert(result.imageUrl, false, null, editor.image.get(), null);
                                editor.undo.saveStep();
                                editor.events.trigger('writable.imageUploaded', [result], true);
                            })
                            .always(function () {
                                $element.find('.writable-image-uploader-placeholder').remove();
                                editor.edit.on();
                            });
                    }
                    return false;
                });
            }

            function _init() {
                if (editor.opts.writableImageUploadEnabled) {
                    var $element = $(editor.$el[0]);
                    initializeImageUpload($element);
                }
            }

            return {
                _init: _init,
            }
        }
    }
})(jQuery);

(function () {
    var defaultUpdateInterval = 2000;   // 2 second intervals for autoSave

    // KO binding for dirtyFlag with initial value comparison
    ko.bindingHandlers.dirtyFlag = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var initialized = typeof bindingContext.$data._watching !== 'undefined';

            bindingContext.$data._watching = bindingContext.$data._watching || {};
            var watchProps = valueAccessor().properties;
            watchProps.forEach(function (item) {
                var propName = String(item).replace(/'/g, '').trim();
                if (typeof bindingContext.$data._watching[propName] !== 'undefined') {
                    return;
                }
                bindingContext.$data._watching[propName] = {
                    initialValue: ko.toJSON(bindingContext.$data[propName])
                };
            });

            // If a dirtyFlag binding is configured twice on the same model object, this skips the init
            // steps below so it only adds/initializes the listed properties. That does mean updateUrl
            // updateInterval, and onError are only read from the first binding of each context.
            if (initialized) { return; }

            bindingContext.$data._dirtyWatched = ko.observableArray();
            bindingContext.$data._saveFailAlerted = false;

            bindingContext.$data.dirty = ko.pureComputed(function () {
                return bindingContext.$data._dirtyWatched().length > 0;
            });

            bindingContext.$data._resetDirty = function (initValues) {
                bindingContext.$data._saveFailAlerted = false;
                var properties = new Array();
                if (!initValues) {
                    for (var key in bindingContext.$data._watching) {
                        if (bindingContext.$data._watching.hasOwnProperty(key)) {
                            properties.push(key);
                        }
                    }
                    properties.forEach(function (propName) {
                        bindingContext.$data._watching[propName].initialValue = ko.toJSON(bindingContext.$data[propName]);
                    });
                    bindingContext.$data._dirtyWatched.removeAll();
                }
                else {
                    for (var initKey in initValues) {
                        if (initValues.hasOwnProperty(initKey)) {
                            properties.push(initKey);
                        }
                    }
                    properties.forEach(function (propName) {
                        bindingContext.$data._watching[propName].initialValue = ko.toJSON(initValues[propName]);
                        bindingContext.$data._dirtyWatched.remove(propName);
                        if (initValues[propName] !== bindingContext.$data[propName]()) {
                            bindingContext.$data._dirtyWatched.push(propName);
                        }
                    });
                }
            };

            if (valueAccessor().updateUrl) {
                bindingContext.$data.saving = bindingContext.$data.saving || ko.observable(false);
                bindingContext.$data._saveDirty = function (force) {
                    if (force !== true && bindingContext.$data.saving()) { return; }
                    bindingContext.$data.saving(true);

                    try {
                        if (bindingContext.$data._dirtyWatched().length === 0) {
                            throw new Error('Not dirty');   // caught below, does not bubble out
                        }

                        var updateUrl = valueAccessor().updateUrl;
                        var properties = {};
                        bindingContext.$data._dirtyWatched().forEach(function (propName) {
                            if (typeof (bindingContext.$data[propName].hasError) === 'function' && bindingContext.$data[propName].hasError()) {
                                // do not update observables with validation errors
                                return;
                            }
                            properties[propName] = ko.utils.unwrapObservable(bindingContext.$data[propName]);
                        });
                        var data = JSON.stringify(properties);

                        $.post(updateUrl, data)
                        .done(function () {
                            bindingContext.$data._resetDirty(properties);

                            try {
                                if (typeof bindingContext.$data._onSuccess === 'function') {
                                    var allproperties = {};
                                    for (var propName in bindingContext.$data._watching) {
                                        allproperties[propName] = ko.utils.unwrapObservable(bindingContext.$data[propName]);
                                    }
                                    bindingContext.$data._onSuccess(allproperties);
                                }
                            }
                            catch (err) { }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            if (bindingContext.$data._saveFailAlerted === true) {
                                return;
                            }
                            bindingContext.$data._saveFailAlerted = true;
                            var genericError = function () {
                                bootbox.alert({
                                    title: 'Save Failed',
                                    message: 'Unfortuantely, there was a problem saving your work. We recommend you check your internet connection while we keep trying.<br /><br />If unable to save via Writable, please keep a copy your work until your connection is restored.',
                                });
                            };
                            if (typeof bindingContext.$data._onError === 'function') {
                                bindingContext.$data._onError(jqXHR, properties)
                                    .fail(genericError);
                            }
                            else {
                                genericError();
                            }
                        })
                        .always(function () {
                            bindingContext.$data.saving(false);
                        });
                    }
                    catch (err) {
                        bindingContext.$data.saving(false);
                    }
                };

                // Set up auto-saving on a timed delay
                bindingContext.$data._autoSave = setInterval(function (model) {
                    if (model.saving()) { return; }
                    if (!model.dirty()) { return; }
                    model._saveDirty();
                }, (valueAccessor().updateInterval || defaultUpdateInterval), bindingContext.$data);

                bindingContext.$data._onError = valueAccessor().onError;

                bindingContext.$data._onSuccess = valueAccessor().onSuccess;

                // Force an auto-save if the page tries to unload while dirty
                $(window).on('beforeunload', { model: bindingContext.$data }, function (e) {
                    if (e.data.model.dirty()) {
                        e.data.model._saveDirty(true);
                    }
                });

                $(window).on('autosave', { model: bindingContext.$data }, function (e) {
                    if (e.data.model.dirty()) {
                        e.data.model._saveDirty(true);
                    }
                });
            }
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var watchProps = valueAccessor().properties;
            watchProps.forEach(function (item) {
                var propName = String(item).replace(/'/g, '').trim();
                var curValue = ko.toJSON(bindingContext.$data[propName]);

                if (curValue !== bindingContext.$data._watching[propName].initialValue) {
                    if (bindingContext.$data._dirtyWatched.indexOf(propName) > -1) { return; }
                    bindingContext.$data._dirtyWatched.push(propName);
                }
                else {
                    bindingContext.$data._dirtyWatched.remove(propName);
                }
            });
        }
    };
    ko.virtualElements.allowedBindings.dirtyFlag = true;

})();
(function () {
/*** Array Polyfills ***/

    if (!Array.prototype.filter) {
        Array.prototype.filter = function (fun/*, thisArg*/) {
            'use strict';

            if (this === void 0 || this === null) {
                throw new TypeError();
            }

            var t = Object(this);
            var len = t.length >>> 0;
            if (typeof fun !== 'function') {
                throw new TypeError();
            }

            var res = [];
            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in t) {
                    var val = t[i];

                    // NOTE: Technically this should Object.defineProperty at
                    //       the next index, as push can be affected by
                    //       properties on Object.prototype and Array.prototype.
                    //       But that method's new, and collisions should be
                    //       rare, so use the more-compatible alternative.
                    if (fun.call(thisArg, val, i, t)) {
                        res.push(val);
                    }
                }
            }

            return res;
        };
    };

    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function (predicate) {
                'use strict';
                if (this == null) {
                    throw new TypeError('Array.prototype.findIndex called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return i;
                    }
                }
                return -1;
            },
            enumerable: false,
            configurable: false,
            writable: false
        });
    }

    // Production steps of ECMA-262, Edition 5, 15.4.4.19
    // Reference: http://es5.github.io/#x15.4.4.19
    if (!Array.prototype.map) {

        Array.prototype.map = function (callback, thisArg) {

            var T, A, k;

            if (this == null) {
                throw new TypeError(' this is null or not defined');
            }

            // 1. Let O be the result of calling ToObject passing the |this| 
            //    value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get internal 
            //    method of O with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If IsCallable(callback) is false, throw a TypeError exception.
            // See: http://es5.github.com/#x9.11
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 1) {
                T = thisArg;
            }

            // 6. Let A be a new array created as if by the expression new Array(len) 
            //    where Array is the standard built-in constructor with that name and 
            //    len is the value of len.
            A = new Array(len);

            // 7. Let k be 0
            k = 0;

            // 8. Repeat, while k < len
            while (k < len) {

                var kValue, mappedValue;

                // a. Let Pk be ToString(k).
                //   This is implicit for LHS operands of the in operator
                // b. Let kPresent be the result of calling the HasProperty internal 
                //    method of O with argument Pk.
                //   This step can be combined with c
                // c. If kPresent is true, then
                if (k in O) {

                    // i. Let kValue be the result of calling the Get internal 
                    //    method of O with argument Pk.
                    kValue = O[k];

                    // ii. Let mappedValue be the result of calling the Call internal 
                    //     method of callback with T as the this value and argument 
                    //     list containing kValue, k, and O.
                    mappedValue = callback.call(T, kValue, k, O);

                    // iii. Call the DefineOwnProperty internal method of A with arguments
                    // Pk, Property Descriptor
                    // { Value: mappedValue,
                    //   Writable: true,
                    //   Enumerable: true,
                    //   Configurable: true },
                    // and false.

                    // In browsers that support Object.defineProperty, use the following:
                    // Object.defineProperty(A, k, {
                    //   value: mappedValue,
                    //   writable: true,
                    //   enumerable: true,
                    //   configurable: true
                    // });

                    // For best browser support, use the following:
                    A[k] = mappedValue;
                }
                // d. Increase k by 1.
                k++;
            }

            // 9. return A
            return A;
        };
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return kValue.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return kValue;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return undefined.
                return undefined;
            }
        });
    }

    // Production steps of ECMA-262, Edition 5, 15.4.4.17
    // Reference: http://es5.github.io/#x15.4.4.17
    if (!Array.prototype.some) {
        Array.prototype.some = function (fun/*, thisArg*/) {
            'use strict';

            if (this == null) {
                throw new TypeError('Array.prototype.some called on null or undefined');
            }

            if (typeof fun !== 'function') {
                throw new TypeError();
            }

            var t = Object(this);
            var len = t.length >>> 0;

            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(thisArg, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (searchElement, fromIndex) {

                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(searchElement, elementK) is true, return true.
                    // c. Increase k by 1. 
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    k++;
                }

                // 8. Return false
                return false;
            }
        });
    }

    // Production steps of ECMA-262, Edition 5, 15.4.4.18
    // Reference: http://es5.github.io/#x15.4.4.18
    if (!Array.prototype.forEach) {
        Array.prototype.forEach = function (callback/*, thisArg*/) {
            var T, k;

            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            // 1. Let O be the result of calling toObject() passing the
            // |this| value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get() internal
            // method of O with the argument "length".
            // 3. Let len be toUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If isCallable(callback) is false, throw a TypeError exception. 
            // See: http://es5.github.com/#x9.11
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            // 5. If thisArg was supplied, let T be thisArg; else let
            // T be undefined.
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // 6. Let k be 0.
            k = 0;

            // 7. Repeat while k < len.
            while (k < len) {

                var kValue;

                // a. Let Pk be ToString(k).
                //    This is implicit for LHS operands of the in operator.
                // b. Let kPresent be the result of calling the HasProperty
                //    internal method of O with argument Pk.
                //    This step can be combined with c.
                // c. If kPresent is true, then
                if (k in O) {

                    // i. Let kValue be the result of calling the Get internal
                    // method of O with argument Pk.
                    kValue = O[k];

                    // ii. Call the Call internal method of callback with T as
                    // the this value and argument list containing kValue, k, and O.
                    callback.call(T, kValue, k, O);
                }
                // d. Increase k by 1.
                k++;
            }
            // 8. return undefined.
        };
    }

    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every
    if (!Array.prototype.every) {
        Array.prototype.every = function (callbackfn, thisArg) {
            'use strict';
            var T, k;

            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            // 1. Let O be the result of calling ToObject passing the this 
            //    value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get internal method
            //    of O with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
            if (typeof callbackfn !== 'function') {
                throw new TypeError();
            }

            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 1) {
                T = thisArg;
            }

            // 6. Let k be 0.
            k = 0;

            // 7. Repeat, while k < len
            while (k < len) {

                var kValue;

                // a. Let Pk be ToString(k).
                //   This is implicit for LHS operands of the in operator
                // b. Let kPresent be the result of calling the HasProperty internal 
                //    method of O with argument Pk.
                //   This step can be combined with c
                // c. If kPresent is true, then
                if (k in O) {

                    // i. Let kValue be the result of calling the Get internal method
                    //    of O with argument Pk.
                    kValue = O[k];

                    // ii. Let testResult be the result of calling the Call internal method
                    //     of callbackfn with T as the this value and argument list 
                    //     containing kValue, k, and O.
                    var testResult = callbackfn.call(T, kValue, k, O);

                    // iii. If ToBoolean(testResult) is false, return false.
                    if (!testResult) {
                        return false;
                    }
                }
                k++;
            }
            return true;
        };
    }

    if (!Array.prototype.unique) {
        Array.prototype.unique = function () {
            var arr = [];
            for (var i = 0; i < this.length; i++) {
                if (!arr.includes(this[i])) {
                    arr.push(this[i]);
                }
            }
            return arr;
        };
    }

/*** String Polyfills ***/

    // From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }

    // From: https://mths.be/startswith v0.2.0 by @mathias
    if (!String.prototype.startsWith) {
        (function () { 'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
            var defineProperty = (function () {
                // IE 8 only supports `Object.defineProperty` on DOM elements
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) { }
                return result;
            }());
            var toString = {}.toString;
            var startsWith = function (search) {
                if (this == null) {
                    throw TypeError();
                }
                var string = String(this);
                if (search && toString.call(search) == '[object RegExp]') {
                    throw TypeError();
                }
                var stringLength = string.length;
                var searchString = String(search);
                var searchLength = searchString.length;
                var position = arguments.length > 1 ? arguments[1] : undefined;
                // `ToInteger`
                var pos = position ? Number(position) : 0;
                if (pos != pos) { // better `isNaN`
                    pos = 0;
                }
                var start = Math.min(Math.max(pos, 0), stringLength);
                // Avoid the `indexOf` call if no match is possible
                if (searchLength + start > stringLength) {
                    return false;
                }
                var index = -1;
                while (++index < searchLength) {
                    if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
                        return false;
                    }
                }
                return true;
            };
            if (defineProperty) {
                defineProperty(String.prototype, 'startsWith', {
                    'value': startsWith,
                    'configurable': true,
                    'writable': true
                });
            } else {
                String.prototype.startsWith = startsWith;
            }
        }());
    }

    // From: https://mths.be/endswith v0.2.0 by @mathias
    if (!String.prototype.endsWith) {
        (function () {
            'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
            var defineProperty = (function () {
                // IE 8 only supports `Object.defineProperty` on DOM elements
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) { }
                return result;
            }());
            var toString = {}.toString;
            var endsWith = function (search) {
                if (this == null) {
                    throw TypeError();
                }
                var string = String(this);
                if (search && toString.call(search) == '[object RegExp]') {
                    throw TypeError();
                }
                var stringLength = string.length;
                var searchString = String(search);
                var searchLength = searchString.length;
                var pos = stringLength;
                if (arguments.length > 1) {
                    var position = arguments[1];
                    if (position !== undefined) {
                        // `ToInteger`
                        pos = position ? Number(position) : 0;
                        if (pos != pos) { // better `isNaN`
                            pos = 0;
                        }
                    }
                }
                var end = Math.min(Math.max(pos, 0), stringLength);
                var start = end - searchLength;
                if (start < 0) {
                    return false;
                }
                var index = -1;
                while (++index < searchLength) {
                    if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
                        return false;
                    }
                }
                return true;
            };
            if (defineProperty) {
                defineProperty(String.prototype, 'endsWith', {
                    'value': endsWith,
                    'configurable': true,
                    'writable': true
                });
            } else {
                String.prototype.endsWith = endsWith;
            }
        }());
    }

    // From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
    if (!String.prototype.includes) {
        String.prototype.includes = function (search, start) {
            'use strict';

            if (search instanceof RegExp) {
                throw TypeError('first argument must not be a RegExp');
            }
            if (start === undefined) { start = 0; }
            return this.indexOf(search, start) !== -1;
        };
    }

    // From: https://vanillajstoolkit.com/polyfills/stringreplaceall/
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (str, newStr) {
            'use strict';

            // If a regex pattern
            if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
                return this.replace(str, newStr);
            }

            // If a string
            return this.replace(new RegExp(str, 'g'), newStr);
        };
    }

/*** Object Polyfills ***/

    if (typeof Object.create != 'function') {
        Object.create = (function (undefined) {
            var Temp = function () { };
            return function (prototype, propertiesObject) {
                if (prototype !== Object(prototype)) {
                    throw TypeError(
                      'Argument must be an object, or null'
                    );
                }
                Temp.prototype = prototype || {};
                var result = new Temp();
                Temp.prototype = null;
                if (propertiesObject !== undefined) {
                    Object.defineProperties(result, propertiesObject);
                }

                // to imitate the case of Object.create(null)
                if (prototype === null) {
                    result.__proto__ = null;
                }
                return result;
            };
        })();
    }

    //From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
    if (typeof Object.assign !== 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, "assign", {
            value: function assign(target, varArgs) { // .length of function is 2
                'use strict';
                if (target === null || target === undefined) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource !== null && nextSource !== undefined) {
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }

/*** Math Polyfills ***/

    //From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc#Polyfill
    Math.trunc = Math.trunc || function (x) {
        var n = x - x % 1;
        return n === 0 && (x < 0 || (x === 0 && (1 / x !== 1 / 0))) ? -0 : n;
    };

/*** Number Polyfills ***/
    // From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
    Number.isInteger = Number.isInteger || function(value) {
      return typeof value === 'number' && 
        isFinite(value) && 
        Math.floor(value) === value;
    };

})();

var ScanFile = (function (my) {
    return my;
}(ScanFile || window.ScanFile || {}));

(function () {

    ScanFile.init = function (scanTimeout) {
        ScanFile.scanTimeout = scanTimeout;
        ScanFile.lastCheck = new Date();
    }

    ScanFile.scanningDisabled = function () {
        return ScanFile.scanTimeout === -1;
    };

    ScanFile.mustReCheckConfig = function () {
        if (ScanFile.lastUserType && ScanFile.lastUserType !== Writable.currentUserType)
            return true;

        var currentTime = new Date();
        var nextTime = new Date(ScanFile.lastCheck.valueOf() + (300 * 1000));
        if (currentTime > nextTime) {
            return true;
        }
        return false;
    };

    ScanFile.getRequestConfig = function () {

        return new Promise(function (resolve, reject) {
            if (ScanFile.scanningDisabled()) {
                // Configured to not use scanning
                resolve({});
                return;
            }

            var storedConfig = window.getSessionString('SCAN_CONFIG', '');
            if (storedConfig !== '' && !ScanFile.mustReCheckConfig()) {
                var config = JSON.parse(storedConfig);
                var actualTimeout = new Date(Date.parse(config.timestamp).valueOf() + (config.timeout * 1000));
                if (Date.now() < actualTimeout && Writable.currentUserType == config.userType) {
                    ScanFile.lastUserType = config.userType;
                    resolve(config);
                    return;
                }
            }

            $.ajax({
                url: '/Home/GetScanRequestConfig',
                type: 'GET'
            })
                .done(function (data) {
                    ScanFile.lastUserType = data.userType;
                    ScanFile.lastCheck = new Date();
                    if (data.timeout === undefined) {
                        ScanFile.scanTimeout = -1;
                        resolve(data);
                        return;
                    }
                    data.timestamp = ScanFile.lastCheck;
                    ScanFile.scanTimeout = data.timeout;
                    window.setSessionString('SCAN_CONFIG', JSON.stringify(data));
                    resolve(data);
                })
                .fail(function (jqXHR) {
                    // If we fail to retrieve the config object, disable scanning
                    // for now. It will check again after the cache refresh, but
                    // no need to pummel the server.
                    ScanFile.lastCheck = new Date();
                    ScanFile.scanTimeout = -1;
                    resolve({});
                });
        });
    };

    ScanFile.runCheck = function (file) {
        return new Promise(function (resolve, reject) {
            if (ScanFile.scanningDisabled()) {
                console.log('ScanFile: Scanning is currently disabled.');
                resolve({});
                return;
            }

            ScanFile.getRequestConfig()
                .then(function (configData) {
                    if (configData.token === undefined) {
                        console.log('ScanFile: Configuration token unavailable.');
                        resolve({});
                        return;
                    }

                    var credentials = btoa(configData.token + ':');
                    var formData = new FormData();
                    formData.append("file", file);
                    formData.append("metadata[uid]", Writable.currentUserId);
                    formData.append("metadata[user_type]", Writable.currentUserType);
                    $.ajax({
                        url: configData.fileUri,
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('Authorization', 'Basic ' + credentials);
                        }
                    })
                        .done(function (result) {
                            if (result.findings !== undefined) {
                                if (result.findings.length > 0) {
                                    Writable.writeEventTrace(function () {
                                        return {
                                            event_name: 'CLIENT_SCAN_FINDINGS',
                                            findings: result.findings.join(', '),
                                            verification_id: result.id
                                        };
                                    });
                                    reject(result);
                                    return;
                                }
                            }

                            resolve(result);
                        })
                        .fail(function (error) {
                            Writable.writeEventTrace(function () {
                                return {
                                    event_name: 'SCAN_CLIENT_ERROR',
                                    status_code: error.statusCode
                                };
                            });

                            reject(error);
                        });
                })
                .catch(function () {
                    // If we can't obtain the config, let it go by.
                    console.log('ScanFile: Unable to fetch config.');
                    resolve({});
                });
        });
    };
})();
var Writable = (function (my) {
    return my;
}(Writable || {}));

(function ($) {
    // Default configuration of all jquery ajax calls
    $.ajaxSetup({
        cache: false,
        contentType: 'application/json; charset=utf-8'
    });
    $(document).ajaxSend(function (e, xhr, options) {
        var reqType = options.type.toUpperCase();
        if (/^\/[^\/]?/.test(options.url) && reqType !== "GET" && reqType !== "HEAD" && reqType !== "OPTIONS" && reqType !== "TRACE") {
            var $antiForgeryToken = $(document.body).find('> form > input[name="__RequestVerificationToken"]');
            if ($antiForgeryToken.length >= 1) {
                xhr.setRequestHeader("RequestVerificationToken", $antiForgeryToken.eq(0).val());
            }
        }
    });

    $.getCachedScript = function (url, options) {
        // Allow user to set any option except for dataType, cache, and url
        options = $.extend(options || {}, {
            dataType: "script",
            cache: true,
            url: url
        });
        return $.ajax(options);
    };

    var onAvatarChangePhotoClick = function () {
        if (!(window.FileReader && window.Blob)) {
            alert('Sorry, uploading images is not supported with this browser version.');
        }

        ScanFile.getRequestConfig();

        $(document.body).find('#avatar-upload input[type="file"]').click();
    };
    var onAvatarRemovePhotoClick = function () {
        var url = $('#avatar-remove-photo').attr('data-delete-url');
        $.post(url)
            .done(function (data, textStatus, jqXHR) {
                $(document.body).find('#avatar .user-image').css('background-image', "url('" + data + "')");
                Writable.setUserHasImage(false);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.status === 404) {
                    return;
                }
                Writable.showRequestFailed();
            });
    };

    var onDismissAnnouncement = function (e) {
        const $announcement = $('#announcement');

        $.post($announcement.attr('data-dismiss-url'))
            .then(function () {
                console.log('Dismissed announcement');
            });
        $announcement.remove();
    };

    Writable.openAssignmentPreview = function (goalId, location, options) {
        try {
            if (Writable.parentWritable && Writable.parentWritable.openAssignmentPreview) {
                return Writable.parentWritable.openAssignmentPreview(goalId, location, options);
            }
        }
        catch (error) {}

        Writable.writeEventTrace(function () {
            var trace = {
                'event_name': 'TEACHER_PREVIEW_ASSIGNMENT',
                'goal_id': goalId,
                'location': location
            };
            if (options.compilationItemId) {
                trace.compilation_item_id = options.compilationItemId;
            }
            if (options.collectionId) {
                trace.collection_id = options.collectionId;
            }
            if (options.compilationFilterId) {
                trace.compilation_filter_id = options.compilationFilterId;
            }
            return trace;
        });

        var previewUrl  = setUrlParameters(Writable.writingPreviewUrl, {
            goalId: goalId,
            noCopy: options.noCopy,
            noPromptPreview: options.noPromptPreview,
            promptId: options.promptId,
            isLti: options.isLti,
            compilationFilterId: options.compilationFilterId
        });
        if (Writable.isMobile()) {
            window.top.location = previewUrl;
            return;
        }
        if (options.noOverlay) {
            window.open(previewUrl, '_blank');
            return;
        }

        previewUrl = setUrlParameter(previewUrl , 'isOverlay', true);
        Writable.closeAssignmentPreview();
        var $overlay = $('<div id="assignment-preview" tabindex="-1">');
        $overlay.append($('<div class="message">Loading Preview</div>'));
        var $iframe = $('<iframe>', { src: previewUrl });
        $overlay.append($iframe);
        $(document.body).append($overlay);
        $iframe.focus();
        $(document.body).addClass('assignment-preview-visible');
        $('.body-content').attr('aria-hidden', 'true');
        $overlay.addClass('visible loading');

        if (options.fullscreen) {
            $overlay.addClass('fullscreen');
        }

        $iframe.on('load', function () {
            $overlay.removeClass('loading');
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, document.title, window.location.href);
        }
    };

    var closeAssignmentPreviewInternal = function () {
        $('.body-content').attr('aria-hidden', 'false');
        $(document.body).removeClass('assignment-preview-visible');
        $('#assignment-preview').remove();
    };

    Writable.openOutlinePreview = function (outlineId, location, options) {
        try {
            if (Writable.parentWritable && Writable.parentWritable.openOutlinePreview) {
                return Writable.parentWritable.openOutlinePreview(goalId, location, options);
            }
        }
        catch (error) { }

        Writable.writeEventTrace(function () {
            var trace = {
                'event_name': 'TEACHER_PREVIEW_OUTLINE',
                'outline_id': outlineId,
                'location': location
            };
            if (options.compilationItemId) {
                trace.compilation_item_id = options.compilationItemId;
            }
            if (options.collectionId) {
                trace.collection_id = options.collectionId;
            }
            if (options.compilationFilterId) {
                trace.compilation_filter_id = options.compilationFilterId;
            }
            return trace;
        });
        var previewUrl = setUrlParameters(Writable.outlineUrl, {
            isPreview: options.isPreview,
            isOverlay: !Writable.isMobile(),
            outlineId: outlineId,
            isOverlay: true
        });
        if (Writable.isMobile()) {
            window.top.location = previewUrl;
            return;
        }
        if (options.noOverlay) {
            window.open(previewUrl, '_blank');
            return;
        }
        Writable.closeOutlinePreview();
        var $overlay = $('<div id="outline-preview" tabindex="-1">');
        $overlay.append($('<div class="message">Loading Preview</div>'));
        var $iframe = $('<iframe>', { src: previewUrl });
        $overlay.append($iframe);
        $(document.body).append($overlay);
        $iframe.focus();
        $(document.body).addClass('outline-preview-visible');
        $('.body-content').attr('aria-hidden', 'true');
        $overlay.addClass('visible loading');

        if (options.fullscreen) {
            $overlay.addClass('fullscreen');
        }

        $iframe.on('load', function () {
            $overlay.removeClass('loading');
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, document.title, window.location.href);
        }
    };

    var closeOutlinePreviewInternal = function () {
        $('.body-content').attr('aria-hidden', 'false');
        $(document.body).removeClass('outline-preview-visible');
        $('#outline-preview').remove();
    };

    Writable.statesList = [
        { name: 'Alabama', abbreviation: 'AL' },
        { name: 'Alaska', abbreviation: 'AK' },
        { name: 'Arizona', abbreviation: 'AZ' },
        { name: 'Arkansas', abbreviation: 'AR' },
        { name: 'California', abbreviation: 'CA' },
        { name: 'Colorado', abbreviation: 'CO' },
        { name: 'Connecticut', abbreviation: 'CT' },
        { name: 'Delaware', abbreviation: 'DE' },
        { name: 'Florida', abbreviation: 'FL' },
        { name: 'Georgia', abbreviation: 'GA' },
        { name: 'Hawaii', abbreviation: 'HI' },
        { name: 'Idaho', abbreviation: 'ID' },
        { name: 'Illinois', abbreviation: 'IL' },
        { name: 'Indiana', abbreviation: 'IN' },
        { name: 'Iowa', abbreviation: 'IA' },
        { name: 'Kansas', abbreviation: 'KS' },
        { name: 'Kentucky', abbreviation: 'KY' },
        { name: 'Louisiana', abbreviation: 'LA' },
        { name: 'Maine', abbreviation: 'ME' },
        { name: 'Maryland', abbreviation: 'MD' },
        { name: 'Massachusetts', abbreviation: 'MA' },
        { name: 'Michigan', abbreviation: 'MI' },
        { name: 'Minnesota', abbreviation: 'MN' },
        { name: 'Mississippi', abbreviation: 'MS' },
        { name: 'Missouri', abbreviation: 'MO' },
        { name: 'Montana', abbreviation: 'MT' },
        { name: 'Nebraska', abbreviation: 'NE' },
        { name: 'Nevada', abbreviation: 'NV' },
        { name: 'New Hampshire', abbreviation: 'NH' },
        { name: 'New Jersey', abbreviation: 'NJ' },
        { name: 'New Mexico', abbreviation: 'NM' },
        { name: 'New York', abbreviation: 'NY' },
        { name: 'North Carolina', abbreviation: 'NC' },
        { name: 'North Dakota', abbreviation: 'ND' },
        { name: 'Ohio', abbreviation: 'OH' },
        { name: 'Oklahoma', abbreviation: 'OK' },
        { name: 'Oregon', abbreviation: 'OR' },
        { name: 'Pennsylvania', abbreviation: 'PA' },
        { name: 'Rhode Island', abbreviation: 'RI' },
        { name: 'South Carolina', abbreviation: 'SC' },
        { name: 'South Dakota', abbreviation: 'SD' },
        { name: 'Tennessee', abbreviation: 'TN' },
        { name: 'Texas', abbreviation: 'TX' },
        { name: 'Utah', abbreviation: 'UT' },
        { name: 'Vermont', abbreviation: 'VT' },
        { name: 'Virginia', abbreviation: 'VA' },
        { name: 'Washington', abbreviation: 'WA' },
        { name: 'West Virginia', abbreviation: 'WV' },
        { name: 'Wisconsin', abbreviation: 'WI' },
        { name: 'Wyoming', abbreviation: 'WY' }
    ];

    Writable.closeAssignmentPreview = function () {
        if ($(document.body).hasClass('assignment-preview-visible')) {
            closeAssignmentPreviewInternal();
            if (window.history && window.history.pushState) {
                window.history.back();
            }
        }
    };

    Writable.closeOutlinePreview = function (data) {
        if ($(document.body).hasClass('outline-preview-visible')) {
            closeOutlinePreviewInternal();
            if (window.history && window.history.pushState) {
                window.history.back();
            }
            if (data?.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
        }
    };

    Writable.openWritingOverlay = function (writingIndexUrl, location) {
        try {
            if (Writable.parentWritable && Writable.parentWritable.openWritingOverlay) {
                return Writable.parentWritable.openWritingOverlay(writingIndexUrl);
            }
        }
        catch (error) { }

        Writable.writeEventTrace(function () {
            return {
                'event_name': 'OPEN_WRITING_OVERLAY',
                'url': writingIndexUrl,
                'location': location
            };
        });

        if (Writable.isMobile()) {
            window.top.location = writingIndexUrl;
            return;
        }

        writingIndexUrl = setUrlParameter(writingIndexUrl, 'isOverlay', true);
        Writable.closeAssignmentPreview();
        const $overlay = $('<div id="writing-overlay" tabindex="-1">');
        $overlay.append($('<div class="message">Loading Writing</div>'));
        const $iframe = $('<iframe>', { src: writingIndexUrl });
        $overlay.append($iframe);
        $(document.body).append($overlay);
        $iframe.focus();
        $(document.body).addClass('writing-overlay-visible');
        $('.body-content').attr('aria-hidden', 'true');
        $overlay.addClass('visible loading');

        $iframe.on('load', function () {
            $overlay.removeClass('loading');
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, document.title, window.location.href);
        }
    };

    const closeWritingOverlayInternal = function () {
        $('.body-content').attr('aria-hidden', 'false');
        $(document.body).removeClass('writing-overlay-visible');
        $('#writing-overlay').remove();
    };

    Writable.closeWritingOverlay = function () {
        if ($(document.body).hasClass('writing-overlay-visible')) {
            closeWritingOverlayInternal();
            if (window.history && window.history.pushState) {
                window.history.back();
            }
        }
    };

    Writable.openBridgesDashboard = function (path) {
        try {
            if (Writable.parentWritable && Writable.parentWritable.openBridgesDashboard) {
                return Writable.parentWritable.openBridgesDashboard(path);
            }
        }
        catch (error) { }

        if ($(document.body).hasClass('bridges-dashboard-visible')) {
            closeBridgesDashboardInternal();
        }

        var dashboardUrl = Writable.bridgesDashboardUrl;
        Writable.writeEventTrace(function () {
            return {
                'event_name': 'OPEN_BRIDGES_DASHBOARD',
            };
        });

        if (Writable.isMobile()) {
            window.top.location = dashboardUrl;
            return;
        }

        dashboardUrl = setUrlParameters(dashboardUrl, {
            'isOverlay': true,
            'path': path
        });
        var $overlay = $('<div id="bridges-dashboard" tabindex="-1">');
        $overlay.append($('<div class="message">Loading Dashboard</div>'));
        var $iframe = $('<iframe>', { src: dashboardUrl, allow: "microphone;clipboard-write" });
        $overlay.append($iframe);
        $(document.body).append($overlay);
        $iframe.focus();
        $(document.body).addClass('bridges-dashboard-visible');
        $overlay.addClass('visible loading');

        $iframe.on('load', function () {
            $overlay.removeClass('loading');
        });

        if (window.history && window.history.pushState) {
            window.history.pushState(null, document.title, window.location.href);
        }
    };

    var closeBridgesDashboardInternal = function () {
        $(document.body).removeClass('bridges-dashboard-visible');
        $('#bridges-dashboard').remove();
    };

    Writable.closeBridgesDashboard = function () {
        if ($(document.body).hasClass('bridges-dashboard-visible')) {
            if (window.history && window.history.pushState) {
                window.history.back();
            } else {
                closeBridgesDashboardInternal();
            }
            return true;
        }
        return false;
    };

    const $collapsibleNavigation = $('#collapsible-navigation');

    function updateCollapsibleNavigation() {
        const $navList = $collapsibleNavigation.find('> ul');
        const $dropdown = $navList.find('> .dropdown');
        const $dropdownList = $dropdown.find('> ul');
        let anyCollapsed = false;

        if (!Writable.usingAiToolsDomain) {
            const navWidth = $collapsibleNavigation.width();
            const dropdownWidth = $dropdown.outerWidth(true);
            const availableWidth = navWidth - dropdownWidth;
            let usedWidth = 0;

            $navList.children('li[data-collapse]').each(function () {
                const $item = $(this);
                const name = $item.attr('data-collapse');
                const width = $item.outerWidth(true);
                const collapsed = anyCollapsed || (usedWidth + width > availableWidth) || $item.attr('data-collapse-always') === 'true';
                $item.toggleClass('collapsed', collapsed);
                const $dropdownItem = $dropdownList.children(`li[data-collapse="${name}"]`);
                $dropdownItem.toggleClass('collapsed', collapsed);
                if (collapsed) {
                    anyCollapsed = true;
                } else {
                    usedWidth += width;
                }
            });
        } else { // Mobile
            const mediaQuery = window.matchMedia('(max-width: 768px)');
            $navList.children('li[data-collapse]').each(function () {
                const $item = $(this);
                const name = $item.attr('data-collapse');
                const collapsed = $item.attr('data-collapse-always') === 'true' || mediaQuery.matches;
                anyCollapsed = collapsed;
                $item.toggleClass('collapsed', collapsed);
                const $dropdownItem = $dropdownList.children(`li[data-collapse="${name}"]`);
                $dropdownItem.toggleClass('collapsed', collapsed);
            });
        }

        $dropdown.toggleClass('active', anyCollapsed);
        $collapsibleNavigation.addClass('initialized');
    }

    if (window.ResizeObserver) {
        const target = $collapsibleNavigation.get(0);
        if (target) {
            const resizeObserver = new ResizeObserver(() => {
                updateCollapsibleNavigation();
            });
            resizeObserver.observe(target);
        }
    } else {
        $(window).on('resize', function (e) {
            updateCollapsibleNavigation();
        });
    }

    $(document).ready(function () {
        updateCollapsibleNavigation();
    });

    $(window).on('load', function (e) {
        updateCollapsibleNavigation();
    });

    $(window).on('message', function (e) {
        var data = e.originalEvent.data;
        if (data && data.source === 'writableWeb') {
            switch (data.operation) {
                case 'accountDetailsClose':
                    $(document).trigger('accountDetailsClose');
                    break;
                case 'nameUpdate':
                    $(document).trigger('nameUpdate', data);
                    break;
                case 'gradeBandUpdate':
                    $(document).trigger('gradeBandUpdate', data);
                    break;
                case 'schoolUpdate':
                    $(document).trigger('schoolUpdate', data);
                    break;
                case 'standardsStateUpdate':
                    $(document).trigger('standardsStateUpdate', data);
                    break;
                case 'previewClose':
                    Writable.closeAssignmentPreview();
                    break;
                case 'outlinePreviewClose':
                    Writable.closeOutlinePreview(data);
                    break;
                case 'writingOverlayClose':
                    Writable.closeWritingOverlay();
                    break;
                case 'bridgesDashboardClose':
                    Writable.closeBridgesDashboard();
                    break;
            }
        }
    });

    $(window).on('popstate', function () {
        if ($(document.body).hasClass('bridges-dashboard-visible')) {
            closeBridgesDashboardInternal();
            return;
        }
        if ($(document.body).hasClass('assignment-preview-visible')) {
            closeAssignmentPreviewInternal();
            return;
        }
        if ($(document.body).hasClass('outline-preview-visible')) {
            closeOutlinePreviewInternal();
            return;
        }
        if ($(document.body).hasClass('writing-overlay-visible')) {
            closeWritingOverlayInternal();
            return;
        }
    });

    $(document.body).on('click', '.open-assignment-preview', function (e) {
        e.preventDefault();
        var $element = $(e.target).closest('[data-goal-id]');

        if ($element.length) {
            var $collection = $element.closest('li.sequence').find('[data-collection-id]');
            Writable.openAssignmentPreview($element.attr('data-goal-id'), $element.attr('data-location'), {
                noCopy: $element.attr('data-no-copy') === 'true',
                noOverlay: $element.attr('data-no-overlay') === 'true',
                noPromptPreview: $element.attr('data-no-prompt-preview') === 'true',
                fullscreen: $element.attr('data-fullscreen') === 'true',
                promptId: $element.attr('data-prompt-id'),
                compilationItemId: getParameterByName('compilationItemId'),
                collectionId: $collection.length ? $collection.data('collection-id') : null,
                isLti: $element.attr('data-is-lti') === 'true',
                compilationFilterId: $element.attr('data-compilation-filter-id')
            });
        }
    });

    $(document.body).on('click', '.open-outline-preview', function (e) {
        e.preventDefault();
        var $element = $(e.target).closest('[data-outline-id]');

        if ($element.length) {
            var $collection = $element.closest('li.sequence').find('[data-collection-id]');
            Writable.openOutlinePreview($element.attr('data-outline-id'), $element.attr('data-location'), {
                noCopy: $element.attr('data-no-copy') === 'true',
                noOverlay: $element.attr('data-no-overlay') === 'true',
                fullscreen: $element.attr('data-fullscreen') === 'true',
                compilationItemId: getParameterByName('compilationItemId'),
                collectionId: $collection.length ? $collection.data('collection-id') : null,
                isLti: $element.attr('data-is-lti') === 'true',
                compilationFilterId: $element.attr('data-compilation-filter-id'),
                isPreview: true
            });
        }
    });

    $(document.body).on('click', '.open-outline', function (e) {
        e.preventDefault();
        var $element = $(e.target).closest('[data-outline-id]');

        if ($element.length) {
            var $collection = $element.closest('li.sequence').find('[data-collection-id]');
            Writable.openOutlinePreview($element.attr('data-outline-id'), $element.attr('data-location'), {
                noCopy: $element.attr('data-no-copy') === 'true',
                noOverlay: $element.attr('data-no-overlay') === 'true',
                fullscreen: $element.attr('data-fullscreen') === 'true',
                compilationItemId: getParameterByName('compilationItemId'),
                collectionId: $collection.length ? $collection.data('collection-id') : null,
                isLti: $element.attr('data-is-lti') === 'true',
                compilationFilterId: $element.attr('data-compilation-filter-id'),
                isPreview: false
            });
        }
    });

    // Prevent page reloads (due to <base> tag) when clicking on empty anchor links whose handlers do not call preventDefault
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    $(document).on('click', 'a.confirm-navigate:not([data-confirmed-navigation])', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($(document.body).hasClass('bridges-dashboard-visible')) {
            Writable.closeBridgesDashboard();
        } else if ($(document.body).hasClass('assignment-preview-visible')) {
            Writable.closeAssignmentPreview();
        } else if ($(document.body).hasClass('outline-preview-visible')) {
            Writable.closeOutlinePreview();
        } else if ($(document.body).hasClass('writing-overlay-visible')) {
            Writable.closeWritingOverlay();
        } else {
            const onConfirmed = function () {
                const $anchor = $(e.target).closest('a');
                $anchor.attr('data-confirmed-navigation', '');
                $anchor.trigger('click');
            };
            if (Writable.confirmNavigationHandler) {
                Writable.confirmNavigationHandler(onConfirmed);
            } else {
                onConfirmed();
            }
        }
    });

    $(document).on('click', '#logout > a[data-confirmed-navigation]', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var performLogout = function () {
            window.location.href = $(e.target).closest('a').attr('href');
        };
        try { 
            SupportChat?.logout();
        } catch (error) { console.error('Failed to logout of support chat', error); }

        if (WritableBridges.enabled) {
            WritableBridges.logout().always(performLogout);
        } else {
            performLogout();
        }
    });

    $(document).on('click', 'a.confirm-navigate[data-confirmed-navigation]', function (e) {
        e.preventDefault();
        const $anchor = $(e.target).closest('a');
        const url = $anchor.attr('href');
        if (!url.startsWith('#')) {
            window.open(url, $anchor.attr('target') || '_self');
        }
    });

    Writable.setConfirmNavigationHandler = function (handler) {
        Writable.confirmNavigationHandler = handler;
    };

    $(document).ready(function () {
        $(document).on('click', '#avatar-change-photo', onAvatarChangePhotoClick);
        $(document).on('click', '#avatar-remove-photo', onAvatarRemovePhotoClick);
        $(document).on('change', '#avatar-upload input[type="file"]', Writable.onAvatarFileChange);
        $(document).on('click', 'a.account-details', Writable.onAccountDetailsClick);
        $(document).on('click', '.account-detail-modal .btn-done', Writable.onCloseAccountDetails);
        $(document).on('nameUpdate', Writable.nameUpdate);
        $(document).on('click', 'a.culture-selection', Writable.onCultureSelectionClick);
        $(document).on('click', '#announcement button.dismiss', onDismissAnnouncement);
    });

    $(window).on('load', function () {
        // look for teacher login cookie, and if it exists start a full google sync.
        var loginSync = Cookies.get('LoginSync');
        if (null != loginSync) {
            Cookies.remove('LoginSync');
            $.get(Writable.syncUrl);
        }

        $(document.body).find('.writable-banner #announcement time.local[datetime]').each(function (i, e) {
            $(e).text(moment($(e).attr('datetime')).format('h:mma'));
        });

        if (Writable.settings.checkSupportedAppVersionInterval > 0) {
            var parentLocationReachable = true;
            try {
                parent.location.href;
            }
            catch (err) {
                parentLocationReachable = false;
            }
            if ((parent === window || !parentLocationReachable) && !Writable.usingAiToolsDomain) {
                setInterval(Writable.onCheckSupportedAppVersion, Writable.settings.checkSupportedAppVersionInterval);
            }
        }

        if (window.FroalaEditor?.VIDEO_PROVIDERS) {
            FroalaEditor.VIDEO_PROVIDERS.push({
                test_regex: /^.+(brightcove\.net|bcove\.video)\//,
                html: `<iframe src="{url}" allowfullscreen="" allow="encrypted-media" width="640" height="360"></iframe>`,
                url_regex: null,
                url_text: null,
                provider: `brightcove`,
            });
        }
    });
})(jQuery);

Writable.disableGrammarly = function () {
    var g = /grammarly/i;
    var observer = new (window.MutationObserver || window.WebKitMutationObserver)(function (mutations) {
        for (mutation in mutations) {
            if (mutations[mutation] && mutations[mutation].addedNodes && $(mutations[mutation].addedNodes).toArray().some(function (n) { return n.nodeName.match(g); })) {
                $(mutations[mutation].addedNodes).toArray()
                    .filter(function (n) { return n.nodeName.match(g); })
                    .forEach(function (n) { $(n).addClass('hide'); });
            }
        }
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
};

Writable.onCheckSupportedAppVersion = function () {
    $.get('/setting/supportedversion').then(function (data) {
        if (!data) { return; }
        if (!Writable.supportedAppVersion) {
            Writable.supportedAppVersion = data;
        }
        else if (Writable.supportedAppVersion !== data) {
            bootbox.alert({
                title: Writable.text.shared_version_mismatch_reload_title,
                message: Writable.text.shared_version_mismatch_reload,
                closeButton: false,
                animate: false,
                backdrop: true,
                buttons: {
                    ok: {
                        label: Writable.text.shared_verb_reload
                    }
                },
                callback: function () { location.reload(true); }
            });
        }
    });
};

Writable.onAvatarFileChange = function (e) {
    $control = $(e.target).closest('#avatar-upload');
    var file = e.target.files[0];

    Writable.onImageFileChange(file, $control.attr('action'), {
        refType: "User",
        refId: Writable.currentUserId,
        verifyUrl: Writable.avatarVerifyUrl
    })
        .then(function (data) {
            $('#avatar .user-image').css('background-image', "url('"+data+"')");
            $control.get(0).reset();
            Writable.setUserHasImage(true);
        }).catch(function (error) {
            if (error.status) {
                bootbox.alert({
                    message: Writable.text.shared_error_image_general_failure,
                    closeButton: false
                });
            } else {
                error.closeButton = false;
                bootbox.alert(error);
            }
            $control.get(0).reset();
        });
        // Not using a finally here as some old browsers don't like it.
};

Writable.onImageFileChange = function (file, url, settings, beforeUpdate) {
    if (!settings) {
        settings = {}; // Ensure we have something accessible
    }

    if (Writable.settings.useImageCompression && settings.useImageCompression !== false) {
        var ieVersion = Writable.isIE();
        if (typeof imageCompression !== undefined &&
            (!ieVersion || ieVersion > 10)) {
            var webWorker = true;
            if (ieVersion && ieVersion == 11)
                webWorker = false;
            return Writable.onImageChange(function () { return Writable.getImageWithCompression(file, settings, webWorker); }, url, settings, beforeUpdate);
        }
    }

    // If we get here, we can't do the compressed version, so go with the basic one
    return Writable.onImageChange(function () { return Writable.getImageBasic(file, settings); }, url, settings, beforeUpdate);
};

Writable.getImageBasic = function (file, settings) {
    return new Promise(function (resolve, reject) {
        var maxSize = (settings.maxSizeMB) ? settings.maxSizeMB : 0.5;
        var maxFileSize = (maxSize * 1024) * 1024;

        if (file.size > maxFileSize) {
            reject({
                title: Writable.text.shared_error_image_size_title,
                message: Writable.text.shared_error_image_compressed_size
            });
            return;
        }

        var fileReader = new FileReader();
        fileReader.onloadend = function (e) {
            var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
            var header = '';
            for (var i = 0; i < arr.length; i++) {
                header += arr[i].toString(16);
            }
            switch (header) {
                case "89504e47":
                    type = "image/png"; break;
                case "47494638":
                    type = "image/gif"; break;
                case "ffd8ffe0":
                case "ffd8ffe1":
                case "ffd8ffe2":
                    type = "image/jpeg"; break;
                default:
                    reject({
                        title: Writable.text.shared_error_image_type_title,
                        message: Writable.text.shared_error_image_type
                    });
                    return;
            }

            resolve(file);
        };
        fileReader.readAsArrayBuffer(file);

    });
};

Writable.getImageWithCompression = function (file, settings, webWorker) {
    return new Promise(function (resolve, reject) {
        var options = {
            exifOrientation: 1,
            maxSizeMB: (settings.maxSizeMB) ? settings.maxSizeMB : 0.5,
            useWebWorker: webWorker,
            maxIteration: (settings.maxIteration) ? settings.maxIteration : 10
        }

        if (settings.maxWidthOrHeight) {
            if (settings.maxWidthOrHeight !== -1) {
                options.maxWidthOrHeight = settings.maxWidthOrHeight;
            }
        } else {
            options.maxWidthOrHeight = 400;
        }

        var maxCompressedSize = (options.maxSizeMB * 1024) * 1024;

        try {
            imageCompression(file, options)
                .then(function (compressed) {
                    if (compressed.type !== 'image/jpeg' &&
                        compressed.type !== 'image/png' &&
                        compressed.type !== 'image/gif') {
                        reject({
                            title: Writable.text.shared_error_image_type_title,
                            message: Writable.text.shared_error_image_type
                        });
                        return;
                    }

                    if (compressed.size > maxCompressedSize) {
                        reject({
                            title: Writable.text.shared_error_image_size_title,
                            message: Writable.text.shared_error_image_compressed_size
                        });
                        return;
                    }

                    resolve(compressed);
                })
                .catch(function (error) {
                    if (error instanceof Event && error.target && error.target.src && error.target.src.startsWith("data:image/heic;")) {
                        reject({
                            title: Writable.text.shared_error_image_type_title,
                            message: Writable.text.shared_error_image_heic_unsupported
                        });
                    } else if (error.message == "The file given is not an image") {
                        reject({
                            title: Writable.text.shared_error_image_type_title,
                            message: Writable.text.shared_error_image_invalid
                        });
                    } else {
                        Writable.getImageBasic(file, settings)
                            .then(function (data) {
                                resolve(data);
                            }).catch(function (error) {
                                reject(error);
                            });
                    }
                });
        } catch (err) {
            if (webWorker && file.size > maxCompressedSize) {
                Writable.getImageWithCompression(file, settings, false)
                    .then(function (data) {
                        resolve(data);
                    }).catch(function (error) {
                        reject(error);
                    });
            } else {
                Writable.getImageBasic(file, settings)
                    .then(function (data) {
                        resolve(data);
                    }).catch(function (error) {
                        reject(error);
                    });
            }
        }
    });
};

Writable.onImageChange = function (getFile, url, settings, beforeUpdate) {
    // Default to 1:40
    var minimumTime = 100000;
    var waitForCompletion = function (failureCheck, successCheck, timeout) {
        if (!timeout) {
            timeout = minimumTime;
        }
        var startTime = Date.now();
        return new Promise(function (waitResolve, waitReject) {
            var doWait = function () {
                setTimeout(function () {
                    if (failureCheck()) {
                        waitReject();
                    } else if (successCheck()) {
                        waitResolve();
                    } else if ((Date.now() - startTime) > timeout) {
                        console.log('Timed out waiting for image change after:', timeout);
                        waitReject();
                    } else {
                        doWait();
                    }
                }, 100);
            };
            doWait();
        });
    };

    return new Promise(function (resolve, reject) {
        try {
            var rejectionMessage;
            var actualFile;
            var presignedData;
            var scaniiData;

            // Obtain the image, either via compression or file reading.
            getFile()
                .then(function (file) {
                    if (beforeUpdate)
                        beforeUpdate();

                    actualFile = file;

                    // Need to send to Scanii
                    ScanFile.runCheck(actualFile)
                        .then(function (scanData) {
                            scaniiData = scanData;
                        })
                        .catch(function (error) {
                            if (error.statusCode === 413) {
                                rejectionMessage = {
                                    title: Writable.text.shared_error_image_size_title,
                                    message: Writable.text.shared_error_image_compressed_size
                                };
                            } else if (error.statusCode === 415) {
                                rejectionMessage = {
                                    title: Writable.text.shared_error_image_type_title,
                                    message: Writable.text.shared_error_image_invalid
                                };
                            } else if (error.findings !== undefined) {
                                rejectionMessage = {
                                    message: Writable.text.shared_error_image_scan_failure
                                };
                            } else {
                                console.log('Scanii returned error:', error);
                                rejectionMessage = {
                                    message: Writable.text.shared_error_image_general_failure
                                };
                            }
                        });
                })
                .catch(function (error) {
                    rejectionMessage = error;
                });

            // Need to make the request to get the presigned url
            var formData = new FormData();
            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false
            })
                .done(function (data, textStatus, jqXHR) {
                    presignedData = JSON.parse(data);
                })
                .fail(function (jqXHR) {
                    rejectionMessage = {
                        message: Writable.text.shared_error_image_general_failure
                    };
                });

            // The above can happen at the same time, need both completed before
            // can continue onto the rest
            waitForCompletion(function () {
                    return rejectionMessage;
                }, function () {
                    return presignedData && actualFile;
                })
                .then(function () {
                    var s3Upload;

                    // Need to send to S3
                    var taggingXml = '<Tagging><TagSet>' +
                        '<Tag><Key>User-Id</Key><Value>' + Writable.currentUserId + '</Value></Tag>';
                    if (settings.refId) {
                        taggingXml = taggingXml + '<Tag><Key>Ref-Id</Key><Value>' + settings.refId + '</Value></Tag>';
                    }
                    if (settings.refType) {
                        taggingXml = taggingXml + '<Tag><Key>Ref-Type</Key><Value>' + settings.refType + '</Value></Tag>';
                    }
                    taggingXml = taggingXml + '</TagSet></Tagging>';
                    var formData = new FormData();
                    var fields = presignedData.fields;
                    Object.keys(fields).forEach(function (value) {
                        formData.append(value, fields[value]);
                    });
                    formData.append('Content-Type', actualFile.type);
                    formData.append('tagging', taggingXml);
                    formData.append('file', actualFile);
                    $.ajax({
                        url: presignedData.url,
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: function (data, status, jqXHR) {
                            s3Upload = jqXHR;
                        },
                        error: function (jqXHR) {
                            if (jqXHR.status === 0) {
                                // Have been encountering a problem during local dev that gives a 0 Status response even
                                // though the POST has succeeded..
                                s3Upload = true;
                            } else {
                                rejectionMessage = {
                                    message: Writable.text.shared_error_image_general_failure
                                };
                            }
                        }
                    });

                    var waitTime = actualFile.size / 10;
                    if (waitTime < minimumTime) {
                        waitTime = minimumTime;
                    }
                    // The above can happen at the same time, need both completed before
                    // can send the all clear.
                    waitForCompletion(function () {
                        return rejectionMessage;
                    }, function () {
                        return scaniiData && s3Upload;
                    }, waitTime)
                        .then(function () {
                            if (settings.verifyUrl) {
                                $.post(settings.verifyUrl, JSON.stringify({
                                    length: actualFile.size,
                                    contentType: actualFile.type,
                                    imageId: presignedData.id,
                                    verificationId: scaniiData.id,
                                }))
                                    .done(function (data, textStatus, jqXHR) {
                                        if (!data) {
                                            data = { id: presignedData.id };
                                        }
                                        resolve(data);
                                    })
                                    .fail(function (jqXHR) {
                                        reject(jqXHR);
                                    });
                            }
                        })
                        .catch(function () {
                            if (rejectionMessage) {
                                reject(rejectionMessage);
                            } else {
                                reject({
                                    message: Writable.text.shared_error_image_general_failure
                                });
                            }
                        });
                })
                .catch(function () {
                    if (rejectionMessage) {
                        reject(rejectionMessage);
                    } else {
                        reject({
                            message: Writable.text.shared_error_image_general_failure
                        });
                    }
                });
        } catch (err) {
            console.log('Encountered Error:', err);
            reject({
                message: Writable.text.shared_error_image_general_failure
            });
        }
    });
};

Writable.nameUpdate = function (e, data) {
    const fn = data.firstName.trim();
    const ln = data.lastName.trim();
    let initials = '';
    if (fn.length > 0) {
        initials += fn[0];
    }
    if (ln.length > 0) {
        initials += ln[0];
    }

    const $avatar = $('#avatar');
    $avatar.find('button[data-toggle="dropdown"]').attr('title', `${fn}${fn && ln ? ' ' : ''}${ln}`);
    $avatar.find('.user-initials').text(initials.toUpperCase());
};

Writable.onAccountDetailsClick = function (e) {
    e.preventDefault();
    const $target = $(e.target).closest('.account-details[data-href]');
    const url = $target.attr('data-href');
    const $accountDetails = $('#accountDetailsOverlay');
    const $iframe = $accountDetails.find('.modal-body > iframe');
    $accountDetails.find('.modal-body > .busy').show();
    $accountDetails.modal({ show: true, backdrop: 'static' });
    $iframe.off('load', Writable.onAccountDetailsLoaded);
    $iframe.on('load', Writable.onAccountDetailsLoaded);

    setTimeout(function () {
        $iframe.get(0).contentWindow.location.replace(url);
    }, 0);
};

Writable.onAccountDetailsLoaded = function (e) {
    e.preventDefault();
    var $accountDetails = $('#accountDetailsOverlay');
    $accountDetails.find('.modal-body > .busy').hide();
};

Writable.onCloseAccountDetails = function (e) {
    var $accountDetails = $('#accountDetailsOverlay');
    var $frame = $accountDetails.find('.modal-body > iframe');
    if (0 === $frame.length) { return; }
    var frameDoc = ($frame.get(0).contentDocument || $frame.get(0).contentWindow.document);
    frameDoc.removeChild(frameDoc.documentElement);
    $frame.get(0).contentWindow.location.replace('about:blank');
    $accountDetails.modal('hide');
};

Writable.onCultureSelectionClick = function (e) {
    e.preventDefault();
    var $element = $(e.target).closest('.culture-selection');
    var url = '/Account/SetLocalizationCulture';
    var culture = $element.attr('data-culture');
    if (culture) {
        url += '?culture=' + culture;
    }
    $.post(url)
        .done(function () {
            location.reload();
        })
        .fail(function (jqXHR) {
            Writable.showRequestFailed(jqXHR, function () {
                location.reload();
            });
        });
};

Writable.updateUnreadMessages = function (messageCount) {
    var $badge = $('#support-button .badge');
    if (messageCount === 0) {
        $badge.text('');
        $badge.hide();
    } else {
        $badge.text(messageCount);
        $badge.show();
    }
};

Writable.ciEquals = function (a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a.localeCompare(b, undefined, { sensitivity: 'base' }) === 0;
}

// Asynchronously load non-critical css
window.loadCSS = function (e, t, n) {
    var i = window.document.createElement("link");
    var o = t || window.document.getElementsByTagName("script")[0];
    i.rel = "stylesheet";
    i.href = e;
    i.media = "only x";
    o.parentNode.insertBefore(i, o);
    setTimeout(function () { i.media = n || "all" })
};

if (!Math.mode) {
    Math.mode = function mode (args) {
        var ary, i, max, mode, str;
        ary = Array.prototype.slice.call(args);
        max = 0;
        mode = [];
        str = ary.sort();
        str = "~" + str.join('~~') + "~"
        str.replace(/(~\-?\d+~)\1*/g, function (a, b) {
            var m = a.length / b.length;
            if (max <= m) {
                if (max < m) { mode = []; max = m; }
                mode.push(+b.replace(/~/g, ""));
            }
        });
        // Not a true mode, but this can only return a single value so return the first
        return mode[0];
    }
}

if (!Math.average) {
    Math.average = function (args) {
        var result = 0;
        var argValues = Array.prototype.slice.call(args);
        if (0 === argValues.length) {
            return result;
        }
        var sum = 0;
        argValues.forEach(function (v) { sum += v; });
        result = sum / argValues.length;
        return result;
    };
}

if (!window.centerBSModals) {
    window.centerBSModals = function () {
        $(this).css('display', 'block');
        var $dialog = $(this).find(".modal-dialog"),
        offset = ($(window).height() - $dialog.height()) / 2,
        bottomMargin = parseInt($dialog.css('marginBottom'), 10);
        if (offset < bottomMargin) {
            offset = bottomMargin;
        }
        $dialog.css("margin-top", offset);
    }
}

if (!window.removeQueryParam) {
    window.removeQueryParam = function (url, paramName) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {
            var prefix = encodeURIComponent(paramName) + '=';
            var pars = urlparts[1].split(/[&;]/g);
            var values = [];

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    values.push(pars.splice(i, 1)[0].replace(prefix, ''));
                }
            }

            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return { url: url, removedValues: values };
        } else {
            return { url: url, removedValues: [] };
        }
    }
}

/// FROM https://blog.bitscry.com/2018/08/17/getting-and-setting-url-parameters-with-javascript/
if (!window.setUrlParameter) {
    window.setUrlParameter = function(url, key, value) {
        var key = encodeURIComponent(key),
            value = encodeURIComponent(value);

        var baseUrl = url.split('?')[0],
            newParam = key + '=' + value,
            params = '?' + newParam;

        if (url.split('?')[1] === undefined) { // if there are no query strings, make urlQueryString empty
            urlQueryString = '';
        } else {
            urlQueryString = '?' + url.split('?')[1];
        }

        // If the "search" string exists, then build params from it
        if (urlQueryString) {
            var updateRegex = new RegExp('([\?&])' + key + '=[^&]*');
            var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

            if (value === undefined || value === null || value === '') { // Remove param if value is empty
                params = urlQueryString.replace(removeRegex, "$1");
                params = params.replace(/[&;]$/, "");

            } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                params = urlQueryString.replace(updateRegex, "$1" + newParam);

            } else if (urlQueryString == '') { // If there are no query strings
                params = '?' + newParam;
            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam;
            }
        }

        // no parameter was set so we don't need the question mark
        params = params === '?' ? '' : params;

        return baseUrl + params;
    }
}

if (!window.setUrlParameters) {
    window.setUrlParameters = function (url, parameters) {
        $.each(parameters, function (key, value) {
            if (value !== undefined) {
                url = setUrlParameter(url, key, value);
            }
        });
        return url;
    };
}

// Enable Knockout deferred updates site-wide
ko.options.deferUpdates = true;
// Remove "_destroy" from default mapping includes
ko.mapping.defaultOptions().include = [];
ko.mapping.defaultOptions().ignore = ["id", "created", "modified", "ownerUserId"];

// Simple KO binding for showing a BS modal
ko.bindingHandlers.showModal = {
    init: function (element, valueAccessor) {
        var onHide = function (e) {
            var modal = ko.utils.unwrapObservable(valueAccessor());
            if (modal && modal.confirmClose) {
                e.preventDefault();
                modal.confirmClose();
            }
        };

        $(element).on('hide.bs.modal', onHide);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(element).off('hide.bs.modal', onHide);
        });
    },
    update: function (element, valueAccessor) {
        var modal = ko.utils.unwrapObservable(valueAccessor());
        $(element).modal(modal ? 'show' : 'hide');
    }
};

// KO binding for jQuery.timeago
ko.bindingHandlers.timeago = {
    init: function (element, valueAccessor, allBindings) {
        $(element).timeago();
    },
    update: function (element, valueAccessor) {
        const $element = $(element);
        const date = ko.unwrap(valueAccessor());
        $element.timeago('update', date);
        if (element.tagName.toLowerCase() === "time") {
            $element.attr("datetime", new Date(date).toISOString());
        }
    }
};

//override the knockstrap binding to allow custom classes on the tooltip.
ko.bindingHandlers.tooltip = {
    init: function (element) {
        var $element = $(element);

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if ($element.data('bs.tooltip')) {
                $element.tooltip('destroy');
            }
        });
    },

    update: function (element, valueAccessor) {
        var $element = $(element),
            value = ko.unwrap(valueAccessor()),
            options = ko.utils.unwrapProperties(value);

        if (options?.classes) {
            options.template = '<div class="tooltip ' + options.classes + '" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';
        }

        var tooltipData = $element.data('bs.tooltip');

        if (!tooltipData) {
            $element.tooltip(options);
        } else {
            ko.utils.extend(tooltipData.options, options);
        }
    }
};

Writable.getLocalizedText = function (text, values) {
    if (values.constructor !== Array) {
        values = [values];
    }
    for (var i = 0; i < values.length; ++i) {
        text = text.replace(new RegExp("\\{" + i + "\\}", 'g'), values[i]);
    }
    return text;
};

Writable.getLocalizedTextForElement = function ($source, values) {
    var text = null;
    if (values.constructor !== Array) {
        values = [values];
    }
    switch (values[0]) {
        case 0:
            text = $source.attr('data-localized-nil');
            break;
        case 1:
            text = $source.attr('data-localized-singular');
            break;
    }
    if (!text) {
        text = $source.attr('data-localized');
    }
    if (text) {
        return Writable.getLocalizedText(text, values);
    } else {
        console.log('Missing localization data on element:', $source.get(0));
    }
};

// Set element text to localized string
ko.bindingHandlers.localizeText = {
    update: function (element, valueAccessor) {
        var $element = $(element);
        var values = ko.unwrap(valueAccessor());
        $element.text(Writable.getLocalizedTextForElement($element, values));
    }
};

// Set element text to localized html
ko.bindingHandlers.localizeHtml = {
    update: function (element, valueAccessor) {
        var $element = $(element);
        var values = ko.unwrap(valueAccessor());
        $element.html(Writable.getLocalizedTextForElement($element, values));
    }
};

// Set element property to localized string
ko.bindingHandlers.localizeProp = {
    update: function (element, valueAccessor) {
        var $element = $(element);
        var config = ko.unwrap(valueAccessor());
        $element.prop(config.name, Writable.getLocalizedTextForElement($element, config.values));
    }
};

ko.bindingHandlers.lottieAnimation = {
    init: function (element, valueAccessor) {
        if (!lottie) {
            console.warn('Lottie library is not loaded');
            return;
        }
        let options = ko.unwrap(valueAccessor());
        options = {
            container: element,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: null,
            ...options
        };

        fetch(options.path)
            .then(response => response.json())
            .then(data => {
                options.animationData = data;
                const animation = lottie.loadAnimation(options);
                ko.utils.domData.set(element, 'lottieAnimation', animation);

                if (options.autoplay === false) {
                    animation.stop();
                }
            })
            .catch(error => console.error('Error loading Lottie JSON:', error));

        return { controlsDescendantBindings: true };
    }
}

ko.extenders.trim = function (target) {
    var result = ko.pureComputed({
        read: target,  //always return the original observables value
        write: function (newValue) {
            var current = target(),
                valueToWrite = newValue == null ? newValue : String(newValue).trim();
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else if (newValue !== current) {
                //trimmed value is the same but a different value was written, force a notification
                target.notifySubscribers(valueToWrite);
            }
        }
    }).extend({ notify: 'always' });
    //initialize with current value
    result(target());
    //return new computed observable
    return result;
};

ko.extenders.numeric = function (target, precision) {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.pureComputed({
        read: target,  //always return the original observables value
        write: function (newValue) {
            var current = target(),
                roundingMultiplier = Math.pow(10, precision),
                newValueAsNum = isNaN(newValue) ? 0 : +newValue,
                valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

            //only write if it changed
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                //if the rounded value is the same, but a different value was written, force a notification for the current field
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });
    //initialize with current value to make sure it is rounded appropriately
    result(target());
    //return the new computed observable
    return result;
};

ko.extenders.range = function (target, intRange) {
    //create a writeable computed observable to intercept writes to our observable
    var result = ko.computed({
        read: target,  //always return the original observables value
        write: function (newValue) {
            var current = target(),
                newValueAsNum = isNaN(newValue) ? 0 : parseInt(+newValue, 10),
                valueToWrite = newValueAsNum;

            if (newValueAsNum < intRange.min) {
                valueToWrite = intRange.min;
            }

            if (newValueAsNum > intRange.max) {
                valueToWrite = intRange.max;
            }

            //only write if it changed
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                //if the tested value is the same, but a different value was written, force a notification for the current field
                if (newValueAsNum !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
};

Writable.applyViewModelUpdate = function (target, data) {
    for (var key in data) {
        if (ko.isWritableObservable(target[key])) {
            target[key](data[key]);
        }
    }
};

window.setStorageString = function (storage, key, value) {
    if (typeof (Storage) !== "undefined") {
        try {
            storage.setItem(key, value);
        } catch (e) {
            console.log(e);
        }
    }
};

window.setLocalString = function (key, value) {
    return window.setStorageString(localStorage, key, value);
};

window.setSessionString = function (key, value) {
    return window.setStorageString(sessionStorage, key, value);
};

window.removeStorageString = function (storage, key) {
    if (typeof (Storage) !== "undefined") {
        try {
            storage.removeItem(key);
        } catch (e) {
            console.log(e);
        }
    }
};

window.removeLocalString = function (key) {
    return window.removeStorageString(localStorage, key);
};

window.removeSessionString = function (key) {
    return window.removeStorageString(sessionStorage, key);
};

window.setOrRemoveStorageString = function (storage, key, value) {
    if (value) {
        setStorageString(storage, key, value);
    } else {
        removeStorageString(storage, key);
    }
};

window.setOrRemoveLocalString = function (key, value) {
    return window.setOrRemoveStorageString(localStorage, key, value);
};

window.setOrRemoveSessionString = function (key, value) {
    return window.setOrRemoveStorageString(sessionStorage, key, value);
};

window.getStorageString = function (storage, key, defaultValue) {
    if (typeof (Storage) !== "undefined") {
        try {
            var value = storage.getItem(key);
            if (value !== null) {
                return value;
            }
        } catch (e) {
            console.log(e);
        }
    }
    return defaultValue;
};

window.getLocalString = function (key, defaultValue) {
    return window.getStorageString(localStorage, key, defaultValue);
};

window.getSessionString = function (key, defaultValue) {
    return window.getStorageString(sessionStorage, key, defaultValue);
};

window.clearStorageStrings = function () {
    if (typeof (Storage) !== "undefined") {
        try {
            localStorage.clear();
            sessionStorage.clear();
        } catch (e) {
            console.log(e);
        }
    }
};

window.getParameterByName = function (name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

window.removeParameterByName = function (name, url) {
    if (!url) {
        url = window.location.href;
    } 
    url = url.trim();
    if (null == name) {
        return url;
    }
    name = name.trim();
    if (0 === name.length) {
        return url;
    }
    if (-1 !== name.indexOf('?') || -1 !== name.indexOf('&')) {
        return url;
    }
    var paramIndex = url.indexOf(name);
    if (-1 === paramIndex) {
        return url;
    }
    var nextParamIndex = url.indexOf('&', paramIndex);
    // it's the last parameter in uri OR no characters follow the parameter's trailing '&'
    if (-1 === nextParamIndex || nextParamIndex >= url.length - 1) {
        if (0 === paramIndex) { // no characters precede the parameter
            return '';
        }

        var result = url.substr(0, paramIndex - 1); // remove the leading '?' or '&'
        return result;
    }
    var front = url.substr(0, paramIndex); // everything up to, and including the leading '?' or '&'
    var back = url.substr(nextParamIndex + 1); // all trailing parameters, without the first trailing param's '&'
    var result = front + back;
    return result;
};

window.inheritsFrom = function (subclass, superclass) {
    subclass.prototype = Object.create(superclass.prototype);
    subclass.prototype.constructor = subclass;
};

Function.prototype.inheritsFrom = function (parent) {
    this.prototype = Object.create(parent.prototype, {
        constructor: {
            value: this,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (Object.setPrototypeOf) {
        Object.setPrototypeOf(this, parent);
    } else {
        this.__proto__ = parent;
    }
    return this;
};

window.setTimeoutPromise = function (ms) {
    var p = new $.Deferred();
    window.setTimeout(function () { p.resolve(); }, ms);
    return p.promise();
};

window.regexEscape = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

window.safeRedirect = function (redirectUrl) {
    try {
        const url = new URL(redirectUrl, window.location.origin);
        //don't allow redirects outside of writable and protect against xss protocol attacks such as 'javascript:'
        if (url.origin !== window.location.origin || url.protocol !== window.location.protocol) window.location.href = window.location.origin;
        else window.location.href = url;
    } catch (error) {
        console.error(error);
        window.location.href = window.location.origin;
    }
}

window.escapeHTML = function (text) {
    return $('<span>').text(text).html();
};

Writable.initEventTracing = function () {
    let sessionEventTracingExpiration = window.getSessionString('event-tracing-expiration');
    if (sessionEventTracingExpiration) {
        let currentTokenExpiration = new Date(sessionEventTracingExpiration);
        if (currentTokenExpiration > (new Date())) {
            Writable.eventTracingEnabled = window.getSessionString('event-tracing') === 'true';
            return;
        }
    }

    $.get(Writable.kinesisCredsUrl).then(function (data) {
        if (!data) {
            Writable.eventTracingEnabled = false;
            window.setSessionString('event-tracing', Writable.eventTracingEnabled);
            return;
        }

        var expiration = new Date();
        expiration.setSeconds(expiration.getSeconds() + data.durationSeconds);

        window.setSessionString('event-tracing-region', data.region);
        window.setSessionString('event-tracing-access', data.accessKey);
        window.setSessionString('event-tracing-key', data.secretKey);
        window.setSessionString('event-tracing-session', data.sessionToken);
        window.setSessionString('event-tracing-stream', data.streamName);
        window.setSessionString('event-tracing-expiration', expiration);

        Writable.eventTracingEnabled = true;
        window.setSessionString('event-tracing', Writable.eventTracingEnabled);
    }).catch(function (err) {
        Writable.eventTracingEnabled = false;
        window.setSessionString('event-tracing', Writable.eventTracingEnabled);
    });
};

Writable.setUserHasImage = function (hasImage) {
    $('#avatar').toggleClass('has-image', hasImage ? true : false);
};

Writable.init = function (config) {
    Writable.hasWritableLogin = config.hasWritableLogin;
    Writable.hasAiToolsLogin = config.hasAiToolsLogin;
    Writable.usingAiToolsDomain = config.usingAiToolsDomain;
    Writable.currentUserId = config.userId;
    Writable.currentUserType = config.userType;
    Writable.settings = config.settings;
    Writable.text = config.text;
    ScanFile.init(config.scanTimeout);
    Writable.setUserHasImage(config.userHasImage);
    Writable.cookieOptions = location.protocol === 'https:' ? { sameSite: 'None', secure: true } : null;
    bootbox.setLocale(config.language);
    $.timeago.settings.localeTitle = true;
    $.timeago.settings.allowFuture = true;
    Writable.avatarVerifyUrl = config.avatarVerifyUrl;
    Writable.syncUrl = config.syncUrl;
    Writable.writingPreviewUrl = config.writingPreviewUrl;
    Writable.outlineUrl = config.outlineUrl;
    Writable.bridgesDashboardUrl = config.bridgesDashboardUrl;
    Writable.goalManageUrl = config.goalManageUrl;
    Writable.imageAddImageUrl = config.imageAddImageUrl;
    Writable.imageVerifyImageUrl = config.imageVerifyImageUrl;
    Writable.settingExchangeUserSettingUrl = config.settingExchangeUserSettingUrl;
    Writable.kinesisCredsUrl = config.kinesisCredsUrl;
    Writable.initEventTracing();
    Writable.logoutUrl = config.logoutUrl;
    Writable.generateBridgesJWTUrl = config.generateBridgesJWTUrl;
    Writable.confirmNavigationHandler = null;
    Writable.requiredWritableAIFeedbackAgreement = 'v1.0';
    Writable.mainScrollSelector = 'body > main';
    Writable.authCodeUrl = config.authCodeUrl;
    Writable.loginWithAuthCodeUrl = config.loginWithAuthCodeUrl;
    Writable.writableBaseUrl = config.writableBaseUrl;
    Writable.aiToolsBaseUrl = config.aiToolsBaseUrl;
    if (config.userId) {
        Writable.currentUser = {
            id: config.userId,
            type: config.userType,
            hasImage: config.userHasImage,
            hasGoogleAuth: config.hasGoogleAuth,
            primaryGoogleEmail: config.primaryGoogleEmail,
            email: config.userEmail,
            firstName: config.userFirstName,
            lastName: config.userLastName
        };
    }
};

Writable.parentWritable = function () {
    try {
        if (window.parent && window.parent !== window && window.parent.Writable) {
            return window.parent.Writable;
        }
    }
    catch (error) { }
}();
Writable.outerWindow = function () {
    try {
        return Writable.parentWritable ? Writable.parentWritable.outerWindow : window;
    }
    catch (error) { return window; }
}();


var _isMobile = null;
Writable.isMobile = function () {
    if (_isMobile === null) {
        var ua = window.navigator.userAgent.toUpperCase();
        _isMobile = -1 !== ua.indexOf('MOBILE');
    }
    return _isMobile;
};

var _isIE = null;
Writable.isIE = function () {
    // returns version of IE or false
    if (_isIE === null) {
        _isIE = function () {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }
            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }
            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }
            return false;
        }();
    }
    return _isIE;
};

var _isSafari = null;
Writable.isSafari = function () {
    if (_isSafari === null) {
        _isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
    }
    return _isSafari;
};

Writable.isSafariOnIPad = function () {
    if (!Writable.isSafari() || !window.screen) {
        return false;
    }

    // https://ios-resolution.com/
    var iPadDimensions = [
        [1024, 1366],
        [834, 1194],
        [810, 1080],
        [820, 1180],
        [768, 1024],
        [834, 1112],
    ];

    return iPadDimensions.some(function (dimension) {
        return (dimension[0] === window.screen.width && dimension[1] === window.screen.height)
            || (dimension[1] === window.screen.width && dimension[0] === window.screen.height);
    });
};

Writable.isPortrait = function () {
    return window.innerWidth < window.innerHeight;
};

Writable.isLandscape = function () {
    return !Writable.isPortrait();
};

Writable.showRequestFailed = function (jqXHR, callback, onReload) {
    var isAntiforgeryError = false;
    try { isAntiforgeryError = jqXHR && jqXHR.status === 401 && (jqXHR.statusText === "AntiforgeryValidationFailed" || jqXHR.responseText === "AntiforgeryValidationFailed"); } catch (ex) { }
    if (isAntiforgeryError) {
        bootbox.confirm({
            title: Writable.text.shared_request_failed_antiforgery_title,
            message: Writable.text.shared_request_failed_antiforgery_message,
            animate: false,
            buttons: {
                confirm: {
                    label: 'Reload'
                },
                cancel: {
                    label: 'Cancel'
                }
            },
            callback: function (result) {
                if (result) {
                    if (onReload) {
                        onReload();
                    }
                    location.reload();
                }
            }
        });
    }
    else {
        if (jqXHR && jqXHR.responseText) {
            console.error(jqXHR.responseText);
        }
        bootbox.alert({
            title: Writable.text.shared_request_failed_title,
            message: Writable.text.shared_request_failed_message,
            closeButton: false,
            animate: false,
            callback: callback
        });
    }
};

Writable.isGoogleAccount = function () {
    var deferred = $.Deferred();

    $.get('/account/isgoogleaccount')
        .done(function () {
            deferred.resolve();
        })
        .fail(function (jqXHR) {
            deferred.reject(jqXHR);
        });

    return deferred;
};

Writable.googleAccessToken = null;

Writable.isUnauthorizedErrorResponse = function (jqXHR) {
    return jqXHR && 401 === jqXHR.status && jqXHR.responseText &&
        -1 !== jqXHR.responseText.indexOf('It appears you do not have access to the data on this page.');
};

Writable.checkUnauthorizedReauth = function (jqXHR, result, deferred, authType, userEmail, onShowingAuthUi) {
    if (Writable.isUnauthorizedErrorResponse(jqXHR)) {
        result.isAuthProblem = true;

        if (onShowingAuthUi) {
            onShowingAuthUi(result);
        }
        Writable.showLoginRequired(authType, userEmail)
            .done(function () {
                result.isReauthComplete = true;
                deferred.resolve(result); // the user re-authed successfully
            })
            .fail(function () {
                deferred.resolve(result); // the user opted not to deal with auth
            });
    } else {
        deferred.resolve(result);
    }
};

Writable.checkGoogleReauth = function (jqXHR, userEmail, additionalScope, optionalUserType, onShowingAuthUi) {
    var deferred = $.Deferred();

    var result = {
        isAntiforgeryError: false,          // it's an antiforgery validation error - nothing to do with Google
        isGoogleError: false,               // is it a valid gError? (...or an error unrelated to google specifically)
        isGoogleAccount: false,             // is the user connected to a Google account?
        isAuthProblem: false,               // is it a recognized auth error code or message?
        isReauthComplete: false,            // has the user reauthed?
        isClassroomAccessDisabled: false,   // The requesting user does not have access to gClassroom. Possible Action: Direct the user to instructions on enabling Classroom access.
        isDomainDriveAppsDisabled: false    // The domain administrators have disabled Drive apps.
    };

    try { result.isAntiforgeryError = jqXHR && jqXHR.status === 401 && (jqXHR.statusText === "AntiforgeryValidationFailed" || jqXHR.responseText === "AntiforgeryValidationFailed"); } catch (ex) { }
    if (result.isAntiforgeryError) {
        deferred.resolve(result);
        return deferred;
    }

    if (null == jqXHR || null == jqXHR.responseJSON || null == jqXHR.responseJSON.googleError) { // if (missing error information)
        if (jqXHR && jqXHR.responseText && (
            -1 !== jqXHR.responseText.indexOf('user not authorized to perform that action') ||
            -1 !== jqXHR.responseText.indexOf('Canvas native access-token has expired') ||
            -1 !== jqXHR.responseText.indexOf('Missing Canvas native access-token')
        )) {
            // NOTE: This is missing permission for a Canvas user. Is the Canvas user still part of the course?
            deferred.resolve(result);
            return deferred;
        }

        Writable.isGoogleAccount() // does the user have a Google account?
            .done(function () {
                result.isGoogleAccount = true;

                if (null == jqXHR || (401 !== jqXHR.status && 403 !== jqXHR.status)) {
                    deferred.resolve(result);
                    return;
                }

                if (401 === jqXHR.status) {
                    if (null == jqXHR.responseText ||
                        -1 === jqXHR.responseText.indexOf('Request had invalid authentication credentials')) {
                        deferred.resolve(result);
                        return;
                    }
                }

                // user has a google account, but likely no token
                result.isGoogleError = true;
                result.isAuthProblem = true;

                if (onShowingAuthUi) {
                    onShowingAuthUi(result);
                }
                Writable.showLoginRequired('Google', userEmail, additionalScope, optionalUserType)
                    .done(function () {
                        result.isReauthComplete = true;
                        deferred.resolve(result); // the user re-authed successfully
                    })
                    .fail(function () {
                        deferred.resolve(result); // the user opted not to deal with auth
                    });
            })
            .fail(function (accountXHR) {
                if (Writable.currentUser && Writable.currentUser.hasGoogleAuth &&
                    Writable.isUnauthorizedErrorResponse(accountXHR)) {
                    result.isGoogleAccount = true;
                    Writable.checkUnauthorizedReauth(jqXHR, result, deferred, 'Google', userEmail, onShowingAuthUi);
                } else {
                    deferred.resolve(result);
                }
            });

        return deferred;
    }

    result.isGoogleAccount = true;
    result.isGoogleError = true;

    var googleError = jqXHR.responseJSON.googleError;
    var isInsufficientPermissions = false;

    if (403 === googleError.code) {
        result.isClassroomAccessDisabled = -1 !== googleError.message.indexOf('ClassroomDisabled');
        var isApiDisabled = -1 !== googleError.message.indexOf('ClassroomApiDisabled');
        var isMissingScope = -1 !== googleError.message.indexOf('insufficient authentication scope') ||
            -1 !== googleError.message.indexOf('Insufficient Permission') ||
            -1 !== googleError.message.indexOf('caller does not have permission') ||
            -1 !== googleError.message.indexOf('write access to the file');

        result.isDomainDriveAppsDisabled = -1 !== googleError.message.indexOf('domain administrators have disabled Drive apps');

        if (isApiDisabled || isMissingScope) {
            isInsufficientPermissions = true;
        }
    }

    if (result.isDomainDriveAppsDisabled) { // if (school or district Google domain administrator has disabled gDrive apps)
        if (onShowingAuthUi) {
            onShowingAuthUi(result);
        }
        // Let the user know what the problem is.
        bootbox.alert({
            title: "Oops!",
            message: 'It looks like school&rsquo;s Google administrator has disabled Google Drive apps for your account. Please ask your teacher or school administrator for help. For more information, contact the Writable team.',
            animate: false,
            backdrop: true
        });

        // There's nothing Writable can do to fix the problem for the user; other than offer instructions.
        deferred.resolve(result);
        return deferred;
    }

    if (result.isClassroomAccessDisabled) { // if (Google Classroom isn't enabled for the account)
        if (onShowingAuthUi) {
            onShowingAuthUi(result);
        }
        // Direct the user to instructions on enabling Classroom access.
        bootbox.alert({
            title: "Oops!",
            message: 'It looks like Google Classroom may not be enabled for your Google account. Please enable <a href="https://classroom.google.com" target="_blank">Google Classroom</a> and try again. If the problem continues, contact the Writable team.',
            animate: false,
            backdrop: true
        });

        // There's nothing Writable can do to fix the problem for the user; other than offer instructions.
        deferred.resolve(result);
        return deferred;
    }

    if (401 === googleError.code || isInsufficientPermissions) {
        result.isAuthProblem = true;

        if (onShowingAuthUi) {
            onShowingAuthUi(result);
        }
        Writable.showLoginRequired('Google', userEmail, additionalScope, optionalUserType)
            .done(function () {
                result.isReauthComplete = true;
                deferred.resolve(result); // the user re-authed successfully
            })
            .fail(function () {
                deferred.resolve(result); // the user opted not to deal with auth
            });

        return deferred;
    }

    deferred.resolve(result);
    return deferred;
};

Writable.isCanvasAccount = function () {
    var deferred = $.Deferred();

    $.get('/account/iscanvasaccount')
        .done(function (data) {
            deferred.resolve(data);
        })
        .fail(function () {
            deferred.reject();
        });

    return deferred;
};

Writable.checkCanvasReauth = function (jqXHR, userEmail, additionalScope, optionalUserType, onShowingAuthUi) {
    var deferred = $.Deferred();

    var result = {
        isAntiforgeryError: false,          // it's an antiforgery validation error - nothing to do with Canvas
        isCanvasLtiAdvAccount: false,       // is the user connected to an LTIAdv:Canvas account?
        isCanvasNativeAccount: false,       // is the user connected to a Native Canvas account?
        isCanvasNativeAvailable: false,     // is a Native Canvas account possible for this user?
        isCanvasPermissionError: false,     // did the user fail to have a required Canvas permission?
        isAuthProblem: false,               // is it a recognized auth error code or message?
        isReauthComplete: false             // has the user reauthed?
    };

    try {
        result.isAntiforgeryError = jqXHR && jqXHR.status === 401 &&
            (jqXHR.statusText === "AntiforgeryValidationFailed" || jqXHR.responseText === "AntiforgeryValidationFailed");
    }
    catch (ex) { }
    if (result.isAntiforgeryError) {
        deferred.resolve(result);
        return deferred;
    }

    if (null == jqXHR || !(401 === jqXHR.status || 403 === jqXHR.status || 440 === jqXHR.status)) {
        deferred.resolve(result);
        return deferred;
    }

    if (null != jqXHR.responseText) {
        try {
            var canvasError = JSON.parse(jqXHR.responseText);

            if (null != canvasError.errors && null != canvasError.errors[0]) {
                result.isCanvasNativeAccount = true;
                result.isCanvasNativeAvailable = true;
                result.isCanvasPermissionError = 'user not authorized to perform that action' === canvasError.errors[0].message;
                deferred.resolve(result);
                return deferred;
            }
        }
        catch (ex) { }
    }

    Writable.isCanvasAccount() // does the user have a Canvas native account?
        .done(function (data) {
            if (null == data) {
                deferred.resolve(result);
                return deferred;
            }

            result.isCanvasLtiAdvAccount = data.ltiAdvAccount;
            result.isCanvasNativeAccount = data.nativeAccount;
            result.isCanvasNativeAvailable = data.isNativeAvailable;

            // user has a canvas account, but likely no token
            result.isAuthProblem = true;

            if (!result.isCanvasNativeAvailable) {
                deferred.resolve(result);
                return deferred;
            }

            if (onShowingAuthUi) {
                onShowingAuthUi(result);
            }

            Writable.showLoginRequired('Canvas', userEmail, additionalScope, optionalUserType)
                .done(function () {
                    result.isReauthComplete = true;
                    deferred.resolve(result); // the user re-authed successfully
                })
                .fail(function () {
                    deferred.resolve(result); // the user opted not to deal with auth
                });
        })
        .fail(function () {
            deferred.resolve(result);
        });

    return deferred;
};

Writable.showingLoginPopup = false;
Writable.loginRequiredPromise = null;
Writable.loginPopup = null;

Writable.showLoginPopup = function (provider, isReauth, optionalScope, userType, returnUrl, isPreAuth, additive, loginHint, hostedDomain) {
    if (Writable.showingLoginPopup) {
        return $.Deferred().reject();
    }

    Writable.showingLoginPopup = true;
    var promise = $.Deferred();

    var w = 800;
    var h = 700;
    var x = Math.max((window.outerWidth / 2) + window.screenX - (w / 2), 0);
    var y = Math.max((window.outerHeight / 2) + window.screenY - (h / 2), 0);
    const isHmh = 'HmhEds' === provider;
    const path = (isReauth) ? '/reauth' :
        (isHmh) ? '/eds-login' : '/provider-login';
    var scope = (!optionalScope) ? '' : '&scope=' + encodeURIComponent(optionalScope);
    var userRole = (!userType && !Writable.currentUserType) ? '' : '&selectedUserType=' + (userType || Writable.currentUserType);
    var isPreAuth = (!isPreAuth || isReauth) ? '' : '&isPreAuth=true';
    var isAuthAdd = (additive) ? '&isAdditive=true' : '';
    var loginHint = loginHint && '' != loginHint ? '&loginHint=' + loginHint : '';
    var hostedDomain = hostedDomain && '' != hostedDomain ? '&hostedDomain=' + hostedDomain : '';

    if (Writable.isIE()) {
        var url = path +
            '?provider=' + provider +
            userRole +
            '&returnUrl=' + encodeURIComponent(returnUrl && returnUrl.length > 0 ? returnUrl : window.location.pathname + window.location.search) +
            scope +
            isPreAuth +
            isAuthAdd +
            loginHint +
            hostedDomain;

        window.location.href = url;
    } else { // not IE
        var url = path +
            '?provider=' + provider +
            userRole +
            '&returnUrl=/popoutcloser' + (returnUrl && returnUrl.length > 0 ? encodeURIComponent('?returnUrl=' + returnUrl) : '') +
            scope +
            isPreAuth +
            isAuthAdd +
            loginHint +
            hostedDomain;

        // Briefly suspend focus handling to address extra clicks and oddness with mobile safari
        Writable.loginPopupIgnoreFocus = true;
        Writable.loginPopup = window.open(
            url,
            'login-required',
            'width=' + w + ',height=' + h + ',top=' + y + ',left=' + x
        );
        setTimeout(function () { Writable.loginPopupIgnoreFocus = false }, (Writable.isSafari() ? 500 : 250));
    }

    window.loginCompleted = false;

    var onReceiveMessage = function (event) {
        if (event.origin !== location.origin) {
            if ((!location.origin || location.origin === 'null') && location.href === 'about:srcdoc' && Writable.outerWindow) {
                if (Writable.outerWindow.location.origin !== event.origin) {
                    return;
                }
            } else {
                return;
            }
        }

        var message = event.data;
        if (message.event === 'onPopoutClose') {
            if (message.status >= 400) {
                window.loginError = message.status;
            } else {
                Writable.googleAccessToken = message.accessToken;
                window.loginCompleted = true;
            }
            Writable.loginPopup.close();
        }
    };
    window.addEventListener("message", onReceiveMessage, false);

    var onFocus = function (event) {
        if (Writable.loginPopupIgnoreFocus === true) { return; }
        setTimeout(function () {
            if (Writable.loginPopup && !Writable.loginPopup.closed) {
                Writable.loginPopup.close();
            }
        }, 250);
    };
    window.addEventListener("focus", onFocus, false);

    var closedtest = setInterval(function () {
        if (!Writable.loginPopup || !Writable.loginPopup.closed) {
            return;
        }

        clearInterval(closedtest);
        Writable.showingLoginPopup = false;
        window.removeEventListener("focus", onFocus, false);
        window.removeEventListener("message", onReceiveMessage, false);
        Writable.loginPopup = null;

        if (!window.loginCompleted) {
            promise.reject(window.loginError);
            return;
        }

        if (null === Writable.currentUserId) {
            promise.resolve();
            return;
        }

        var postAuthUser;

        $.get('/Account/GetId')
            .done(function (data) {
                postAuthUser = data;
            })
            .always(function () {
                if (postAuthUser === Writable.currentUserId) {
                    promise.resolve();
                    return;
                }

                promise.reject();
                Writable.ignoreUnsavedChanges = true;
                bootbox.alert({
                    title: "Not The Same User",
                    message: "Sorry, it looks like you re-authenticated with a different user than you were logged in as before. We'll have to redirect you now.",
                    closeButton: false,
                    animate: false,
                    callback: function () { Writable.outerWindow.location.href = '/'; }
                });
            });
    }, 500);

    return promise;
};

Writable.showLoginRequired = function (provider, userEmail, additionalScope, optionalUserType, optionalOverrideMessage) {
    /*TODO:
     * UPDATE: This has been updated with the 'provider' argument and now supports Canvas native auth.
     *
     * ORIGINAL:
     * This flow currently assumes a Google auth is required. In most cases that will be correct, but it isn't a given.
     * In order to not send the user back through the initial login page (choose user type, login method, etc) logic
     * is needed to determine the means by which the user originally authenticated and whether this is a reauth to
     * gain additional OAuth scope or is due to an expired authentication.
     */
    if (!provider) {
        if (Writable.currentUser && Writable.currentUser.hasGoogleAuth) {
            provider = 'Google';
        }
    }

    if (Writable.loginRequiredPromise) {
        return Writable.loginRequiredPromise;
    }

    Writable.loginRequiredPromise = $.Deferred();

    if (!provider && !additionalScope) {
        // No provider that we can use, prompt them to save
        bootbox.confirm({
            title: Writable.text.shared_request_login_redirect_title,
            message: Writable.text.shared_request_login_redirect_message,
            buttons: {
                cancel: { label: Writable.text.shared_verb_cancel },
                confirm: { label: Writable.text.shared_verb_confirm }
            },
            callback: function (result) {
                // Always reset ourself, and indicate to caller we have failed.
                Writable.loginRequiredPromise.reject();
                Writable.loginRequiredPromise = null;
                if (!result) {
                    return;
                }

                var logoutUrl = setUrlParameter(Writable.logoutUrl, 'returnUrl', Writable.outerWindow.location.pathname + Writable.outerWindow.location.search);
                Writable.outerWindow.location.href = logoutUrl;
            }
        });

        return Writable.loginRequiredPromise;
    }

    var requestLogin = function (optionalScope) {
        var title = Writable.text.shared_request_login_title;
        var message = Writable.text.shared_request_login_message;

        if ('Canvas' === provider) {
            title = Writable.text.shared_request_login_canvas_title;
            message = Writable.text.shared_request_login_canvas_message;
        } else if (optionalScope) {
            title = Writable.text.shared_request_login_scope_title;
            message = Writable.text.shared_request_login_scope_message;
        }

        if (provider === 'Google' && Writable.currentUser && Writable.currentUser.primaryGoogleEmail) {
            userEmail = Writable.currentUser.primaryGoogleEmail;
        }

        var currentUserHtml = userEmail ? ('</br></br>' + Writable.getLocalizedText(Writable.text.shared_request_login_identify_user, userEmail)) : '';
        if (optionalOverrideMessage) {
            message = optionalOverrideMessage;
            currentUserHtml = "";

        }
        var confirmLabel = optionalScope ? Writable.text.shared_request_login_scope_confirm : Writable.text.shared_request_login_confirm;

        bootbox.confirm({
            title: title,
            message: message + currentUserHtml,
            buttons: {
                cancel: { label: 'Cancel' },
                confirm: { label: confirmLabel }
            },
            closeButton: false,
            callback: function (result) {
                if (!result) {
                    Writable.loginRequiredPromise.reject();
                    Writable.loginRequiredPromise = null;
                    return;
                }

                Writable.showLoginPopup(provider, true, optionalScope, optionalUserType)
                    .done(function () {
                        Writable.loginRequiredPromise.resolve();
                    })
                    .fail(function () {
                        Writable.loginRequiredPromise.reject();
                    })
                    .always(function () {
                        Writable.loginRequiredPromise = null;
                    });
            }
        });
    };

    if (null == additionalScope) {
        requestLogin();
    } else {
        if ('Google' === provider) {
            $.get('/Account/RequestGoogleScope?requestedScope=' + additionalScope + "&selectedUserType=" + optionalUserType)
                .done(function (data) {
                    requestLogin(data);
                })
                .fail(function () {
                    Writable.loginRequiredPromise.reject();
                    Writable.loginRequiredPromise = null;
                });
        } else {
            console.log('ERROR: Unable to aquire additional security scope for ' + provider);
            requestLogin();
        }
    }

    return Writable.loginRequiredPromise;
};

Writable.openProviderLogin = function (provider, userType, scope, returnUrl, isPreAuth) {
    return Writable.showLoginPopup(provider, false, scope, userType, returnUrl, isPreAuth);
};

Writable.getNumericScore = function (scoreType, numericScoring, score) {
    var s0 = numericScoring[0];
    score = Math.min(score, numericScoring[numericScoring.length - 1]);
    for (var i = 1; i < numericScoring.length; ++i) {
        var s1 = numericScoring[i];
        if (s0 < s1 && score >= s0 && score <= s1) {
            return (scoreType === 'Z' ? i - 1 : i) + ((score - s0) / (s1 - s0));
        }
        s0 = s1;
    }
    return 0;
};

Writable.getNumericGoalScoring = function (scoring) {
    return scoring && (scoring.scoreType === 'Z' || scoring.scoreType === 'S') && scoring.numericScoring && scoring.numericScoring.length > 1 ? scoring.numericScoring : null;
};

Writable.getNormalizedScore = function (scoring, minScore, maxScore, score) {
    var numericScoring = Writable.getNumericGoalScoring(scoring);
    if (numericScoring) {
        var numeric = Writable.getNumericScore('S', numericScoring, score);
        var initial = minScore >= numericScoring[0] ? 1 : 0;
        return (numeric - initial) / Math.max(1, numericScoring.length - initial) * 100;
    } else {
        return (Math.max(minScore, Math.min(score, maxScore)) - minScore) / (maxScore - minScore) * 100;
    }
};

Writable.getPointsText = function (score, maximumPoints, adjustPrecision) {
    var raw = Math.min(score / 100 * maximumPoints, maximumPoints);
    var candidate = raw.toFixed(2);
    if (adjustPrecision && !/^\d+\.(25|33|66|75)$/.test(candidate)) {
        return parseFloat(raw.toFixed(1)).toString();
    }
    return candidate;
};

Writable.getChoiceScoreText = function (scoring, score, maximumPoints) {
    if (score == null) {
        return '';
    }
    if (scoring && scoring.scoreType === 'T' && maximumPoints > 0) {
        return Writable.getLocalizedText(Writable.text.shared_scoring_choice_points, Writable.getPointsText(score, maximumPoints, true));
    }
    return Writable.getScoreText(scoring, score, maximumPoints);
};

Writable.getAdjustedPercentageScore = function (score, scoreBase) {
    return scoreBase > 0 && scoreBase < 100 ? Math.round(scoreBase + (Math.max(0, Math.min(score, 100)) / 100) * (100 - scoreBase)) : Math.round(score);
};

Writable.getScoreText = function (scoring, score, maximumPoints, forceDecimalPoints) {
    if (score == null) {
        return '';
    }
    if (scoring) {
        switch (scoring.scoreType) {
            case 'P':
                return Writable.getAdjustedPercentageScore(score, scoring.scoreBase) + '%';
            case 'Z':
            case 'S':
                if (scoring.numericScoring) {
                    return Writable.getNumericScore(scoring.scoreType, scoring.numericScoring, score).toFixed(1);
                }
                break;
            case 'T':
                if (maximumPoints > 0) {
                    return Writable.getLocalizedText(Writable.text.shared_scoring_x_of_y_points, [Writable.getPointsText(score, maximumPoints, !forceDecimalPoints), maximumPoints]);
                }
                break;
        }
    }

    return score + '%';
};

Writable.recordAjaxError = function (context, jqXHR) {
    try {
        if (typeof (newrelic) == "undefined" || null == newrelic) { return; }

        var errorMessage = String(jqXHR.status) + ' - ' + jqXHR.statusText + ' => ' + context;

        if (jqXHR.responseText && jqXHR.responseText.length > 0 && jqXHR.responseText.length < 512) {
            errorMessage += ' \n' + jqXHR.responseText;
        }

        // Record the error with NewRelic (eventually)
        newrelic.noticeError(new Error(errorMessage));
    }
    catch (err) { /* ignore all errors */ }
};

Writable.recordException = function (err) {
    try {
        if (typeof (newrelic) == "undefined" || null == newrelic) { return; }
        // Record the error with NewRelic (eventually)
        newrelic.noticeError(err);
    }
    catch (err) { /* ignore all errors */ }
};

Writable.AutosaveEntry = function (observable, onRequest, rateLimitTimeout, onError, context) {
    var self = this;
    var version = ko.observable(0);
    var saved = ko.observable(version());
    var dirtyTimeout = null;
    var maxDirtyTime = null;
    var maxDirtyTimeout = null;
    var save = function (value) {
        try {
            var current = version();
            var completed = function () {
                saved(current);
                self.trigger();
            };
            var xhr = onRequest(value);
            if (xhr) {
                var request = {};
                self.saving(request);
                var forcedTimeout = setTimeout(function () {
                    if (request === self.saving()) {
                        onError(null, new Error('Autosave: Forced timeout triggered (' + self.context + ')'));
                        self.saving(null);
                    }
                }, Writable.settings.forcedAutosaveTimeout);
                xhr.done(function () {
                    if (request === self.saving()) {
                        self.saving(null);
                        completed();
                    }
                }).fail(function (jqXHR) {
                    if (request === self.saving()) {
                        onError(jqXHR);
                        self.saving(null);
                    }
                }).always(function () {
                    clearTimeout(forcedTimeout);
                });
            } else {
                completed();
            }
        }
        catch (e) {
            console.log(e);
            onError(null, e);
            self.saving(null);
        }
    };
    self.context = context;
    self.saving = ko.observable(null);
    self.hasUnsavedChanges = ko.pureComputed(function () {
        return version() !== saved();
    });
    self.trigger = function () {
        if (dirtyTimeout !== null) {
            clearTimeout(dirtyTimeout);
            dirtyTimeout = null;
        }
        if (maxDirtyTimeout !== null) {
            clearTimeout(maxDirtyTimeout);
            maxDirtyTimeout = null;
        }
        try {
            if (self.hasUnsavedChanges() && !self.saving()) {
                save(observable());
            }
        }
        catch (e) {
            onError(null, e);
            self.saving(null);
        }
    };
    self.setMaxDirtyTime = function (ms) {
        maxDirtyTime = ms;
    };
    self.subscription = observable.subscribe(function () {
        version(version() + 1);
        clearTimeout(dirtyTimeout);
        dirtyTimeout = setTimeout(function () {
            dirtyTimeout = null;
            self.trigger();
        }, rateLimitTimeout ?? 1000);
        if (maxDirtyTime > 0 && maxDirtyTimeout === null) {
            maxDirtyTimeout = setTimeout(function () {
                maxDirtyTimeout = null;
                self.trigger();
            }, maxDirtyTime);
        }
    });
};

Writable.AutosaveManager = function () {
    var self = this;
    self.entries = ko.observableArray();
    self.active = true;
    var displayError = function () {
        bootbox.confirm({
            title: Writable.text.shared_autosave_failed_title,
            message: Writable.text.shared_autosave_failed_message,
            closeButton: false,
            buttons: {
                cancel: { label: Writable.text.shared_verb_cancel },
                confirm: { label: Writable.text.shared_verb_retry }
            },
            callback: function (result) {
                self.active = true;
                if (result) {
                    self.trigger();
                }
            }
        });
    };
    var onError = function (jqXHR, err) {
        if (jqXHR) {
            var currentEntry = self.entries().find(function (entry) { return entry.saving(); });
            var msg = currentEntry ? 'Autosave (' + currentEntry.context + ')' : 'Autosave';
            Writable.recordAjaxError(msg, jqXHR);
        }
        if (err) {
            Writable.recordException(err);
        }
        if (self.active) {
            self.active = false;
            if (jqXHR && jqXHR.status === 401) {
                var isAntiforgeryError = false;
                try { isAntiforgeryError = jqXHR.statusText === "AntiforgeryValidationFailed" || jqXHR.responseText === "AntiforgeryValidationFailed"; } catch (ex) { }
                if (isAntiforgeryError) {
                    self.active = true;
                    $.get('/Home/About')
                        .done(function (data) {
                            if (data) {
                                var antiForgeryToken = $(data).find('input[name="__RequestVerificationToken"]').eq(0).val();
                                $(document.body).find('> form > input[name="__RequestVerificationToken"]').val(antiForgeryToken);
                            }
                        })
                        .always(function () {
                            self.trigger();
                        });
                    return;
                }
                Writable.showLoginRequired()
                    .done(function () {
                        self.active = true;
                        self.trigger();
                    })
                    .fail(function () {
                        displayError();
                    });
            } else {
                displayError();
            }
        }
    };
    self.add = function (observable, onRequest, timeout, context) {
        var entry = new Writable.AutosaveEntry(observable, onRequest, timeout, onError, context);
        self.entries.push(entry);
        return entry;
    };
    self.remove = function (entry) {
        if (entry) {
            self.entries.remove(entry);
            entry.subscription.dispose();
        }
    };
    self.trigger = function () {
        self.entries().forEach(function (entry) {
            entry.trigger();
        });
    };
    self.hasUnsavedChanges = ko.pureComputed(function() {
        return self.entries().some(function (entry) {
            return entry.hasUnsavedChanges();
        });
    });
    self.executeOnChangesSaved = function (callback) {
        // Ensure observables have had a chance to fire
        setTimeout(function () {
            if (self.hasUnsavedChanges()) {
                const subscription = self.hasUnsavedChanges.subscribe(function () {
                    subscription.dispose();
                    callback();
                });
                Writable.autosave.trigger();
            } else {
                callback();
            }
        });
    };
};

Writable.autosave = new Writable.AutosaveManager();

Writable.autosaveOnBeforeUnload = function (e) {
    Writable.autosave.trigger();
    if (Writable.autosave.hasUnsavedChanges() && Writable.ignoreUnsavedChanges !== true) {
        var message = Writable.text.shared_autosave_before_unload;
        e.returnValue = message; // Gecko, Trident, Chrome 34+
        return message; // Gecko, WebKit, Chrome <34
    }
};

Writable.writeEventTrace = function (getBody) {
    if (Writable.eventTracingEnabled !== true) {
        return;
    }

    var expiration = new Date(window.getSessionString('event-tracing-expiration'));
    if (expiration <= (new Date())) {
        Writable.initEventTracing();
    }

    try {
        var region = window.getSessionString('event-tracing-region');
        var accessKeyId = window.getSessionString('event-tracing-access');
        var secretAccessKey = window.getSessionString('event-tracing-key');
        var sessionToken = window.getSessionString('event-tracing-session');
        var stream = window.getSessionString('event-tracing-stream');

        // Make the call to Firehose
        var firehose = new AWS.Firehose({
            apiVersion: '2015-08-04',
            endpoint: 'firehose.' + region + '.amazonaws.com',
            region: region,
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey,
            sessionToken: sessionToken
        });

        var body = getBody();
        if (Writable.currentUserId !== null) {
            body.user_id = Writable.currentUserId
            body.is_basic_user = $(document).find('body').hasClass('basic-user');
        }
        body.timestamp = new Date();
        body.event_id = uuid.v4();
        var params = {
            DeliveryStreamName: stream,
            Record: {
                Data: JSON.stringify(body) + "\n"
            }
        };
        firehose.putRecord(params, function (error) {
            if (error !== null) {
                console.log('Failed writing Trace: ' + error);
            }
        });
    }
    catch (ex) {
        console.error(ex.message);
    }
};

Writable.passwordScore = function (pass) {
    var score = 0;
    if (!pass) {
        return score;
    }
    // award every unique letter until 5 repetitions
    var letters = new Object();
    for (var i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
    }

    // bonus points for mixing it up
    var variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
    };

    variationCount = 0;
    for (var check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;
    return parseInt(score);
};

Writable.passwordStrengthFromScore = function (score) {
    if (score >= 80) return 'strong';
    if (score >= 60) return 'good';
    if (score >= 38) return 'fair';
    if (score > 0) return 'weak';
    return null;
};

Writable.activeElementPreModal = null;

$(document).on('show.bs.modal', '.modal', function () {
    Writable.activeElementPreModal = document.activeElement;
});

$(document).on('shown.bs.modal', '.modal', function (e) {
    $(e.target).closest('.modal').attr('aria-modal', 'true');
    setTimeout(function () {
        $(e.target).focus();
    });
});

$(document).on('hidden.bs.modal', '.modal', function (e) {
    $(e.target).closest('.modal').removeAttr('aria-modal');
    if (Writable.activeElementPreModal && window.document.contains(Writable.activeElementPreModal)) {
        Writable.activeElementPreModal.focus();
        Writable.activeElementPreModal = null;
    }
});

Writable.introExit = function () {
    if (Writable.intro) {
        Writable.intro.exit(true);
    }
};

Writable.introStart = function (steps) {
    Writable.introExit();
    Writable.intro = introJs();
    Writable.intro.setOptions({
        showBullets: false,
        exitOnOverlayClick: false,
        showStepNumbers: false,
        hidePrev: true,
        hideNext: false,
        disableInteraction: true,
        scrollToElement: false,
        doneLabel: Writable.text.shared_intro_completed,
        nextLabel: Writable.text.shared_verb_next,
        steps: steps
    });
    Writable.intro.onbeforechange(function (targetElement) {
        targetElement.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' });
    });
    Writable.intro.onexit(function () {
        Writable.intro = null;
    });
    Writable.intro.start();
};

Writable.closeWindowForLTI = function (goalId) {
    window.top.opener.location.href = setUrlParameters(Writable.goalManageUrl, {
        goalId: goalId,
        isLti: true,
    });
    bootbox.alert({
        title: Writable.text.shared_close_window_for_lti_title,
        closeButton: false,
        message: Writable.text.shared_close_window_for_lti_message,
        callback: function () {
            window.top.close();
        }
    });
};

Writable.closeWindowForGoogleAttachment = function () {
    bootbox.alert({
        title: Writable.text.shared_close_window_for_lti_title,
        closeButton: false,
        message: Writable.text.shared_close_window_for_lti_message,
        callback: function () {
            window.parent.postMessage({
                type: 'Classroom',
                action: 'closeIframe',
            }, '*');
        }
    });
};

Writable.textForNodeNewlineElements = {
    'P': true,
    'H1': true,
    'H2': true,
    'H3': true,
    'H4': true,
    'H5': true,
    'H6': true,
    'OL': true,
    'UL': true,
    'PRE': true,
    'ADDRESS': true,
    'BLOCKQUOTE': true,
    'DL': true,
    'DIV': true,
    'FIELDSET': true,
    'FORM': true,
    'HR': true,
    'NOSCRIPT': true,
    'TABLE': true,
    'BR': true,
};

Writable.getTextForNode = function (node) {
    switch (node.nodeType) {
        case 1: // Node.ELEMENT_NODE
            var result = '';
            for (var child = node.firstChild; child; child = child.nextSibling) {
                var addNewLine = Writable.textForNodeNewlineElements[child.tagName];
                if (addNewLine && result.charAt(result.length - 1) !== '\n') {
                    result += '\n';
                }
                result += Writable.getTextForNode(child);
                if (addNewLine && result.charAt(result.length - 1) !== '\n') {
                    result += '\n';
                }
            }
            return result.trim();
        case 3: // Node.TEXT_NODE
            return node.nodeValue;
        default:
            return '';
    }
};

Writable.htmlToText = function (html) {
    var $element = $('<div>').html(html);
    return Writable.getTextForNode($element[0]);
};

Writable.cleanPastedHtml = function (html) {
    var $html = $('<div>').html(html);
    $html.find('*').css('background-color', '');
    return $html.html();
};

Writable.isGoalScoringCompatible = function (scoringA, scoringB) {
    if (!scoringA || !scoringB) {
        return false;
    }

    if (scoringA.scoreType != scoringB.scoreType) {
        return false;
    }

    switch (scoringA.scoreType) {
        case 'P':
            return scoringA.scoreBase === scoringB.scoreBase;
        case 'Z':
        case 'S':
            return scoringA.numericScoring
                && scoringB.numericScoring
                && scoringA.numericScoring.length === scoringB.numericScoring.length
                && scoringA.numericScoring.every((s, i) => scoringB.numericScoring[i] === s);
        default:
            return true;
    }
};

Writable.presentWritableAIFeedbackAgreement = function (config) {
    const deferred = $.Deferred();
    let message = "<p>Writable's AI creates personalized feedback suggestions that encourage student revision and accelerate writing growth. The AI never sends messages directly to students; teachers should review all grades and comments before sending.</p>";
    message += '<div class="checkbox" style="margin: 20px 0 0"><label><input type="checkbox" value=""><strong>I agree to review AI suggestions before sending.</strong></label></div>';
    if (null == config.isFlight)
        config.isFlight = false;
    const _config = config;

    const dialog = bootbox.dialog({
        title: "Welcome to Writable AI",
        message: message,
        closeButton: false,
        animate: false,
        onEscape: false,
        buttons: {
            cancel: {
                label: 'Cancel',
                callback: function () {
                    deferred.resolve(false);
                }
            },
            confirm: {
                label: 'Continue',
                callback: function () {
                    $.post(setUrlParameters(Writable.settingExchangeUserSettingUrl, {
                        key: 'WritableAIFeedbackAgreement',
                        value: Writable.requiredWritableAIFeedbackAgreement
                    }));
                    deferred.resolve(true);
                }
            }
        }
    });
    
    dialog.init(function () {
        const $dialog = $(dialog);
        const $button = $dialog.find('.btn-primary');
        const $checkbox = $dialog.find('.checkbox input');
        const $footer = $dialog.find('.modal-footer');
        $button.prop('disabled', true);
        $checkbox.change(function () {
            $button.prop('disabled', !$checkbox.is(':checked'));
        });
        const helpLink = _config.isFlight ?
            "http://downloads.hmlt.hmco.com/Help/HNMFlight/Teacher/#t=Teacher_Home.htm" :
            "https://intercom.help/writable/en/articles/8097806-writable-ai-overview";
        $footer.prepend('<a href="' + helpLink + '" target="_blank" rel="noopener" style="margin-right: 15px">Questions, Help, Suggestions?</a>')
    });

    return deferred.promise();
};

Writable.showUnavailableWhenImpersonatingAlert = function () {
    bootbox.alert({
        title: "Feature Unavailable",
        message: "Sorry, that feature is not available when impersonating another user.",
        animate: false,
        closeButton: false
    });
};

Writable.getAuthorshipColor = function (value, isNoDraftHistory) {
    if (value == null) {
        return isNoDraftHistory ? 'gray' : null;
    }
    if (value < -1) {
        return 'orange';
    }
    if (value < 50) {
        return 'red';
    }
    if (value < 75) {
        return 'yellow';
    }
    return 'green';
};

Writable.getAuthorshipClasses = function (value, isNoDraftHistory) {
    const color = Writable.getAuthorshipColor(value, isNoDraftHistory);
    if (color == null) {
        return null;
    }
    const validColors = ['red', 'orange', 'yellow', 'green', 'gray'];
    return validColors.includes(color) ? 'fas fa-circle authorship ' + color : null;
};

Writable.getAuthorshipDescription = function (authorshipRecord, authorshipAverages, includeStatistics) {
    if (!authorshipRecord.integrityScore && authorshipRecord.integrityScore !== 0) {
        return '';
    }
    if (authorshipRecord.integrityScore < -1) {
        return '<p>This submission started by pasting a large block of text and then was edited in Writable.</p>';
    }
    if (authorshipRecord.integrityScore < 0) {
        return '<p>This submission was pasted into Writable and was not edited.</p>';
    }
    if (authorshipRecord.integrityScore < 50) {
        const blocks = authorshipRecord.suspectDrafts ? authorshipRecord.suspectDrafts.length : 0;
        const blockText = (blocks !== 1) ? 'were ' + blocks + ' large blocks' : 'was a large block';
        let result = '<p style="text-align: left;">This submission was pasted into Writable.';
        if (includeStatistics) {
            result += '<br><br>' +
                '<b>Drafting</b>: There ' + blockText + ' copied into the submission. ' + (blocks !== 1 ? 'They' : 'It') + ' could be quotes, or plagiarism.<br><br>' +
                '<b>Revising</b>: The author completed ' + authorshipRecord.revisingRecords + ' revision actions. (Class Average: ' + authorshipAverages.revisingRecords + ')<br><br>' +
                '<b>Editing</b>: The author completed ' + authorshipRecord.editingRecords + ' editing actions. (Class Average: ' + authorshipAverages.editingRecords + ')';
        }
        result += '</p>';
        return result;
    }
    if (authorshipRecord.integrityScore < 75) {
        let result = '<p style="text-align: left;">This submission includes several blocks of writing that were pasted.';
        if (includeStatistics) {
            result += '<br><br>' +
                '<b>Drafting</b>: The author averaged ' + authorshipRecord.wordsPerMinute + ' words per minute while drafting. (Class Average: ' + authorshipAverages.wordsPerMinute + ')<br><br>' +
                '<b>Revising</b>: The author completed ' + authorshipRecord.revisingRecords + ' revision actions. (Class Average: ' + authorshipAverages.revisingRecords + ')<br><br>' +
                '<b>Editing</b>: The author completed ' + authorshipRecord.editingRecords + ' editing actions. (Class Average: ' + authorshipAverages.editingRecords + ')';
        }
        result += '</p>';
        return result;
    } else {
        let result = '<p style="text-align: left;">This submission was authored in Writable.';
        if (includeStatistics) {
            result += '<br><br>' +
                '<b>Drafting</b>: The author averaged ' + authorshipRecord.wordsPerMinute + ' words per minute while drafting. (Class Average: ' + authorshipAverages.wordsPerMinute + ')<br><br>' +
                '<b>Revising</b>: The author completed ' + authorshipRecord.revisingRecords + ' revision actions. (Class Average: ' + authorshipAverages.revisingRecords + ')<br><br>' +
                '<b>Editing</b>: The author completed ' + authorshipRecord.editingRecords + ' editing actions. (Class Average: ' + authorshipAverages.editingRecords + ')';
        }
        result += '</p>';
        return result;
    }
};

Writable.applySharedFroalaConfigurationUpdates = function (editorConfig) {
    if (FroalaEditor?.DEFAULTS?.specialCharactersSets) {
        const specialCharactersSets = $.extend(true, [], FroalaEditor.DEFAULTS.specialCharactersSets);
        const latinCharactersSet = specialCharactersSets.find(s => s.title === 'Latin');
        if (latinCharactersSet?.list) {
            const addCharacters = [
                { char: '&#x00B9', desc: 'SUPERSCRIPT ONE' },
                { char: '&#x00B2', desc: 'SUPERSCRIPT TWO' },
                { char: '&#x00B3', desc: 'SUPERSCRIPT THREE' },
                { char: '&#x2074', desc: 'SUPERSCRIPT FOUR' },
                { char: '&#x2075', desc: 'SUPERSCRIPT FIVE' },
                { char: '&#x2076', desc: 'SUPERSCRIPT SIX' },
                { char: '&#x2077', desc: 'SUPERSCRIPT SEVEN' },
                { char: '&#x2078', desc: 'SUPERSCRIPT EIGHT' },
                { char: '&#x2079', desc: 'SUPERSCRIPT NINE' },
            ];
            const retainCharacters = latinCharactersSet.list.filter(c => !c.desc?.startsWith('SUPERSCRIPT'));
            latinCharactersSet.list = addCharacters.concat(retainCharacters);
        }
        editorConfig.specialCharactersSets = specialCharactersSets;
    }
};

Writable.minimumDelay = async function (operationPromise, minimumMs) {
    const results = await Promise.all([operationPromise, new Promise(resolve => setTimeout(resolve, minimumMs))]);
    return results[0];
};

Writable.launchAiTools = async function (url, parameters) {
    try {
        // Get auth code and redirect to writable with auth code
        const response = await $.get(Writable.authCodeUrl);
        const params = { ...response, returnUrl: setUrlParameters(url, parameters) };
        const targetUrl = `${Writable.aiToolsBaseUrl}${Writable.loginWithAuthCodeUrl}`;
        window.open(setUrlParameters(targetUrl, params), '_blank');
    } catch (error) {
        console.error('Error launching AI Tools:', error);
        bootbox.alert({
            message: "Unfortunately, an error occurred while launching AI Tools.<br><br>Please try again or contact support if the problem continues."
        });
    }
};
(function () {

    if (!window.SSMLGenerator) {
        window.SSMLGenerator = function ($elements, options) {
            var self = this;
            self.options = options;
            self.limit = 1500;
            self.batch = '';
            self.batchLength = 0;
            self.batches = [];

            if ($elements) {
                self.addElements($elements);
                self.completeBatch();
            }
        };

        SSMLGenerator.prototype.escape = function (text) {
            return text.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&apos;');
        };

        SSMLGenerator.prototype.completeBatch = function () {
            var self = this;
            if (self.batch) {
                self.batches.push('<speak>' + self.batch + '</speak>');
                self.batch = '';
                self.batchLength = 0;
            }
        };

        SSMLGenerator.prototype.nextChunk = function (text) {
            var self = this;
            if (text.length > self.limit) {
                return text.substr(0, text.lastIndexOf(' ', self.limit)) || text.substr(0, self.limit);
            } else {
                return text;
            }
        };

        SSMLGenerator.prototype.addText = function (text) {
            var self = this;
            var trimmed = text.trim();
            if (trimmed.length > 0) {
                while (trimmed.length > 0) {
                    var chunk = self.nextChunk(trimmed);
                    trimmed = trimmed.substr(chunk.length).trim();
                    var escaped = self.escape(chunk);
                    if (self.batchLength + chunk.length <= self.limit) {
                        self.batch += escaped;
                        self.batchLength += chunk.length;
                    } else {
                        self.completeBatch();
                        self.batch = escaped;
                        self.batchLength = chunk.length;
                    }
                }
                self.batch += '<break/>';
            }
        };

        SSMLGenerator.prototype.addNode = function (node) {
            var self = this;
            if (self.options && self.options.ignore && $(node).is(self.options.ignore)) {
                return;
            }
            switch (node.nodeName) {
                case 'SCRIPT':
                    break;
                case 'P':
                    self.addText(node.innerText);
                    break;
                default:
                    if (node.nodeType === 3) {
                        self.addText(node.textContent);
                    }
                    var child = node.firstChild;
                    while (child) {
                        self.addNode(child);
                        child = child.nextSibling;
                    }
                    break;
            }
        };

        SSMLGenerator.prototype.addElements = function ($elements) {
            var self = this;
            $elements.each(function (i, e) {
                self.addNode(e);
            });
        };

        SSMLGenerator.prototype.equalTo = function (other) {
            var self = this;
            if (other && (self.batches.length === other.batches.length)) {
                for (var i = 0; i < self.batches.length; ++i) {
                    if (self.batches[i] !== other.batches[i]) {
                        return false;
                    }
                }
                return true;
            } else {
                return false;
            }
        };
    }

})();
var StackModal = (function (my) {
    return my;
}(StackModal || window.StackModal || {}));

(function ($) {
    StackModal.init = function (style) {
        const defaultStyle = {
            dialog: '',
            header: '',
            footer: '',
        };
        if (null == style) {
            StackModal.style = defaultStyle;
        } else {
            style.dialog = style.dialog ?? '';
            style.header = style.header ?? '';
            style.footer = style.footer ?? '';
            StackModal.style = style;
        }

        var $header = $('<div class="modal-header clearfix ' + StackModal.style.header + '">');
        $header.append($('<div class="buttons left-buttons pull-left">'));
        $header.append($('<div class="buttons right-buttons pull-right">'));
        $header.append($('<h4 class="modal-title"></h4>'));
        $header.append($('<div class="actions"></div>'));
        var $body = $('<div class="modal-body">');
        $body.append($('<div class="loading-indicator"><span class="fad fa-spinner fa-spin"></span></div>'));
        var $footer = $('<div class="modal-footer ' + StackModal.style.footer + '">');
        $footer.append($('<div class="buttons left-buttons pull-left">'));
        $footer.append($('<div class="buttons right-buttons pull-right">'));
        $footer.append($('<button type="button" class="btn btn-primary btn-pop btn-done"></button>'));
        $footer.append($('<button type="button" class="btn btn-primary btn-pop btn-back">Done</button>'));
        $footer.append($('<button type="button" class="btn btn-default btn-pop btn-cancel">Cancel</button>'));
        var $content = $('<div class="modal-content">').append($header, $body, $footer);
        var $dialog = $('<div class="modal-dialog ' + StackModal.style.dialog + '" role="document">').append($content);
        var $modal = $('<div id="stack-modal" class="modal stack-modal" tabindex="-1" role="dialog" data-keyboard="false">').append($dialog);
        $('body').append($modal);

        $modal.on('click', '.modal-footer .btn-pop', StackModal.popView);
        $modal.on('hidden.bs.modal', function () {
            popAllViews();
        });

        StackModal.$modal = $modal;
        StackModal.$views = $body;
        StackModal.removeFrameDelay = 1000;
        StackModal.pushViewCount = 0;
    };

    StackModal.show = function (view, style) {
        if (style) {
            StackModal.init(style);
        }

        StackModal.rootView = view;
        StackModal.entries = [];
        StackModal.loading = {};
        StackModal.$modal.modal({
            show: true,
            backdrop: 'static'
        });
        StackModal.pushView(view);
    };

    StackModal.pushView = function (view) {
        var hideEntry = StackModal.entries.length > 0 ? StackModal.entries[StackModal.entries.length - 1] : null;
        if (hideEntry) {
            hideEntry.$iframe.addClass('view-lower');
        }
        var $iframe = $('<iframe>', {
            class: hideEntry ? 'view-upper' : null
        });

        if (view.request) {
            view.request
                .done(function (response) {
                    $iframe.attr('srcdoc', response);
                })
                .fail(function (jqXHR) {
                    StackModal.hide();
                    Writable.showRequestFailed(jqXHR);
                });
        } else {
            $iframe.attr('src', view.src);
        }

        StackModal.$views.append($iframe);
        var entry = {
            view: view,
            $iframe: $iframe
        };
        StackModal.entries.push(entry);
        var loadingId = 'stack-view-' + StackModal.pushViewCount++;
        StackModal.setLoading(loadingId, true);
        $iframe.on('load', function () {
            $iframe.focus();
            try {
                entry.handler = this.contentWindow.stackViewHandler;
            } catch (err) {
                console.log(err);
            }
            StackModal.setLoading(loadingId, false);
            updateState();
        });
        if (hideEntry) {
            $iframe.position();
            $iframe.removeClass('view-upper');
        }
        updateState();
    };

    StackModal.popView = function () {
        var deferred = $.Deferred();
        var onConfirmed = function () {
            if (StackModal.entries.length > 1) {
                popViewInternal(true);
            } else {
                StackModal.hide();
            }
            deferred.resolve();
        };
        if (StackModal.entries.length > 0) {
            var entry = StackModal.entries[StackModal.entries.length - 1];
            if ((entry.handler && entry.handler.stackViewConfirmClose) || entry.view.confirmCloseHandler) {
                var $buttons = StackModal.$modal.find('.modal-footer .btn-pop');
                $buttons.prop('disabled', true);
                (entry.handler && entry.handler.stackViewConfirmClose ? entry.handler.stackViewConfirmClose() : $.when())
                    .then(function () {
                        if (entry.view.confirmCloseHandler) {
                            return entry.view.confirmCloseHandler();
                        }
                    })
                    .done(function () {
                        onConfirmed();
                    })
                    .fail(function () {
                        deferred.reject();
                    })
                    .always(function () {
                        $buttons.prop('disabled', false);
                    });
            } else {
                onConfirmed();
            }
        } else {
            onConfirmed();
        }
        return deferred.promise();
    };

    StackModal.containsWindow = function (targetWindow) {
        return StackModal.entries?.some(e => e.$iframe.get(0).contentWindow === targetWindow);
    };

    StackModal.hide = function () {
        StackModal.$modal.modal('hide');
    };

    StackModal.isLoading = function () {
        return $.isEmptyObject(StackModal.loading) ? false : true;
    };

    StackModal.setLoading = function (id, state) {
        if (state) {
            StackModal.loading[id] = true;
        } else {
            delete StackModal.loading[id];
        }
        var loading = StackModal.isLoading();
        StackModal.$modal.toggleClass('loading', loading);
        StackModal.$modal.find('button.disabled-when-loading').prop('disabled', loading);
    };

    StackModal.updateButtonState = function () {
        updateState();
    };

    StackModal.broadcastUpdate = function (type, data) {
        if (StackModal.entries.length > 0) {
            StackModal.entries.forEach(function (entry) {
                if (entry.handler && entry.handler.stackViewOnUpdate) {
                    entry.handler.stackViewOnUpdate(type, data);
                }
            });
        }
        if (StackModal.rootView.updateHandler) {
            StackModal.rootView.updateHandler(type, data);
        }
    };

    var popViewInternal = function (restoringPreviousView) {
        var poppedEntry = StackModal.entries.pop();
        if (poppedEntry.handler) {
            if (poppedEntry.handler.stackViewOnClose) {
                poppedEntry.handler.stackViewOnClose();
            }
            if (poppedEntry.handler.stackViewOnBroadcastUpdate && (restoringPreviousView || StackModal.entries.length === 0)) {
                poppedEntry.handler.stackViewOnBroadcastUpdate(StackModal);
            }
        }
        poppedEntry.$iframe.addClass('view-upper');
        if (poppedEntry.view.popHandler) {
            poppedEntry.view.popHandler();
        }
        setTimeout(function () {
            poppedEntry.$iframe.remove();
        }, StackModal.removeFrameDelay);
        if (restoringPreviousView) {
            if (StackModal.entries.length > 0) {
                var entry = StackModal.entries[StackModal.entries.length - 1];
                entry.$iframe.removeClass('view-lower');
                entry.$iframe.focus();
                updateState();
                if (entry.handler && entry.handler.stackViewOnReappear) {
                    entry.handler.stackViewOnReappear(StackModal);
                }
            } else {
                StackModal.hide();
            }
        }
    };

    var popAllViews = function () {
        while (StackModal.entries.length > 0) {
            popViewInternal(false);
        }
        StackModal.rootView = null;
    };

    var updateButtons = function ($container, buttons, loading) {
        if (buttons) {
            buttons.forEach(function (button) {
                var $button = $(button.html);
                $button.on('click', button.click);
                if ($button.hasClass('disabled-when-loading')) {
                    $button.prop('disabled', loading);
                }
                $container.append($button);
            });
        }
    };

    var updateState = function () {
        var $header = StackModal.$modal.find('.modal-header');
        var $footer = StackModal.$modal.find('.modal-footer');
        var $title = $header.find('.modal-title');
        var $headerLeftButtons = $header.find('.left-buttons');
        var $headerRightButtons = $header.find('.right-buttons');
        var $footerLeftButtons = $footer.find('.left-buttons');
        var $footerRightButtons = $footer.find('.right-buttons');

        $title.empty();
        $headerLeftButtons.empty();
        $headerRightButtons.empty();
        $footerLeftButtons.empty();
        $footerRightButtons.empty();

        var entry = StackModal.entries[StackModal.entries.length - 1];
        if (entry) {
            if (entry.view.titleHtml) {
                $title.html(entry.view.titleHtml);
            } else {
                $title.text(entry.view.title);
            }

            if (entry.handler && entry.handler.stackViewConfigure) {
                var config = entry.handler.stackViewConfigure(entry.view);
                if (config) {
                    var loading = StackModal.isLoading();
                    updateButtons($headerLeftButtons, config.headerButtonsLeft, loading);
                    updateButtons($headerRightButtons, config.headerButtonsRight, loading);
                    updateButtons($footerLeftButtons, config.footerButtonsLeft, loading);
                    updateButtons($footerRightButtons, config.footerButtonsRight, loading);
                }
            }
        }

        StackModal.$modal.toggleClass('enable-back', StackModal.entries.length > 1);
        StackModal.$modal.toggleClass('enable-cancel', entry && entry.view.cancelable ? true : false);
        StackModal.$modal.toggleClass('custom-footer-buttons', $footerRightButtons.children().length > 0);
    };
})(jQuery);

var Subscribe = (function (my) {
    return my;
}(Subscribe || {}));

(function ($) {
    Subscribe.init = function (config) {
        Subscribe.config = config;

        const status = getSessionString('licenseStatus');
        if (status) {
            updateCurrentStatus(JSON.parse(status));
        }

        $(function () {
            Subscribe.requestStatus();
        });
    };

    function updateCurrentStatus(status) {
        Subscribe.currentStatus(status);
        const li = $('#subscribe');
        const a = li.children('a').first();
        switch (status.status) {
            case 'inactive':
            case 'pretrial':
                a.text('Plan your Trial');
                li.addClass('show-subscribe');
                break;
            case 'trial':
                if (status.trialRemaining) {
                    a.html(status.trialRemaining);
                } else {
                    a.text('Extend your Trial');
                }
                li.addClass('show-subscribe');
                break;
            case 'active':
                li.removeClass('show-subscribe');
                break;
        }
    };

    Subscribe.requestStatus = function () {
        return $.get(Subscribe.config.licenseStatusUrl)
            .then(function (status) {
                updateCurrentStatus(status);
                setSessionString('licenseStatus', JSON.stringify(status));

                // Schedule an update if next credit within 24h
                if (status.credits?.next) {
                    const nextDate = new Date(status.credits.next);
                    const nextDelay = nextDate.getTime() - Date.now();
                    if (nextDelay < 24 * 60 * 60 * 1000) {
                        setTimeout(Subscribe.requestStatus, nextDelay);
                    }
                }
            })
            .fail(function (jqXHR) {
                console.error('Failed to read license status:', jqXHR);
            });
    };

    Subscribe.currentStatus = ko.observable();

    Subscribe.currentCreditsStatus = ko.pureComputed(function () {
        const currentStatus = Subscribe.currentStatus();
        const credits = currentStatus?.credits;

        // Do we have credit restrictions (e.g. not a curator/admin)
        if (credits) {
            // Is the user out of throttle credits
            if (credits.throttleCreditsTotal > 0 && credits.throttleCreditsAvailable === 0) {
                return {
                    blockedReason: 'throttle',
                    throttleCreditsTotal: credits.throttleCreditsTotal,
                    throttleCreditInterval: credits.throttleCreditInterval,
                    throttleCreditNextDate: credits.throttleCreditNextDate,
                };
            }

            // Do free credit restrictions apply to this user
            if (currentStatus.status === 'inactive' && credits.freeCreditsTotal > 0) {
                // Is the user out of free credits
                if (credits.freeCreditsAvailable === 0) {
                    return {
                        blockedReason: 'free',
                        freeCreditsTotal: credits.freeCreditsTotal,
                        freeCreditInterval: credits.freeCreditInterval,
                        freeCreditNextDate: credits.freeCreditNextDate,
                        hasTrialLicense: currentStatus.hasTrialLicense,
                        aiToolsFreeTrialInterval: currentStatus.aiToolsFreeTrialInterval,
                    };
                }

                return {
                    blockedReason: null,
                    freeCreditsTotal: credits.freeCreditsTotal,
                    freeCreditInterval: credits.freeCreditInterval,
                    freeCreditsAvailable: credits.freeCreditsAvailable,
                };
            }
        }

        return null;
    });

    Subscribe.showCreditsInformation = function (total, timespan) {
        bootbox.dialog({
            animate: false,
            title: `How do credits work?`,
            message: `Free accounts get ${total} credit${total !== 1 ? 's' : ''} every ${timespan}. One credit is used each time you generate content using an AI Tool or chat with HMH Assist. Get the most out of HMH AI Tools by upgrading to an unlimited plan.`,
            buttons: {
                cancel: { label: 'Close', className: 'secondary' },
                upgrade: {
                    label: 'Upgrade to Unlimited',
                    className: 'primary',
                    callback: function () {
                        window.location.href = Subscribe.config.licenseSubscribeUrl;
                    }
                },
            }
        });
    };

    Subscribe.showAlertModal = function () {
        var status = getSessionString('licenseStatus');
        if (!status) {
            setTimeout(Subscribe.showAlertModal, 100);
            return;
        }

        var licenseData = JSON.parse(status);
        if (licenseData.status !== 'inactive') {
            return;
        }

        var message = Subscribe.warningText();
        Subscribe.$alertModal = bootbox.alert({
            message: message,
            closeButton: false,
            animate: false,
            callback: function () {
                Subscribe.$alertModal = null;
            }
        });
    };

    Subscribe.closeAlertModal = function () {
        if (Subscribe.$alertModal) {
            Subscribe.$alertModal.modal('hide');
            Subscribe.$alertModal = null;
        }
    }

    Subscribe.isReady = function () {
        return getSessionString('licenseStatus');
    }

    Subscribe.warningText = function () {
        var status = getSessionString('licenseStatus');
        if (!status) {
            return null;
        }

        var licenseData = JSON.parse(status);
        if (licenseData.status !== 'inactive') {
            return null;
        }

        var message = 'You are not connected to a license. In order for students to access your assignments, you will need to connect to a license. Please contact <a href="#" class="chat-link">customer support</a>.';
        if (licenseData.hasHmhAccount) {
            message = 'We need updated license information. Please launch Writable from inside Ed to automatically update your license. <a href="https://intercom.help/writable/en/articles/4348102-how-do-i-access-writable-from-ed" class="help-article-link" target="_blank">Learn More</a>';
        }

        return message;
    };
})(jQuery);

var SupportOverlay = (function (my) {
    return my;
}(
    (function () {
    if (SupportOverlay || window.SupportOverlay) { return SupportOverlay || window.SupportOverlay; }
    // This bit of weirdness supports launching the overlay from within an iframe.
    // Requires try/catch because `parent` may be cross-origin (e.g. LTI).
    try { return parent.SupportOverlay || {}; }
    catch (er) { return {}; }
    })()
));

(function ($) {
    SupportOverlay.init = function (config) {
        SupportOverlay.config = config;
        if (null == SupportOverlay.config.isFlight)
            SupportOverlay.config.isFlight = false;
        SupportOverlay.showingHelp = false;
        SupportOverlay.sessionKey = 'supportOverlayData';
        SupportOverlay.isReady = false;
        SupportOverlay.unreadMessages = 0;
        SupportOverlay.iframeReady = $.Deferred();
        SupportOverlay.iframeUrl = "/Support/Index?isOverlay=true&url=" + encodeURIComponent(window.location.href);
        if (document.referrer) SupportOverlay.iframeUrl += '&previousUrl=' + encodeURIComponent(document.referrer);

        $(window).on('load', function () {
            SupportOverlay.$button = $('#support-button');
            SupportOverlay.$overlay = $('.support-container');
            SupportOverlay.$header = SupportOverlay.$overlay.find('.move-header');
            SupportOverlay.$iframe = SupportOverlay.$overlay.find('iframe');

            if (!SupportOverlay.isEnabled()) {
                SupportOverlay.$button.hide();
            }

            let supportAction = SupportOverlay.config.isFlight ?
                function () { window.open('http://downloads.hmlt.hmco.com/Help/HNMFlight/Teacher/#t=Teacher_Home.htm', '_blank') } :
                SupportOverlay.toggleSupportOverlay;
            $(document).on('click', '#support-button', supportAction);

            var supportString = window.getSessionString(SupportOverlay.sessionKey);
            if (supportString) {
                var supportData = JSON.parse(supportString);

                if (supportData.left || supportData.top) {
                    var offset = {};
                    if (supportData.left) {
                        offset.left = supportData.left;
                    }
                    if (supportData.top) {
                        offset.top = supportData.top;
                    }
                    SupportOverlay.offsetToRestore = offset;
                }

                SupportOverlay.unreadMessages = supportData.unreadMessages;
                if (SupportOverlay.unreadMessages > 0) {
                    Writable.updateUnreadMessages(SupportOverlay.unreadMessages);
                }

                if (supportData.showingHelp ||
                    (supportData.unreadMessages > 0 && SupportOverlay.config.showChatOnMessage)) {
                    SupportOverlay.openSupportOverlay();
                }
                else if (Writable.currentUserId) {
                    SupportOverlay.initChat();
                }
            } else if (Writable.currentUserId) {
                SupportOverlay.initChat();
            }

            SupportOverlay.threshhold = 20;
            SupportOverlay.undockedClass = 'undocked';
            // Code to make the overlay draggable, taken from:
            // https://stackoverflow.com/questions/12571922/make-bootstrap-twitter-dialog-modal-draggable/51824269#51824269
            SupportOverlay.$header.on("mousedown", function (mousedownEvt) {
                var $draggable = $(this).closest('.support-container');

                var x = mousedownEvt.pageX - $draggable.offset().left,
                    y = mousedownEvt.pageY - $draggable.offset().top;

                var $banner = $('.writable-banner');
                var bannerSize = {
                    width: parseInt($banner.css('width')),
                    height: parseInt($banner.css('height'))
                };
                var overlaySize = {
                    width: parseInt(SupportOverlay.$overlay.css('width'))
                };

                SupportOverlay.$header.on("mousemove.draggable", function (mousemoveEvt) {
                    var offset = {
                        left: mousemoveEvt.pageX - x,
                        top: mousemoveEvt.pageY - y
                    };
                    var storedOffset = {
                        left: mousemoveEvt.clientX - x,
                        top: mousemoveEvt.clientY - y
                    };

                    if (offset.top < (bannerSize.height + SupportOverlay.threshhold + window.pageYOffset) &&
                        (offset.left + overlaySize.width) > (bannerSize.width - SupportOverlay.threshhold)) {
                        offset.top = 64 + window.pageYOffset;
                        offset.left = bannerSize.width - overlaySize.width;
                        SupportOverlay.$overlay.offset(offset);
                        SupportOverlay.$overlay.removeClass(SupportOverlay.undockedClass);
                        SupportOverlay.draggedOffset = null;
                    } else {
                        SupportOverlay.$overlay.offset(offset);
                        SupportOverlay.$overlay.addClass(SupportOverlay.undockedClass);
                        SupportOverlay.draggedOffset = storedOffset;
                    }
                });
                SupportOverlay.$overlay.one("mouseup", function () {
                    SupportOverlay.onDragEnd();
                    writeSupportLocation();
                });
            });

            SupportOverlay.iframeReady.resolve();
        });
    };

    SupportOverlay.isEnabled = function () {
        if (Writable.isMobile()) {
            return false;
        }
        return true;
    }
    SupportOverlay.onDragEnd = function () {
        SupportOverlay.$header.off("mousemove.draggable");
        var dockedProperties = {
            docked: ((SupportOverlay.draggedOffset) ? false : true)
        };
        SupportOverlay.postMessage(SupportOverlay.$iframe[0].contentWindow, 'dockingChange', dockedProperties);
    };

    SupportOverlay.dock = function () {
        var $banner = $('.writable-banner');
        SupportOverlay.$overlay.css({ left: '', top: '' });
        SupportOverlay.$overlay.removeClass(SupportOverlay.undockedClass);
        SupportOverlay.draggedOffset = null;
        var dockedProperties = {
            docked: true
        };
        SupportOverlay.postMessage(SupportOverlay.$iframe[0].contentWindow, 'dockingChange', dockedProperties);
        writeSupportLocation();
    };

    SupportOverlay.onReceiveMessage = function (event) {
        if (event.origin !== location.origin) {
            return;
        }

        var message = event.data;

        if (message.operation === 'closeSupportOverlay') {
            SupportOverlay.closeSupportOverlay();
        } else if (message.operation === 'supportOverlayReady') {
            SupportOverlay.isReady = true;
            if (SupportOverlay.showingHelp) {
                SupportOverlay.showSupportOverlay();
            }
        } else if (message.operation === 'supportUnreadCount') {
            if (SupportOverlay.unreadMessages === 0 && message.unread > 0 &&
                !SupportOverlay.showingHelp && SupportOverlay.config.showChatOnMessage) {
                SupportOverlay.openSupportOverlay();
                SupportOverlay.showingHelp = true;
            }
            SupportOverlay.unreadMessages = message.unread;
            Writable.updateUnreadMessages(message.unread);
            writeSupportLocation();
        } else if (message.operation === 'navigateFromSupport') {
            Writable.outerWindow.location = message.href;
        } else if (message.operation === 'setDocked') {
            SupportOverlay.dock();
        }
    };

    window.addEventListener("message", SupportOverlay.onReceiveMessage, false);

    SupportOverlay.postMessage = function (targetWindow, operation, properties) {
        var message = {
            source: "writableWeb",
            operation: operation
        };
        if (properties) {
            $.each(properties, function (name, value) {
                message[name] = value;
            });
        }
        targetWindow.postMessage(message, "*");
    };

    var writeSupportLocation = function (data) {
        var existing = window.getSessionString(SupportOverlay.sessionKey);
        var supportLocation = {
            showingHelp: SupportOverlay.showingHelp,
            unreadMessages: SupportOverlay.unreadMessages
        };

        if (existing) {
            var existingData = JSON.parse(existing);
            Object.keys(existingData).forEach(function (key) {
                if (key === 'showingHelp' || key === 'unreadMessages' || key === 'left' || key === 'top') {
                    return;
                }
                supportLocation[key] = existingData[key];
            });
        }

        if (data) {
            Object.keys(data).forEach(function (key) {
                supportLocation[key] = data[key];
            });
        }

        if (SupportOverlay.draggedOffset) {
            Object.keys(SupportOverlay.draggedOffset).forEach(function (key) {
                supportLocation[key] = SupportOverlay.draggedOffset[key];
            });
        }

        window.setSessionString(SupportOverlay.sessionKey, JSON.stringify(supportLocation));
    };

    SupportOverlay.toggleSupportOverlay = function () {
        if (SupportOverlay.showingHelp === true) {
            SupportOverlay.closeSupportOverlay();
        } else {
            SupportOverlay.openSupportOverlay();
        }

        writeSupportLocation();
    };

    SupportOverlay.openSupportOverlay = function () {
        SupportOverlay.iframeReady.then(function () {
            var $iframe = SupportOverlay.$iframe;
            if (!$iframe.attr('src')) {
                $iframe.attr('src', SupportOverlay.iframeUrl);
                SupportOverlay.$overlay.find('.spinner').show();
                $iframe.hide();
            } else {
                SupportOverlay.postMessage(SupportOverlay.$iframe[0].contentWindow, 'reopen');
            }
            SupportOverlay.showingHelp = true;
            SupportOverlay.$button.attr('title', 'Close Help');
            setTimeout(function () {
                SupportOverlay.$overlay.show();
            }, 0);
            if (SupportOverlay.isReady) {
                SupportOverlay.showSupportOverlay();
            }
        });
    };

    SupportOverlay.showSupportOverlay = function () {
        SupportOverlay.postMessage(SupportOverlay.$iframe[0].contentWindow, 'setConfig', {
            path: SupportOverlay.config.path,
            docked: ((SupportOverlay.offsetToRestore) ? false : true)
        });
        SupportOverlay.$overlay.find('.spinner').hide();
        SupportOverlay.$iframe.show();
        SupportOverlay.$overlay.show();
        if (SupportOverlay.offsetToRestore) {
            SupportOverlay.offsetToRestore.top += window.pageYOffset;
            SupportOverlay.$overlay.offset(SupportOverlay.offsetToRestore);
            SupportOverlay.$overlay.addClass(SupportOverlay.undockedClass);
            SupportOverlay.offsetToRestore = null;
        }
    };

    SupportOverlay.closeSupportOverlay = function () {
        SupportOverlay.onDragEnd();
        SupportOverlay.$overlay.hide();
        SupportOverlay.showingHelp = false;
        SupportOverlay.$button.attr('title', 'Learn With Us');
        window.removeSessionString(SupportOverlay.sessionKey);
    };

    SupportOverlay.initChat = function () {
        var $iframe = SupportOverlay.$iframe;
        if ($iframe.attr('src') === undefined) {
            $iframe.attr('src', SupportOverlay.iframeUrl + "&indexMode=init");
            SupportOverlay.$overlay.find('.spinner').show();
            $iframe.hide();
        }
    };

    // This is intended to be called so that it handles the opening
    // action regardless of whether the support overlay is supported
    // if the overlay can't open it internally, it opens the url in
    // a new window
    SupportOverlay.openArticleUrl = function (url) {
        if (!SupportOverlay.innerOpenArticleUrl(url)) {
            window.open(url);
        }
    };

    // This is used directly from anchor elements, so if it handles the event
    // it needs to return false to suppress the caller from acting.
    SupportOverlay.openArticle = function (event) {
        var url = $(event.target).closest('[href]').attr('href');
        if (!url) { return true; }

        if (!url.includes('intercom.help/writable')) {
            return true;
        }

        return !SupportOverlay.innerOpenArticleUrl(url);
    };

    SupportOverlay.innerOpenArticleUrl = function (url) {
        // Return false in the case that we can't open it in the support blade.
        if (!SupportOverlay.config) {
            return false;
        }
        if (!SupportOverlay.isEnabled()) {
            return false;
        }

        var ieVersion = Writable.isIE();
        if (ieVersion && ieVersion < 12) {
            return false;
        }

        var openWhenReady = function () {
            if (SupportOverlay.isReady) {
                SupportOverlay.postMessage(SupportOverlay.$iframe[0].contentWindow, 'articleNavigate', {
                    href: url,
                    clearHistory: true
                });
            } else {
                setTimeout(openWhenReady, 50);
            }
        };
        openWhenReady();

        if (!SupportOverlay.showingHelp) {
            SupportOverlay.openSupportOverlay();
        }

        // Otherwise return true to indicate we've handled it and no further nav is needed by caller
        return true;
    };

    SupportOverlay.openChat = function () {
        var openWhenReady = function () {
            if (SupportOverlay.isReady) {
                SupportOverlay.postMessage(SupportOverlay.$iframe[0].contentWindow, 'activateChat');
            } else {
                setTimeout(openWhenReady, 50);
            }
        };
        openWhenReady();

        if (!SupportOverlay.showingHelp) {
            SupportOverlay.openSupportOverlay();
        }
        return false;
    };
})(jQuery);

var VideoModal = (function (my) {
    return my;
}(VideoModal || window.VideoModal || {}));

(function ($) {
    VideoModal.init = function (config) {
        VideoModal.config = config || {};
        VideoModal.text = VideoModal.config.text;
        VideoModal.players = {};
        VideoModal.resetValues();

        $(function () {
            VideoModal.$modal = $(document.body).find('#videoModal');

            VideoModal.$modal.on('click', '.modal-footer .btn-save', onSaveVideoClick);
            VideoModal.$modal.on('click', '.modal-footer .btn-cancel', onCancelClick);
            VideoModal.$modal.on('click', '.modal-header [data-mode-select]', onModeClick);
            VideoModal.$modal.on('click', '.option-body .btn.record', onRecordOptionClick);
            VideoModal.$modal.on('click', '.option-body .btn.upload', onUploadOptionClick);
            VideoModal.$modal.on('click', '.select-video', onSelectVideoClick);
            VideoModal.$modal.on('change', '.video-upload-form', onSelectedVideoChange);
        });

        VideoModal.postMessage = function (targetWindow, operation, properties) {
            var message = {
                source: "writableWeb",
                operation: operation
            };
            if (properties) {
                $.each(properties, function (name, value) {
                    message[name] = value;
                });
            }
            targetWindow.postMessage(message, "*");
        };
    };

    VideoModal.show = function (htmlContent, showData) {
        VideoModal.$modal.html(htmlContent);
        VideoModal.resetValues(showData);
        showOptions();
        VideoModal.$modal.modal({ show: true });

        VideoModal.$modal.find('.attach h4').text(VideoModal.showData.modalTitle ? VideoModal.showData.modalTitle : VideoModal.config.modalTitle);

        $videoPlayback = $('#videoPlayback');
        $videoPlayback.on('loadeddata', function (e) {
            var videoElement = e.target;
            var videoWidth = videoElement.videoWidth;
            var videoHeight = videoElement.videoHeight;
            if ((videoWidth % 16 === 0) && (videoHeight % 9 === 0) &&
                (videoWidth / 16 === videoHeight / 9)) {
                $videoPlayback.addClass('wide');
                $videoPlayback.removeClass('square');
            } else if (videoWidth === videoHeight) {
                $videoPlayback.addClass('square');
                $videoPlayback.removeClass('wide');
            } else {
                $videoPlayback.removeClass('square');
                $videoPlayback.removeClass('wide');
            }
        });

        // Code to make the modal draggable, taken from:
        // https://stackoverflow.com/questions/12571922/make-bootstrap-twitter-dialog-modal-draggable/51824269#51824269
        $(".modal-header").on("mousedown", function (mousedownEvt) {
            var $draggable = $(this);
            var x = mousedownEvt.pageX - $draggable.offset().left,
                y = mousedownEvt.pageY - $draggable.offset().top;
            $("body").on("mousemove.draggable", function (mousemoveEvt) {
                $draggable.closest(".modal-content").offset({
                    "left": mousemoveEvt.pageX - x,
                    "top": mousemoveEvt.pageY - y
                });
            });
            $("body").one("mouseup", function () {
                $("body").off("mousemove.draggable");
            });
            $draggable.closest(".modal").one("bs.modal.hide", function () {
                $("body").off("mousemove.draggable");
            });
        });
    };

    VideoModal.hide = function () {
        if (VideoModal.isInitializing) {
            VideoModal.isInitializing = false;
            bootbox.alert(VideoModal.text.video_modal_error_could_not_start);
        }

        VideoModal.$modal.find('audio').each(function (index, element) {
            element.pause();
        });
        VideoModal.$modal.find('video').each(function (index, element) {
            element.pause();
        });

        $('.spinner.video').hide();
        VideoModal.resetValues();
        VideoModal.$modal.modal('hide');
    };

    VideoModal.modal = function (options) {
        VideoModal.$modal.modal(options);
    };

    VideoModal.resetValues = function (showData) {
        var players = VideoModal.players;
        Object.keys(players).forEach(function (key) {
            var value = players[key];
            if (value !== null) {
                value.record().destroy();
            }
        });
        VideoModal.players = {
            video: null,
            audio: null
        };
        VideoModal.player = null;
        VideoModal.recordingInfo = null;
        VideoModal.recordedData = null;
        VideoModal.isRecordingStarted = false;
        VideoModal.isInitializing = false;
        VideoModal.initError = null;

        VideoModal.selectedFile = null;
        VideoModal.showData = showData || {};
    };

    VideoModal.getReferenceType = function () {
        var referenceType = VideoModal.config.referenceType;
        if (VideoModal.showData.referenceType) {
            referenceType = VideoModal.showData.referenceType;
        }
        return referenceType;
    };

    VideoModal.getReferenceId = function () {
        var referenceId = VideoModal.config.referenceId;
        if (VideoModal.showData.referenceId) {
            referenceId = VideoModal.showData.referenceId;
        }
        return referenceId;
    };

    var showOptions = function () {
        VideoModal.$modal.find('.modal-dialog').addClass('options');

        VideoModal.$modal.find('.modal-header .perspective-selector').hide();
        VideoModal.$modal.find('.modal-body .record-body').addClass('disabled');
        VideoModal.$modal.find('.modal-body .upload-body').addClass('disabled');
        VideoModal.$modal.find('.modal-footer .btn-save').hide();

        // We are having problems with getting the recording working in Safari
        // so for the time being, we are going to only allow the upload feature
        // within that browser
        if (Writable.isSafari()) {
            onUploadOptionClick();
        } else {
            switch (VideoModal.showData.autoSelectOption) {
                case 'record':
                    onRecordOptionClick();
                    break;
                case 'upload':
                    onUploadOptionClick();
                    break;
            }
        }
    }

    var onRecordOptionClick = function () {
        VideoModal.$modal.find('.modal-header .attach').hide();
        VideoModal.$modal.find('.modal-body .option-body').hide();
        VideoModal.$modal.find('.modal-header .perspective-selector').show();
        VideoModal.$modal.find('.modal-body .record-body').removeClass('disabled');
        VideoModal.$modal.find('.modal-footer .btn-save').show();
        VideoModal.$modal.find('.modal-dialog').removeClass('options');

        if (VideoModal.videoAllowed === undefined) {
            if (!canEditRecording()) {
                VideoModal.videoAllowed = false;
            } else {
                VideoModal.videoAllowed = true;
            }
        }

        if (VideoModal.currentMode === undefined) {
            if (VideoModal.videoAllowed)
                VideoModal.currentMode = "video";
            else
                VideoModal.currentMode = "audio";
        }

        activateMode(VideoModal.currentMode);
    }

    var canEditRecording = function () {
        if (Writable.isIE() || Writable.isSafari()) {
            return false;
        }
        return true;
    }

    var onUploadOptionClick = function (delayClick) {
        if (delayClick !== true && delayClick !== false) {
            delayClick = false;
        }
        VideoModal.$modal.find('.modal-header .perspective-selector').hide();
        VideoModal.$modal.find('.modal-header .attach').show();
        VideoModal.$modal.find('.modal-body .record-body').hide();
        VideoModal.$modal.find('.modal-body .option-body').hide();
        VideoModal.$modal.find('.modal-body .upload-body').removeClass('disabled');
        VideoModal.$modal.find('.modal-dialog').removeClass('options');
        VideoModal.$modal.find('.modal-dialog').addClass('upload');
        VideoModal.$modal.find('#videoPlayback').hide();
        VideoModal.$modal.find('#audioPlayback').hide();
        VideoModal.$modal.find('.modal-footer .btn-save').addClass('upload');
        // The option allows us to switch to this mode on recording init failures
        // and display a message before popping up the file selection
        if (delayClick && VideoModal.initError) {
            bootbox.alert({
                message: VideoModal.initError,
                animate: false,
                callback: function () {
                    VideoModal.initError = null;
                    setTimeout(function () { VideoModal.$modal.find('.modal-body .upload-body button.select-video').click(); }, 0);
                }
            });
        } else {
            setTimeout(function () { VideoModal.$modal.find('.modal-body .upload-body button.select-video').click(); }, 0);
        }
    }

    var onSelectVideoClick = function () {
        if (Writable.isMobile()) {
            VideoModal.$modal.modal('hide');
        }

        VideoModal.$modal.find('.video-upload-form input[type="file"]').click();
    };

    var onSelectedVideoChange = function (e) {
        if (Writable.isMobile()) {
            VideoModal.$modal.modal({ show: true });
        }

        var file = e.target.files[0];

        var maxFileSize = 80;
        if (file.size > (maxFileSize * 1024 * 1024)) {
            bootbox.alert(Writable.getLocalizedText(VideoModal.text.video_modal_max_size, maxFileSize));
            return;
        }
        var url = window.URL || window.webkitURL;

        if (file.type.includes('video/')) {
            var $other = VideoModal.$modal.find('#audioPlayback');
            $other.hide();
            var $playback = VideoModal.$modal.find('#videoPlayback');
            $playback.show();

            var fileURL = url.createObjectURL(file);
            $playback.attr('src', fileURL);
        } else if (file.type.includes('audio/')) {
            var $other = VideoModal.$modal.find('#videoPlayback');
            $other.hide();
            var $playback = VideoModal.$modal.find('#audioPlayback');
            $playback.show();

            var fileURL = url.createObjectURL(file);
            $playback.attr('src', fileURL);
        } else {
            bootbox.alert(VideoModal.text.video_modal_incorrect_file_type);
            return;
        }

        VideoModal.selectedFile = file;
        VideoModal.$modal.find('.upload-body .select-video').text(VideoModal.text.video_modal_change_file);

        VideoModal.$modal.find('.modal-footer .btn-save').removeClass('disabled');
        VideoModal.$modal.find('.modal-footer .btn-save').show();
    };

    var onModeClick = function (e) {
        var $selector = $(e.target).closest('[data-mode-select]');
        var mode = $selector.data('mode-select');

        if (mode === 'video' && !VideoModal.videoAllowed) {
            if (!canEditRecording()) {
                bootbox.alert(VideoModal.text.video_modal_unsupported_browser);
            } else {
                bootbox.confirm({
                    message: VideoModal.text.video_modal_device_reinit_option,
                    animate: false,
                    closeButton: false,
                    buttons: {
                        cancel: { label: VideoModal.text.shared_verb_cancel },
                        confirm: { label: VideoModal.text.shared_verb_confirm }
                    },
                    callback: function (result) {
                        if (result) {
                            VideoModal.videoAllowed = true;
                            onModeClick(e);
                        }
                    }
                });
            }
            return;
        }

        var currentMode = VideoModal.currentMode;

        // Check the current mode, if we are already there, no need to change
        if (currentMode === mode) {
            return;
        }

        // If we are currently recording, confirm stopping first
        if (VideoModal.player.record().isRecording() || VideoModal.recordedData !== null) {
            bootbox.confirm({
                message: VideoModal.text.video_modal_discard_current_recording,
                animate: false,
                closeButton: false,
                buttons: {
                    cancel: { label: VideoModal.text.shared_verb_cancel },
                    confirm: { label: VideoModal.text.shared_verb_confirm }
                },
                callback: function (result) {
                    if (result) {
                        stopRecording();
                        VideoModal.isRecordingStarted = false;
                        VideoModal.$modal.find('.modal-footer .btn-save').addClass('disabled');
                        activateMode(mode);
                    }
                }
            });
        } else {
            activateMode(mode);
        }
    };

    var activateMode = function (mode) {
        VideoModal.recordedData = null;
        VideoModal.$modal.find('.modal-header [data-mode-select]').removeClass('active');
        VideoModal.$modal.find('.modal-header [data-mode-select="' + mode + '"]').addClass('active');
        VideoModal.currentMode = mode;

        if (mode === 'video') {
            VideoModal.$modal.find('#videoRecorder').removeClass('disabled');
            VideoModal.$modal.find('#audioRecorder').addClass('disabled');
        } else if (mode === 'audio') {
            VideoModal.$modal.find('#audioRecorder').removeClass('disabled');
            VideoModal.$modal.find('#videoRecorder').addClass('disabled');
        }

        updateVideoOptions();

        onInitializeRecordingClick(mode);
    };

    var updateVideoOptions = function () {
        if (VideoModal.videoAllowed) {
            VideoModal.$modal.find('.modal-header [data-mode-select="video"]').removeClass('disabled');
        } else {
            VideoModal.$modal.find('.modal-header [data-mode-select="video"]').addClass('disabled');
        }
    };

    var createRecordingData = function (onSuccess, onError) {
        if (VideoModal.recordingInfo === null) {
            // Calls down to get the recording id
            $.post('/Home/CreateRecording')
                .done(function (data) {
                    VideoModal.recordingInfo = JSON.parse(data);
                    if (onSuccess !== undefined) {
                        onSuccess();
                    }
                })
                .fail(function (jqXHR) {
                    if (onError !== undefined) {
                        onError();
                    }
                });
        }
    };

    var stopRecording = function () {
        if (VideoModal.player !== null) {
            var recorder = VideoModal.player.record();
            if (recorder.isRecording()) {
                recorder.stop();
            }
            recorder.stopDevice();
            recorder.reset();
        }
    };

    var onInitializeRecordingClick = function (mode) {

        stopRecording();

        var recordingOptions = {
            audio: true,
            //debug: true,
            maxLength: 300 // Maximum length of 300 seconds currently. Not yet configurable.
        };

        var playerId = 'videoRecorder';
        if (mode === 'video') {
            /*
             * Based on the Codec support from the RecordRTC page, vp8 is the lowest common denominator,
             * but vp9 recording works in both Firefox and Chrome. vp8 doesn't record in Firefox.
             * Nothing seems to record in Edge / Safari. vp9 playback seems to work in Edge.
             * No playback works in Safari.
             */
            recordingOptions.videoMimeType = 'video/webm;codecs=vp9';
            recordingOptions.video = {
                // Attempting to reduce the size of the recorded file by constraining
                // the dimensions of the recording.
                width: 480,
                height: 360
            };
            recordingOptions.frameWidth = 480;
            recordingOptions.frameHeight = 360;
        } else {
            recordingOptions.video = false;
        }

        var pluginOptions = {
            record: recordingOptions
        };

        if (mode === 'audio') {
            playerId = 'audioRecorder';
            pluginOptions.wavesurfer = {
                backend: 'WebAudio',
                waveColor: '#36393b',
                progressColor: 'black',
                debug: true,
                cursorWidth: 1,
                hideScrollbar: true,
                plugins: [
                    // enable microphone plugin
                    WaveSurfer.microphone.create({
                        bufferSize: 4096,
                        numberOfInputChannels: 1,
                        numberOfOutputChannels: 1,
                        constraints: {
                            video: false,
                            audio: true
                        }
                    })
                ]
            };

            if (Writable.isSafari()) {
                if (window.MediaRecorder !== undefined) {
                    console.log('MediaRecorder appears to be present, but still applying audio recording workaround for Safari.');
                }
                // This is here to workaround a Safari recording issue, see:
                // https://github.com/collab-project/videojs-record/issues/295
                // for more info.
                recordingOptions.audioRecorderType = 'StereoAudioRecorder';
                recordingOptions.audioSampleRate = 44100;
                recordingOptions.audioBufferSize = 4096;
                recordingOptions.audioChannels = 2;
            } else {
                // This is in place to resolve a small pitch problem in the recorded audio
                recordingOptions.audioSampleRate = 48000;
                recordingOptions.audioBitRate = 128;

                // Disabling the lame encoder as we have post processing to convert to mp3 if it isn't already
                //recordingOptions.audioEngine = 'lamejs';
                //var blob = new Blob(["importScripts('" + new URL(VideoModal.config.lamejsWorker, document.baseURI).href + "', '" + new URL(VideoModal.config.lamejs, document.baseURI).href + "');"], { "type": 'application/javascript' });
                //var url = window.URL || window.webkitURL;
                //var blobUrl = url.createObjectURL(blob);
                //recordingOptions.audioWorkerURL = blobUrl;
            }
        }

        var options = {
            controls: true,
            width: 480,
            height: 360,
            plugins: pluginOptions
        };

        var player;
        if (VideoModal.players[mode] === null) {

            player = videojs(playerId, options, function () {
                // print version information at startup
                //var msg = 'Using video.js ' + videojs.VERSION +
                //    ' with videojs-record ' + videojs.getPluginVersion('record') +
                //    ', videojs-wavesurfer ' + videojs.getPluginVersion('wavesurfer') +
                //    ', wavesurfer.js ' + WaveSurfer.VERSION + ' and recordrtc ' +
                //    RecordRTC.version;
                //videojs.log(msg);
            });

            // Once we've started recording...
            player.on('startRecord', function () {
                VideoModal.isRecordingStarted = true;
                VideoModal.$modal.find('.modal-footer .btn-save').removeClass('disabled');
            });

            player.on('deviceReady', function () {
                try {
                    if (VideoModal.initError) {
                        bootbox.alert({
                            message: VideoModal.initError,
                            animate: false,
                            callback: function () {
                                VideoModal.initError = null;
                            }
                        });
                    }
                    var record = player.record();
                    if (record.mediaElement) {
                        var videoHeight = record.mediaElement.videoHeight;
                        var videoWidth = record.mediaElement.videoWidth;

                        var $videoInstructions = VideoModal.$modal.find('#videoRecorder');
                        if ((videoWidth % 16 === 0) && (videoHeight % 9 === 0) &&
                            (videoWidth / 16 === videoHeight / 9)) {
                            $videoInstructions.addClass('wide');
                            $videoInstructions.removeClass('square');
                        } else if (videoWidth === videoHeight) {
                            $videoInstructions.addClass('square');
                            $videoInstructions.removeClass('wide');
                        } else {
                            $videoInstructions.removeClass('square');
                            $videoInstructions.removeClass('wide');
                        }
                    }
                } catch (err) {
                    console.log('Could not check recording dimensions. Error:', err);
                }

            });

            // error handling
            player.on('deviceError', function () {
                var deviceError = player.deviceErrorCode;
                if (deviceError.message === "Permission denied") {
                    VideoModal.initError = VideoModal.text.video_modal_error_permission_denied;
                } else if (deviceError.message === "Requested device not found") {
                    VideoModal.initError = VideoModal.text.video_modal_error_device_not_found; // Checked
                } else if (deviceError.message === "Could not start video source") {
                    VideoModal.initError = VideoModal.text.video_modal_error_could_not_start; // Checked
                } else if (deviceError.message === "Failed to allocate videosource") { // Name: 'NotReadableError'
                    VideoModal.initError = VideoModal.text.video_modal_error_not_readable;
                } else {
                    VideoModal.initError = VideoModal.text.video_modal_error_general_init_failure;
                    console.error('Recording Device Error:', deviceError);
                }

                // Direct to the next attempt
                processDeviceError();
            });

            player.on('error', function (element, error) {
                console.error('Recording Error:', error);
            });

            // user completed recording and stream is available
            player.on('finishRecord', function () {
                if (VideoModal.currentMode === mode) {
                    // the blob object contains the recorded data that
                    // can be downloaded by the user, stored on server etc.
                    VideoModal.recordedData = player.recordedData;
                }
            });

            VideoModal.players[mode] = player;
        } else {
            player = VideoModal.players[mode];
        }
        VideoModal.player = player;

        VideoModal.isInitializing = true;
        initializeDevice(player, 0);
    };

    var processDeviceError = function () {
        if (VideoModal.currentMode === 'video') {
            VideoModal.initError = VideoModal.initError + ' ' + VideoModal.text.video_modal_error_attempt_audio_only;
            VideoModal.videoAllowed = false;
            activateMode('audio');
        } else {
            VideoModal.initError = VideoModal.initError + ' ' + VideoModal.text.video_modal_error_upload_fallback;
            onUploadOptionClick(true);
        }
    };

    var initializeDevice = function (player, counter) {
        // Initializing the device will activate the recorder without needing the
        // user to click a button. In the audio recording option specifically,
        // doing this too soon seems to throw an error about a 'surfer'
        // property being missing.
        setTimeout(function () {
            try {
                player.record().getDevice();
                VideoModal.isInitializing = false;
            } catch (ex) {
                console.log('Failed to obtain recording device:', ex);
                if (counter < 10) {
                    initializeDevice(player, counter + 1);
                } else {
                    if (VideoModal.isInitializing) {
                        VideoModal.initError = VideoModal.text.video_modal_error_could_not_start;
                        processDeviceError();
                    }
                    VideoModal.isInitializing = false;
                }
            }
        }, 100);
    };

    var onSaveVideoClick = function () {
        if (VideoModal.selectedFile === null && !VideoModal.isRecordingStarted) {
            return;
        }

        VideoModal.$modal.find('button.select-video').prop('disabled', true);

        var $savingMessage = VideoModal.$modal.find('.modal-footer .action');
        $savingMessage.show();
        var $footer = VideoModal.$modal.find('.modal-footer');
        $footer.addClass('active');

        $('.spinner.video').show();

        // Stop the recording when they say they want to save it
        if (VideoModal.selectedFile === null &&     // Only need to worry about this if we have no selected file...
            VideoModal.player.record().isRecording()) {
            VideoModal.player.record().stop();
            VideoModal.stoppedManually = true;
            // May need more than this little bump in the road, but for the short term...
            setTimeout(readyForStoring, 500);
        } else {
            VideoModal.stoppedManually = false;
            readyForStoring();
        }
    };

    var readyForStoring = function () {
        if (!VideoModal.recordingInfo) {
            createRecordingData(storeRecording,
                function () {
                    bootbox.alert(VideoModal.text.video_modal_error_storage_initialization);
                });
        } else {
            storeRecording();
        }
    };

    var storeRecording = function () {
        // Write it to the Url...
        var recordingInfo = VideoModal.recordingInfo;
        // First check to see if a file has been selected
        var recordedData = VideoModal.selectedFile;
        if (!recordedData) {
            // If not, get the recorded data
            var recordedData = VideoModal.recordedData;
            if (!recordedData) {
                // Fallback handling, as currently it seems that for Safari, the finishRecord event does not fire.
                recordedData = VideoModal.player.recordedData;
                VideoModal.recordedData = recordedData;
            }
            if (!recordedData && VideoModal.stoppedManually) {
                // If we don't have it yet, don't complete this process, and prompt them to try again.
                // This is likely due to a slow machine/app since we did wait for a half second if they stopped it
                // via our button. If they didn't stop it via our button, this should not be hit
                $('.spinner.video').hide();
                bootbox.alert(VideoModal.text.video_modal_error_stopping_recording);
            }
        }

        if (!recordedData) {
            bootbox.alert(VideoModal.text.video_modal_error_missing_recording_data);
            VideoModal.$modal.find('.modal-footer').removeClass('active');
            VideoModal.$modal.find('.modal-footer .action').hide();
            $('.spinner.video').hide();
            return;
        }

        var formData = new FormData();
        var fields = recordingInfo.fields;
        Object.keys(fields).forEach(function (value) {
            formData.append(value, fields[value]);
        });
        formData.append('Content-Type', recordedData.type);
        formData.append('X-Amz-Meta-Ref-Id', VideoModal.getReferenceId());
        formData.append('X-Amz-Meta-Ref-Type', VideoModal.getReferenceType());
        formData.append('X-Amz-Meta-User-Id', Writable.currentUserId);
        formData.append('file', recordedData);
        $.ajax({
            url: recordingInfo.url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function () {
                onWroteS3Recording(recordedData);
            },
            error: function (jqXHR) {
                bootbox.alert(VideoModal.text.video_modal_error_recording_storage);
            }
        });
    };

    var onWroteS3Recording = function (recordedData) {
        var url = '/' + VideoModal.getReferenceType() + '/Recording';
        var referenceId = VideoModal.getReferenceId();
        var properties = {
            contentType: recordedData.type,
            recordingId: VideoModal.recordingInfo.id,
            modelId: referenceId
        };
        $.post(url, JSON.stringify(properties))
            .done(function () {
                properties = {
                    id: VideoModal.recordingInfo.id,
                    url:  VideoModal.recordingInfo.s3Url,
                    contentType: recordedData.type,
                    modelId: referenceId
                };
                VideoModal.postMessage(window, 'setRecording', properties);
                try {
                    if (VideoModal.showData.onSuccess) {
                        VideoModal.showData.onSuccess(properties);
                    }
                } catch (error) {
                    console.log('error executing VideoModal onSuccess handler');
                    console.log(error);
                }
                VideoModal.hide();
            })
            .fail(function (jqXHR) {
                console.log('Failed to Link Data:', jqXHR);
            });
    };

    var onCancelClick = function () {
        if (VideoModal.player !== null) {
            // Don't look here for a selected file, this is specific to dropping a recording.
            if (VideoModal.isRecordingStarted || VideoModal.recordedData) {
                bootbox.confirm({
                    message: VideoModal.text.video_modal_discard_current_recording,
                    animate: false,
                    closeButton: false,
                    buttons: {
                        cancel: { label: VideoModal.text.shared_verb_cancel },
                        confirm: { label: VideoModal.text.shared_verb_confirm }
                    },
                    callback: function (result) {
                        if (result) {
                            VideoModal.hide();
                        }
                    }
                });
            } else {
                VideoModal.hide();
            }
        } else {
            VideoModal.hide();
        }
    };
})(jQuery);
